export default [
  {
    value: '01',
    label: '德城区',
    children: [
      {
        value: '01121',
        label: '德城区',
        children: [
          {
            value: '011212',
            label: '运河街道',
            children: [
              { value: '011211', label: '新铁西南社区' },
              { value: '0112121', label: '石家园社区' },
              { value: '0112122', label: '盐店口社区' },
              { value: '0112123', label: '杨家圈社区' },
              { value: '0112124', label: '魏庄社区' },
              { value: '0112125', label: '小庄社区' },
              { value: '0112126', label: '三里庄社区' },
              { value: '0112127', label: '天衢西路社区' },
              { value: '0112128', label: '陈庄社区' },
              { value: '0112129', label: '南陈庄村' },
              { value: '01121210', label: '芦庄村' },
              { value: '01121211', label: '屠屯村' },
              { value: '01121212', label: '西八里村' },
              { value: '01121213', label: '东八里村' },
              { value: '01121214', label: '钟辛庄村' },
              { value: '01121215', label: '李庄村' },
              { value: '01121216', label: '五一村' },
              { value: '01121217', label: '五二村' },
              { value: '01121218', label: '五三村' },
              { value: '01121219', label: '五四村' },
              { value: '01121220', label: '闫庄村' },
              { value: '01121221', label: '代官屯村' },
              { value: '01121222', label: '张庄村' }
            ]
          },
          {
            value: '011213',
            label: '新湖街道',
            children: [
              { value: '011212', label: '马庄社区' },
              { value: '01121323', label: '南关社区' },
              { value: '01121324', label: '南市社区' },
              { value: '01121325', label: '明湖社区' },
              { value: '01121326', label: '南营社区' },
              { value: '01121327', label: '青龙桥社区' },
              { value: '01121328', label: '状元府社区' },
              { value: '01121329', label: '城隍庙社区' },
              { value: '01121330', label: '尉署社区' },
              { value: '01121331', label: '丰华社区' },
              { value: '01121332', label: '顺城社区' },
              { value: '01121333', label: '罗南社区' },
              { value: '01121334', label: '胜利社区' },
              { value: '01121335', label: '康乐社区' },
              { value: '01121336', label: '北园社区' },
              { value: '01121337', label: '顺河社区' },
              { value: '01121338', label: '南龙社区' },
              { value: '01121339', label: '荣庄社区' },
              { value: '01121340', label: '北营社区' }
            ]
          },
          {
            value: '011214',
            label: '新华街道',
            children: [
              { value: '011213', label: '益德社区' },
              { value: '01121441', label: '辛庄社区' },
              { value: '01121442', label: '新河社区' },
              { value: '01121443', label: '振华社区' },
              { value: '01121444', label: '德苑社区' },
              { value: '01121445', label: '邹李社区' },
              { value: '01121446', label: '池口社区' },
              { value: '01121447', label: '陈公社区' },
              { value: '01121448', label: '新园村' },
              { value: '01121449', label: '双河村' },
              { value: '01121450', label: '魏庄村' },
              { value: '01121451', label: '三七村' },
              { value: '01121452', label: '城苑村' },
              { value: '01121453', label: '常兴村' },
              { value: '01121454', label: '李何村' },
              { value: '01121455', label: '于官屯村' },
              { value: '01121456', label: '于庄村' }
            ]
          },
          {
            value: '011215',
            label: '广川街道',
            children: [
              { value: '011214', label: '大东关社区' },
              { value: '01121557', label: '学府社区' },
              { value: '01121558', label: '岔河社区' },
              { value: '01121559', label: '长乐社区' },
              { value: '01121560', label: '永庆社区' },
              { value: '01121561', label: '东方家园社区' },
              { value: '01121562', label: '锦绣川社区' },
              { value: '01121563', label: '文化社区' },
              { value: '01121564', label: '祥和社区' },
              { value: '01121565', label: '小东关社区' },
              { value: '01121566', label: '堤岭社区' },
              { value: '01121567', label: '兴文社区' },
              { value: '01121568', label: '尚德社区' }
            ]
          },
          {
            value: '011216',
            label: '天衢街道',
            children: [
              { value: '011215', label: '肖何庄社区' },
              { value: '01121669', label: '罗庄社区' },
              { value: '01121670', label: '乾城社区' },
              { value: '01121671', label: '东长社区' },
              { value: '01121672', label: '西长社区' },
              { value: '01121673', label: '于赵社区' },
              { value: '01121674', label: '果园社区' },
              { value: '01121675', label: '罗家院社区' },
              { value: '01121676', label: '新四合社区' },
              { value: '01121677', label: '翟时社区' },
              { value: '01121678', label: '七里庄社区' },
              { value: '01121679', label: '贾庄社区' },
              { value: '01121680', label: '田龙社区' },
              { value: '01121681', label: '御园村' },
              { value: '01121682', label: '小屯村' }
            ]
          },
          {
            value: '011217',
            label: '黄河涯镇',
            children: [
              { value: '011216', label: '绿苑村' },
              { value: '01121783', label: '新纪庄村' },
              { value: '01121784', label: '耿李杨村' },
              { value: '01121785', label: '闸北村' },
              { value: '01121786', label: '王程寨村' },
              { value: '01121787', label: '前后李村' },
              { value: '01121788', label: '大史新村' },
              { value: '01121789', label: '东西屯村' },
              { value: '01121790', label: '馨秋村' },
              { value: '01121791', label: '桃园村' },
              { value: '01121792', label: '大于庄村' },
              { value: '01121793', label: '王村店村店' },
              { value: '01121794', label: '鑫源村' },
              { value: '01121795', label: '李家桥新村' },
              { value: '01121796', label: '三十里铺村' },
              { value: '01121797', label: '嘉和村' },
              { value: '01121798', label: '乐章村' },
              { value: '01121799', label: '廿里铺新村' },
              { value: '011217100', label: '四新村' },
              { value: '011217101', label: '漳卫新村' },
              { value: '011217102', label: '李家庙村' },
              { value: '011217103', label: '沙杨村' },
              { value: '011217104', label: '九村' },
              { value: '011217105', label: '焦庄村' },
              { value: '011217106', label: '王律村' },
              { value: '011217107', label: '黄河涯村' },
              { value: '011217108', label: '宋奇屯村' },
              { value: '011217109', label: '许庄村' },
              { value: '011217110', label: '滕庄村' }
            ]
          },
          {
            value: '011218',
            label: '二屯镇',
            children: [
              { value: '011217', label: '舜昕苑社区' },
              { value: '011218111', label: '索庄新村' },
              { value: '011218112', label: '贵和村' },
              { value: '011218113', label: '老渡口村' },
              { value: '011218114', label: '馨苑村' },
              { value: '011218115', label: '永和村' },
              { value: '011218116', label: '程何庄村' },
              { value: '011218117', label: '丰乐屯村' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '02',
    label: '陵城区',
    children: [
      {
        value: '02132',
        label: '陵城区',
        children: [
          {
            value: '021322',
            label: '丁庄镇',
            children: [
              { value: '021321', label: '大刘新村' },
              { value: '0213221', label: '丁庄新村' },
              { value: '0213222', label: '薛庄新村' },
              { value: '0213223', label: '郭叶新村' },
              { value: '0213224', label: '闫庄新村' },
              { value: '0213225', label: '董羊皮新村' },
              { value: '0213226', label: '赵家庙村' },
              { value: '0213227', label: '孙堤口村' },
              { value: '0213228', label: '许桥村' },
              { value: '0213229', label: '董屠新村' }
            ]
          },
          {
            value: '021323',
            label: '临齐街道',
            children: [
              { value: '021322', label: '西街社区' },
              { value: '02132310', label: '西关社区' },
              { value: '02132311', label: '东关社区' },
              { value: '02132312', label: '南街社区' },
              { value: '02132313', label: '万福社区' },
              { value: '02132314', label: '三和居社区' },
              { value: '02132315', label: '邓家村' },
              { value: '02132316', label: '丁家楼村' },
              { value: '02132317', label: '穆家村' },
              { value: '02132318', label: '叶家村' },
              { value: '02132319', label: '张集村' },
              { value: '02132320', label: '西曹村' },
              { value: '02132321', label: '杨堤口村' },
              { value: '02132322', label: '张石灰村' },
              { value: '02132323', label: '后张机村' },
              { value: '02132324', label: '前张机村' },
              { value: '02132325', label: '董家村' },
              { value: '02132326', label: '王定杆村' },
              { value: '02132327', label: '李圣传村' },
              { value: '02132328', label: '卜庄村' },
              { value: '02132329', label: '后王村' },
              { value: '02132330', label: '小赵家村' },
              { value: '02132331', label: '孙油坊村' },
              { value: '02132332', label: '盛庄村' },
              { value: '02132333', label: '杨家村' },
              { value: '02132334', label: '马庄村' },
              { value: '02132335', label: '孙来路村' },
              { value: '02132336', label: '前王村' },
              { value: '02132337', label: '蔺庄村' },
              { value: '02132338', label: '郭梨花村' },
              { value: '02132339', label: '东药庙村' },
              { value: '02132340', label: '前药庙村' },
              { value: '02132341', label: '崔冒头村' },
              { value: '02132342', label: '西药庙村' },
              { value: '02132343', label: '王落悟村' },
              { value: '02132344', label: '西才庙村' },
              { value: '02132345', label: '周家村' },
              { value: '02132346', label: '东才庙村' },
              { value: '02132347', label: '十里河村' },
              { value: '02132348', label: '宋光国村' },
              { value: '02132349', label: '前刘泮村' },
              { value: '02132350', label: '后刘泮村' },
              { value: '02132351', label: '宋家柳村' },
              { value: '02132352', label: '廉寨村' },
              { value: '02132353', label: '八里屯村' },
              { value: '02132354', label: '王还子村' },
              { value: '02132355', label: '王迪吉村' },
              { value: '02132356', label: '王芽子村' },
              { value: '02132357', label: '娄庙村' },
              { value: '02132358', label: '韩家村' },
              { value: '02132359', label: '刘大友村' },
              { value: '02132360', label: '李百都村' },
              { value: '02132361', label: '祁家盛村' },
              { value: '02132362', label: '郭家庙村' },
              { value: '02132363', label: '谷家村' },
              { value: '02132364', label: '陆家庙村' },
              { value: '02132365', label: '王海池村' },
              { value: '02132366', label: '大杨店村' },
              { value: '02132367', label: '孙花药村' },
              { value: '02132368', label: '赵家寨村' },
              { value: '02132369', label: '李七还村' },
              { value: '02132370', label: '赵油坊村' },
              { value: '02132371', label: '小杨店村' },
              { value: '02132372', label: '王强村' },
              { value: '02132373', label: '焦家村' },
              { value: '02132374', label: '刘家村' },
              { value: '02132375', label: '三里河村' },
              { value: '02132376', label: '张挑弓村' },
              { value: '02132377', label: '李冲天村' },
              { value: '02132378', label: '周丰台村' },
              { value: '02132379', label: '苑家村' },
              { value: '02132380', label: '王举人村' },
              { value: '02132381', label: '西崔村' },
              { value: '02132382', label: '候家村' },
              { value: '02132383', label: '西赵村' },
              { value: '02132384', label: '王景河村' },
              { value: '02132385', label: '贺家村' },
              { value: '02132386', label: '许王村' },
              { value: '02132387', label: '李马户村' },
              { value: '02132388', label: '孙克明村' },
              { value: '02132389', label: '冯家村' },
              { value: '02132390', label: '路寨村' },
              { value: '02132391', label: '凤凰树村' },
              { value: '02132392', label: '三龙候村' },
              { value: '02132393', label: '小王家村' },
              { value: '02132394', label: '孙铁匠村' },
              { value: '02132395', label: '凤凰街村' },
              { value: '02132396', label: '大吕村' },
              { value: '02132397', label: '刘载阁村' },
              { value: '02132398', label: '陈庄村' },
              { value: '02132399', label: '马家村' },
              { value: '021323100', label: '冯老村' },
              { value: '021323101', label: '斜庙村' },
              { value: '021323102', label: '杨致屯村' },
              { value: '021323103', label: '西高村' },
              { value: '021323104', label: '于道口村' },
              { value: '021323105', label: '八里宋村' },
              { value: '021323106', label: '张寺村' },
              { value: '021323107', label: '李车户村' },
              { value: '021323108', label: '马酒坊村' },
              { value: '021323109', label: '杨念佛村' },
              { value: '021323110', label: '王四衙村' },
              { value: '021323111', label: '南高村' },
              { value: '021323112', label: '钟官屯村' },
              { value: '021323113', label: '王二马村' },
              { value: '021323114', label: '曹都龙村' },
              { value: '021323115', label: '魏寨村' },
              { value: '021323116', label: '黑龙庙村' },
              { value: '021323117', label: '孙来仪村' },
              { value: '021323118', label: '赵先红村' },
              { value: '021323119', label: '张定杆村' },
              { value: '021323120', label: '彭家庙村' },
              { value: '021323121', label: '盐店村' },
              { value: '021323122', label: '赵奎武村' },
              { value: '021323123', label: '连七乡村' },
              { value: '021323124', label: '王架新村' },
              { value: '021323125', label: '李圣安新村' },
              { value: '021323126', label: '吴店新村' },
              { value: '021323127', label: '三圣家村' },
              { value: '021323128', label: '高官屯新村' },
              { value: '021323129', label: '丁寇二庄村' },
              { value: '021323130', label: '小吕家村' },
              { value: '021323131', label: '前后蒙新村' },
              { value: '021323132', label: '五李社区村' },
              { value: '021323133', label: '张举人村' }
            ]
          },
          {
            value: '021324',
            label: '前孙镇',
            children: [
              { value: '021323', label: '后刘村' },
              { value: '021324134', label: '楼子庄村' },
              { value: '021324135', label: '田庄村' },
              { value: '021324136', label: '翟庄村' },
              { value: '021324137', label: '李集村' },
              { value: '021324138', label: '赵庄村' },
              { value: '021324139', label: '安仁村' },
              { value: '021324140', label: '鲁庄村' },
              { value: '021324141', label: '王桂枝新村' },
              { value: '021324142', label: '单家村' },
              { value: '021324143', label: '东堂村' },
              { value: '021324144', label: '李庄村' },
              { value: '021324145', label: '柳庄村' },
              { value: '021324146', label: '宋庄村' },
              { value: '021324147', label: '坡于村' },
              { value: '021324148', label: '纪庄村' },
              { value: '021324149', label: '王雨村' },
              { value: '021324150', label: '郭庵村' },
              { value: '021324151', label: '三宝店村' },
              { value: '021324152', label: '盐头吕村' },
              { value: '021324153', label: '水王村' },
              { value: '021324154', label: '张架村' },
              { value: '021324155', label: '三金村' },
              { value: '021324156', label: '前刘新村' },
              { value: '021324157', label: '连五庄村' },
              { value: '021324158', label: '后孙常庄村' },
              { value: '021324159', label: '杨庄村' },
              { value: '021324160', label: '杨马村' },
              { value: '021324161', label: '马勺刘村' },
              { value: '021324162', label: '百万新村' },
              { value: '021324163', label: '高庄村' },
              { value: '021324164', label: '小辛新村' },
              { value: '021324165', label: '新白庄村' },
              { value: '021324166', label: '匙庄村' },
              { value: '021324167', label: '宋辛村' },
              { value: '021324168', label: '花马张村' },
              { value: '021324169', label: '许孙新村' },
              { value: '021324170', label: '新马庄村' },
              { value: '021324171', label: '前孙新四村' },
              { value: '021324172', label: '刘大楼村' },
              { value: '021324173', label: '新陈庄村' },
              { value: '021324174', label: '杜王新村' },
              { value: '021324175', label: '张万良新村' },
              { value: '021324176', label: '新商庄村' }
            ]
          },
          {
            value: '021325',
            label: '神头镇',
            children: [
              { value: '021324', label: '任集村' },
              { value: '021325177', label: '牟陈村' },
              { value: '021325178', label: '刁家村' },
              { value: '021325179', label: '郑杜村' },
              { value: '021325180', label: '靳家村' },
              { value: '021325181', label: '神头街村' },
              { value: '021325182', label: '隆兴村' },
              { value: '021325183', label: '祖屯村' },
              { value: '021325184', label: '孙禄还村' },
              { value: '021325185', label: '皂户杨村' },
              { value: '021325186', label: '房家村' },
              { value: '021325187', label: '月河村' },
              { value: '021325188', label: '南任村' },
              { value: '021325189', label: '东小李村' },
              { value: '021325190', label: '东姚村' },
              { value: '021325191', label: '小褚家村' },
              { value: '021325192', label: '徐店村' },
              { value: '021325193', label: '化店村' },
              { value: '021325194', label: '付店村' },
              { value: '021325195', label: '毛店村' },
              { value: '021325196', label: '前张店村' },
              { value: '021325197', label: '后张店村' },
              { value: '021325198', label: '西辛村' },
              { value: '021325199', label: '李家塔村' },
              { value: '021325200', label: '侯家村' },
              { value: '021325201', label: '后屯村' },
              { value: '021325202', label: '徐屯村' },
              { value: '021325203', label: '李屯村' },
              { value: '021325204', label: '矫屯村' },
              { value: '021325205', label: '前屯村' },
              { value: '021325206', label: '邓集村' },
              { value: '021325207', label: '前邓村' },
              { value: '021325208', label: '霍家村' },
              { value: '021325209', label: '东寨村' },
              { value: '021325210', label: '西寨村' },
              { value: '021325211', label: '南蔡村' },
              { value: '021325212', label: '圈刘村' },
              { value: '021325213', label: '孙家村' },
              { value: '021325214', label: '寨马张村' },
              { value: '021325215', label: '李五道村' },
              { value: '021325216', label: '史家村' },
              { value: '021325217', label: '张家村' },
              { value: '021325218', label: '西郭村' },
              { value: '021325219', label: '西小李村' },
              { value: '021325220', label: '老李家村' },
              { value: '021325221', label: '九合聚村' },
              { value: '021325222', label: '黄家村' },
              { value: '021325223', label: '东店村' },
              { value: '021325224', label: '西店村' },
              { value: '021325225', label: '马集村' },
              { value: '021325226', label: '后李村' },
              { value: '021325227', label: '东石庄村' },
              { value: '021325228', label: '迟家村' },
              { value: '021325229', label: '李家楼村' },
              { value: '021325230', label: '小庞家村' },
              { value: '021325231', label: '乔家村' },
              { value: '021325232', label: '刘向前村' },
              { value: '021325233', label: '赵庄村' },
              { value: '021325234', label: '杜刘村' },
              { value: '021325235', label: '前店村' },
              { value: '021325236', label: '刘东龙村' },
              { value: '021325237', label: '田老村' },
              { value: '021325238', label: '吴老村' },
              { value: '021325239', label: '刘白老村' },
              { value: '021325240', label: '马老村' },
              { value: '021325241', label: '东朱村' },
              { value: '021325242', label: '西朱村' },
              { value: '021325243', label: '东高村' },
              { value: '021325244', label: '西高村' },
              { value: '021325245', label: '肖文图村' },
              { value: '021325246', label: '南郭村' },
              { value: '021325247', label: '康家村' },
              { value: '021325248', label: '姜家村' },
              { value: '021325249', label: '祁屯村' }
            ]
          },
          {
            value: '021326',
            label: '安德街道',
            children: [
              { value: '021325', label: '紫云社区' },
              { value: '021326250', label: '智汇社区' },
              { value: '021326251', label: '芦坊社区' },
              { value: '021326252', label: '时楼村' },
              { value: '021326253', label: '雨淋店村' },
              { value: '021326254', label: '后王村' },
              { value: '021326255', label: '金庄村' },
              { value: '021326256', label: '孙家洼村' },
              { value: '021326257', label: '佟寨村' },
              { value: '021326258', label: '菜园村' },
              { value: '021326259', label: '董家阁村' },
              { value: '021326260', label: '宋堤口村' },
              { value: '021326261', label: '刘占新村' },
              { value: '021326262', label: '吕庄村' },
              { value: '021326263', label: '小刘村' },
              { value: '021326264', label: '桃刘村' }
            ]
          },
          {
            value: '021327',
            label: '徽王庄镇',
            children: [
              { value: '021326', label: '玫瑰园新村' },
              { value: '021327265', label: '东西刘村' },
              { value: '021327266', label: '孙世官村' },
              { value: '021327267', label: '薛庄新村' },
              { value: '021327268', label: '西角寨村' },
              { value: '021327269', label: '大官辛村' },
              { value: '021327270', label: '连五寨村' },
              { value: '021327271', label: '郭庄村' },
              { value: '021327272', label: '桥杨刘村村' },
              { value: '021327273', label: '西纸坊村' },
              { value: '021327274', label: '东纸坊村' },
              { value: '021327275', label: '庞家新村' },
              { value: '021327276', label: '王家屯村' },
              { value: '021327277', label: '徽王庄村' },
              { value: '021327278', label: '申家湾新村' },
              { value: '021327279', label: '松树宿村' },
              { value: '021327280', label: '西王集村' },
              { value: '021327281', label: '东王集村' },
              { value: '021327282', label: '张家新村' },
              { value: '021327283', label: '前王奇村' },
              { value: '021327284', label: '田庄村' },
              { value: '021327285', label: '小梁庄村' },
              { value: '021327286', label: '史庄村' },
              { value: '021327287', label: '卢庄村' },
              { value: '021327288', label: '后程村' },
              { value: '021327289', label: '邢李新村' },
              { value: '021327290', label: '高于新村' },
              { value: '021327291', label: '方庄村' },
              { value: '021327292', label: '郭杨新村' },
              { value: '021327293', label: '梅庄村' },
              { value: '021327294', label: '马庄村' },
              { value: '021327295', label: '官道胥村' },
              { value: '021327296', label: '白家村' },
              { value: '021327297', label: '郑家村' },
              { value: '021327298', label: '尹李村' },
              { value: '021327299', label: '小官辛村' },
              { value: '021327300', label: '陶家村' },
              { value: '021327301', label: '乔家村' },
              { value: '021327302', label: '前马村' },
              { value: '021327303', label: '靳庄村' },
              { value: '021327304', label: '王郑村' },
              { value: '021327305', label: '齐刘新村' },
              { value: '021327306', label: '宋齐新村' },
              { value: '021327307', label: '天明新村' },
              { value: '021327308', label: '杨钰石村' },
              { value: '021327309', label: '西王奇村' },
              { value: '021327310', label: '中东王奇村' },
              { value: '021327311', label: '吴庄村' },
              { value: '021327312', label: '孙杠村' },
              { value: '021327313', label: '解冯寨村' },
              { value: '021327314', label: '蒋赵张村' },
              { value: '021327315', label: '牛王村' },
              { value: '021327316', label: '红庙村' },
              { value: '021327317', label: '王解村' },
              { value: '021327318', label: '董窦村' },
              { value: '021327319', label: '官道孙村' },
              { value: '021327320', label: '后马村' },
              { value: '021327321', label: '朱家村' },
              { value: '021327322', label: '辛张新村' },
              { value: '021327323', label: '于家新村' },
              { value: '021327324', label: '边庄村' },
              { value: '021327325', label: '武家村' },
              { value: '021327326', label: '王淮庵村' },
              { value: '021327327', label: '张龙村' }
            ]
          },
          {
            value: '021328',
            label: '糜镇',
            children: [
              { value: '021327', label: '大河崖' },
              { value: '021328328', label: '东田' },
              { value: '021328329', label: '回孟村' },
              { value: '021328330', label: '齐老村' },
              { value: '021328331', label: '前李村' },
              { value: '021328332', label: '西刘村' },
              { value: '021328333', label: '张习桥村' },
              { value: '021328334', label: '中刘村' },
              { value: '021328335', label: '陈凡村' },
              { value: '021328336', label: '崔赵村' },
              { value: '021328337', label: '韩家村' },
              { value: '021328338', label: '金家村' },
              { value: '021328339', label: '梅家村' },
              { value: '021328340', label: '孙楼村' },
              { value: '021328341', label: '王举村' },
              { value: '021328342', label: '杨家村' },
              { value: '021328343', label: '大江村' },
              { value: '021328344', label: '候王村' },
              { value: '021328345', label: '前寺村' },
              { value: '021328346', label: '田冢村' },
              { value: '021328347', label: '湾头村' },
              { value: '021328348', label: '小孙村' },
              { value: '021328349', label: '张成吾村' },
              { value: '021328350', label: '朱官屯村' },
              { value: '021328351', label: '北于村' },
              { value: '021328352', label: '大陈村' },
              { value: '021328353', label: '大孙村' },
              { value: '021328354', label: '大田村' },
              { value: '021328355', label: '董河村' },
              { value: '021328356', label: '写字王村' },
              { value: '021328357', label: '修家村' },
              { value: '021328358', label: '徐阁村' },
              { value: '021328359', label: '东刘村' },
              { value: '021328360', label: '后陈村' },
              { value: '021328361', label: '后范桥村' },
              { value: '021328362', label: '后张社区' },
              { value: '021328363', label: '吉祥社区' },
              { value: '021328364', label: '解孟村' },
              { value: '021328365', label: '李官屯村' },
              { value: '021328366', label: '陶家村' },
              { value: '021328367', label: '湾头李村' },
              { value: '021328368', label: '温家村' },
              { value: '021328369', label: '吴龙村' },
              { value: '021328370', label: '新岳村' },
              { value: '021328371', label: '北马村' },
              { value: '021328372', label: '后李寺村' },
              { value: '021328373', label: '基山村' },
              { value: '021328374', label: '孟家村' },
              { value: '021328375', label: '前范桥' },
              { value: '021328376', label: '寺后刘村' },
              { value: '021328377', label: '西徐村' },
              { value: '021328378', label: '小王村' },
              { value: '021328379', label: '张寨村' },
              { value: '021328380', label: '大裴村' },
              { value: '021328381', label: '小官寨村' }
            ]
          },
          {
            value: '021329',
            label: '滋镇',
            children: [
              { value: '021328', label: '滋镇街' },
              { value: '021329382', label: '大王村' },
              { value: '021329383', label: '陈魏新村' },
              { value: '021329384', label: '杨洪村' },
              { value: '021329385', label: '宋杨村' },
              { value: '021329386', label: '展家村' },
              { value: '021329387', label: '王元梅村' },
              { value: '021329388', label: '小郭村' },
              { value: '021329389', label: '朱胥村' },
              { value: '021329390', label: '南许村' },
              { value: '021329391', label: '大郭村' },
              { value: '021329392', label: '大辛村' },
              { value: '021329393', label: '小付村' },
              { value: '021329394', label: '刘安村' },
              { value: '021329395', label: '六和新村' },
              { value: '021329396', label: '周张蔺村' },
              { value: '021329397', label: '程周村' },
              { value: '021329398', label: '孙保安村' },
              { value: '021329399', label: '西杨村' },
              { value: '021329400', label: '葛家村' },
              { value: '021329401', label: '苗家村' },
              { value: '021329402', label: '界刘村' },
              { value: '021329403', label: '孙明山村' },
              { value: '021329404', label: '前后许村' },
              { value: '021329405', label: '张李道村' },
              { value: '021329406', label: '沙王村' },
              { value: '021329407', label: '张龙村' },
              { value: '021329408', label: '小吕村' },
              { value: '021329409', label: '大于村' },
              { value: '021329410', label: '孙龙村' },
              { value: '021329411', label: '兴西村' },
              { value: '021329412', label: '三于村' },
              { value: '021329413', label: '兴中村' },
              { value: '021329414', label: '兴东村' },
              { value: '021329415', label: '盛家村' },
              { value: '021329416', label: '鸭子庄村' },
              { value: '021329417', label: '高家村' },
              { value: '021329418', label: '前仓村' },
              { value: '021329419', label: '后仓村' },
              { value: '021329420', label: '马家村' },
              { value: '021329421', label: '张庙村' },
              { value: '021329422', label: '赵屯村' },
              { value: '021329423', label: '三洄河村' }
            ]
          },
          {
            value: '0213210',
            label: '宋家镇',
            children: [
              { value: '021329', label: '祁家村' },
              { value: '0213210424', label: '白集村' },
              { value: '0213210425', label: '白家村' },
              { value: '0213210426', label: '北五村' },
              { value: '0213210427', label: '常麻村' },
              { value: '0213210428', label: '陈庙村' },
              { value: '0213210429', label: '崇兴街' },
              { value: '0213210430', label: '褚集村' },
              { value: '0213210431', label: '崔家村' },
              { value: '0213210432', label: '大陈村' },
              { value: '0213210433', label: '大苏村' },
              { value: '0213210434', label: '大王村' },
              { value: '0213210435', label: '大小李村' },
              { value: '0213210436', label: '单家村' },
              { value: '0213210437', label: '东蜂李村' },
              { value: '0213210438', label: '东孔村' },
              { value: '0213210439', label: '东屯' },
              { value: '0213210440', label: '东于河村' },
              { value: '0213210441', label: '段家村' },
              { value: '0213210442', label: '付家村' },
              { value: '0213210443', label: '高牛村' },
              { value: '0213210444', label: '管饭堂村' },
              { value: '0213210445', label: '郭家村' },
              { value: '0213210446', label: '河沟孙村' },
              { value: '0213210447', label: '黑黄村' },
              { value: '0213210448', label: '后蜂李村' },
              { value: '0213210449', label: '后姜村' },
              { value: '0213210450', label: '后刘村' },
              { value: '0213210451', label: '后马村' },
              { value: '0213210452', label: '厚家新村' },
              { value: '0213210453', label: '黄集新村' },
              { value: '0213210454', label: '吉古堂村' },
              { value: '0213210455', label: '康贾村' },
              { value: '0213210456', label: '李堂村' },
              { value: '0213210457', label: '梁家村' },
              { value: '0213210458', label: '刘李村' },
              { value: '0213210459', label: '刘林村' },
              { value: '0213210460', label: '麻坊村' },
              { value: '0213210461', label: '马桥村' },
              { value: '0213210462', label: '南五村' },
              { value: '0213210463', label: '聂家村' },
              { value: '0213210464', label: '前蜂李村' },
              { value: '0213210465', label: '前马村' },
              { value: '0213210466', label: '前屯' },
              { value: '0213210467', label: '曲集村' },
              { value: '0213210468', label: '阮家村' },
              { value: '0213210469', label: '石家村' },
              { value: '0213210470', label: '四合村' },
              { value: '0213210471', label: '宋家村' },
              { value: '0213210472', label: '孙家村' },
              { value: '0213210473', label: '太家村' },
              { value: '0213210474', label: '王集新村' },
              { value: '0213210475', label: '王庙村' },
              { value: '0213210476', label: '王寨村' },
              { value: '0213210477', label: '西孔村' },
              { value: '0213210478', label: '西屯' },
              { value: '0213210479', label: '西于河村' },
              { value: '0213210480', label: '小林村' },
              { value: '0213210481', label: '小刘村' },
              { value: '0213210482', label: '小王村' },
              { value: '0213210483', label: '小许村' },
              { value: '0213210484', label: '新楼村' },
              { value: '0213210485', label: '邢杨村' },
              { value: '0213210486', label: '徐坊村' },
              { value: '0213210487', label: '旭升屯' },
              { value: '0213210488', label: '闫家村' },
              { value: '0213210489', label: '杨庄村' },
              { value: '0213210490', label: '药王庙村' },
              { value: '0213210491', label: '袁家村' },
              { value: '0213210492', label: '袁毛村' },
              { value: '0213210493', label: '张集村' },
              { value: '0213210494', label: '张家村' },
              { value: '0213210495', label: '赵庄' },
              { value: '0213210496', label: '周坊村' },
              { value: '0213210497', label: '朱木匠村' }
            ]
          },
          {
            value: '0213211',
            label: '边临镇',
            children: [
              { value: '0213210', label: '西于架村' },
              { value: '0213211498', label: '东于架村' },
              { value: '0213211499', label: '王张村' },
              { value: '0213211500', label: '仁义店村' },
              { value: '0213211501', label: '桐城村' },
              { value: '0213211502', label: '华宋村' },
              { value: '0213211503', label: '华家屯架' },
              { value: '0213211504', label: '张庄' },
              { value: '0213211505', label: '边临镇街' },
              { value: '0213211506', label: '幸福街' },
              { value: '0213211507', label: '乔庄' },
              { value: '0213211508', label: '库庄' },
              { value: '0213211509', label: '陈庄' },
              { value: '0213211510', label: '郭庄' },
              { value: '0213211511', label: '马王村' },
              { value: '0213211512', label: '范桥' },
              { value: '0213211513', label: '陈五桥村' },
              { value: '0213211514', label: '孙闫村' },
              { value: '0213211515', label: '南北辛新村' },
              { value: '0213211516', label: '王连榜村' },
              { value: '0213211517', label: '史家庵村' },
              { value: '0213211518', label: '夏庄' },
              { value: '0213211519', label: '临城村' }
            ]
          },
          {
            value: '0213212',
            label: '郑家寨镇',
            children: [
              { value: '0213211', label: '金付寨村' },
              { value: '0213212520', label: '孙李二庄' },
              { value: '0213212521', label: '祝家新村' },
              { value: '0213212522', label: '久久新村' },
              { value: '0213212523', label: '四街新村' },
              { value: '0213212524', label: '明杨新村' },
              { value: '0213212525', label: '谷马纪家村' },
              { value: '0213212526', label: '李姚新村' },
              { value: '0213212527', label: '郑寨汪家村' },
              { value: '0213212528', label: '韩马村' },
              { value: '0213212529', label: '刘楼新村' },
              { value: '0213212530', label: '小王新村' },
              { value: '0213212531', label: '闫肖侯家村' },
              { value: '0213212532', label: '旭堂村' },
              { value: '0213212533', label: '大宗魏村' },
              { value: '0213212534', label: '碱穆刘村' },
              { value: '0213212535', label: '新城社区' },
              { value: '0213212536', label: '高士风村' },
              { value: '0213212537', label: '西祝村' },
              { value: '0213212538', label: '大付村' },
              { value: '0213212539', label: '前王寨村' },
              { value: '0213212540', label: '邓家村' },
              { value: '0213212541', label: '北小王村' },
              { value: '0213212542', label: '前秦村' },
              { value: '0213212543', label: '后秦村' },
              { value: '0213212544', label: '蛤蟆街村' },
              { value: '0213212545', label: '张高村' },
              { value: '0213212546', label: '帽张村' },
              { value: '0213212547', label: '洼李村' },
              { value: '0213212548', label: '大邱村' },
              { value: '0213212549', label: '王美韩村' },
              { value: '0213212550', label: '李金池村' },
              { value: '0213212551', label: '官道魏村' },
              { value: '0213212552', label: '张丰池村' },
              { value: '0213212553', label: '李廷辉村' },
              { value: '0213212554', label: '门徐村' },
              { value: '0213212555', label: '王庙村' },
              { value: '0213212556', label: '姜家村' },
              { value: '0213212557', label: '邰家村' },
              { value: '0213212558', label: '杨马村' },
              { value: '0213212559', label: '葛家村' },
              { value: '0213212560', label: '张二贩村' },
              { value: '0213212561', label: '大吴村' },
              { value: '0213212562', label: '李士若村' },
              { value: '0213212563', label: '圣刘村' },
              { value: '0213212564', label: '夏家村' },
              { value: '0213212565', label: '小周村' },
              { value: '0213212566', label: '栾家村' },
              { value: '0213212567', label: '后李村' },
              { value: '0213212568', label: '前侯村' },
              { value: '0213212569', label: '李五清村' },
              { value: '0213212570', label: '陈大亮村' }
            ]
          },
          {
            value: '0213213',
            label: '义渡口镇',
            children: [
              { value: '0213212', label: '义渡街村' },
              { value: '0213213571', label: '北小高新村' },
              { value: '0213213572', label: '后刘新村' },
              { value: '0213213573', label: '西许村' },
              { value: '0213213574', label: '辛安新村' },
              { value: '0213213575', label: '赵店新村' },
              { value: '0213213576', label: '王院村' },
              { value: '0213213577', label: '周家村' },
              { value: '0213213578', label: '解家村' },
              { value: '0213213579', label: '毛李村' },
              { value: '0213213580', label: '大李新村' },
              { value: '0213213581', label: '南赵新村' },
              { value: '0213213582', label: '常家村' },
              { value: '0213213583', label: '大付村' },
              { value: '0213213584', label: '李志拔村' },
              { value: '0213213585', label: '冷家村' },
              { value: '0213213586', label: '柴家村' },
              { value: '0213213587', label: '丁赵村' },
              { value: '0213213588', label: '潘家新村' },
              { value: '0213213589', label: '顺河新村' },
              { value: '0213213590', label: '付庵村' },
              { value: '0213213591', label: '赵庵村' },
              { value: '0213213592', label: '邵家村' },
              { value: '0213213593', label: '桑林村' },
              { value: '0213213594', label: '戊极刘村' },
              { value: '0213213595', label: '果园新村' },
              { value: '0213213596', label: '铁太新村' },
              { value: '0213213597', label: '马庙村' },
              { value: '0213213598', label: '张耐村' },
              { value: '0213213599', label: '庄科王村' },
              { value: '0213213600', label: '孙油坊村' },
              { value: '0213213601', label: '边家村' },
              { value: '0213213602', label: '小马村' },
              { value: '0213213603', label: '段店新村' },
              { value: '0213213604', label: '马颊河新村' },
              { value: '0213213605', label: '堤后刘村' },
              { value: '0213213606', label: '王士超村' },
              { value: '0213213607', label: '东小宿村' },
              { value: '0213213608', label: '小林村' },
              { value: '0213213609', label: '孙屯村' }
            ]
          },
          {
            value: '0213214',
            label: '于集乡',
            children: [
              { value: '0213213', label: '于集新村村' },
              { value: '0213214610', label: '田庄村' },
              { value: '0213214611', label: '谭庄村' },
              { value: '0213214612', label: '芦庄村' },
              { value: '0213214613', label: '三和鑫村' },
              { value: '0213214614', label: '王路寺村' },
              { value: '0213214615', label: '陈宝亮村' },
              { value: '0213214616', label: '张五开村' },
              { value: '0213214617', label: '孙国家村' },
              { value: '0213214618', label: '孟家村' },
              { value: '0213214619', label: '李七村' },
              { value: '0213214620', label: '李士公村' },
              { value: '0213214621', label: '任张村' },
              { value: '0213214622', label: '孟庙村' },
              { value: '0213214623', label: '崔楼村' },
              { value: '0213214624', label: '贺家村' },
              { value: '0213214625', label: '张武村' },
              { value: '0213214626', label: '孙屯村' },
              { value: '0213214627', label: '温家村' },
              { value: '0213214628', label: '东朱村' },
              { value: '0213214629', label: '西朱村' },
              { value: '0213214630', label: '唐屯村' },
              { value: '0213214631', label: '程屯村' },
              { value: '0213214632', label: '谢屯村' },
              { value: '0213214633', label: '宗庵村' },
              { value: '0213214634', label: '石淮村' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '03',
    label: '禹城市',
    children: [
      {
        value: '03143',
        label: '禹城市',
        children: [
          {
            value: '031432',
            label: '房寺镇',
            children: [
              { value: '031431', label: '众合村' },
              { value: '0314321', label: '幸福里村' },
              { value: '0314322', label: '连五庄村' },
              { value: '0314323', label: '大程新村' },
              { value: '0314324', label: '阳光村' },
              { value: '0314325', label: '姜园村' },
              { value: '0314326', label: '乐源村' },
              { value: '0314327', label: '戴梁村' },
              { value: '0314328', label: '北源村' },
              { value: '0314329', label: '善集村' },
              { value: '03143210', label: '石佛寺村' },
              { value: '03143211', label: '白塔寺村' },
              { value: '03143212', label: '三兴村' },
              { value: '03143213', label: '南连五庄村' },
              { value: '03143214', label: '荣和村' },
              { value: '03143215', label: '新星村' },
              { value: '03143216', label: '尚纸坊村' },
              { value: '03143217', label: '张靳明村' },
              { value: '03143218', label: '三合庄村' },
              { value: '03143219', label: '南集村' },
              { value: '03143220', label: '朱任冯村' },
              { value: '03143221', label: '双河村' },
              { value: '03143222', label: '石桥村' },
              { value: '03143223', label: '大李店村' },
              { value: '03143224', label: '莲花村' },
              { value: '03143225', label: '邢店村' },
              { value: '03143226', label: '韩王庄村' },
              { value: '03143227', label: '福全村' },
              { value: '03143228', label: '狮范村' },
              { value: '03143229', label: '镇东村' },
              { value: '03143230', label: '西湖新村' },
              { value: '03143231', label: '镇北新村' },
              { value: '03143232', label: '朝阳村' },
              { value: '03143233', label: '于马村' },
              { value: '03143234', label: '三和村' },
              { value: '03143235', label: '鲁夏村' },
              { value: '03143236', label: '团结村' },
              { value: '03143237', label: '三友村' },
              { value: '03143238', label: '崔李村' },
              { value: '03143239', label: '滨河村' },
              { value: '03143240', label: '陈寨村' },
              { value: '03143241', label: '张安村' },
              { value: '03143242', label: '宜居村' },
              { value: '03143243', label: '聂庄村' },
              { value: '03143244', label: '现代城村' },
              { value: '03143245', label: '茂徐村' },
              { value: '03143246', label: '房寺街村' },
              { value: '03143247', label: '楼子王村' },
              { value: '03143248', label: '红星前街村' },
              { value: '03143249', label: '红星后街村' }
            ]
          },
          {
            value: '031433',
            label: '莒镇',
            children: [
              { value: '031432', label: '李富苑屯村' },
              { value: '03143350', label: '车刘村' },
              { value: '03143351', label: '富康村' },
              { value: '03143352', label: '高庄村' },
              { value: '03143353', label: '焦王村' },
              { value: '03143354', label: '曲季村' },
              { value: '03143355', label: '新河村' },
              { value: '03143356', label: '梁家庄村' },
              { value: '03143357', label: '将军庙村' },
              { value: '03143358', label: '郭倪村' },
              { value: '03143359', label: '欧庄村' },
              { value: '03143360', label: '西袁庄村' },
              { value: '03143361', label: '棚赵村' },
              { value: '03143362', label: '后赵村' },
              { value: '03143363', label: '水寺村' },
              { value: '03143364', label: '白布高村' },
              { value: '03143365', label: '孙富荣村' },
              { value: '03143366', label: '鞠宋村' },
              { value: '03143367', label: '柳庄村' },
              { value: '03143368', label: '程庄村' },
              { value: '03143369', label: '徐庄村' },
              { value: '03143370', label: '兴隆村' },
              { value: '03143371', label: '孙塘村' },
              { value: '03143372', label: '丁寺村' },
              { value: '03143373', label: '邵庄村' },
              { value: '03143374', label: '李尚武村' },
              { value: '03143375', label: '后武村' },
              { value: '03143376', label: '张武村' },
              { value: '03143377', label: '大纸坊村' },
              { value: '03143378', label: '单庄村' },
              { value: '03143379', label: '梨杭村' },
              { value: '03143380', label: '李法桥村' },
              { value: '03143381', label: '王辛村' },
              { value: '03143382', label: '李庄村' },
              { value: '03143383', label: '莒镇村' },
              { value: '03143384', label: '香河村' },
              { value: '03143385', label: '小庄村' },
              { value: '03143386', label: '小郑村' },
              { value: '03143387', label: '神庄村' },
              { value: '03143388', label: '后刘村' },
              { value: '03143389', label: '梁庄村' },
              { value: '03143390', label: '楚庄村' },
              { value: '03143391', label: '宿楼村' },
              { value: '03143392', label: '邓庄村' },
              { value: '03143393', label: '小纸坊村' },
              { value: '03143394', label: '水牛李村' },
              { value: '03143395', label: '董屯村' },
              { value: '03143396', label: '贾庄村' },
              { value: '03143397', label: '大侯村' },
              { value: '03143398', label: '杨集村' },
              { value: '03143399', label: '前总司庙村' },
              { value: '031433100', label: '后总司庙村' },
              { value: '031433101', label: '张段村' },
              { value: '031433102', label: '兴农村' },
              { value: '031433103', label: '徐桥村' },
              { value: '031433104', label: '白庄村' },
              { value: '031433105', label: '芦堂村' },
              { value: '031433106', label: '别屯村' },
              { value: '031433107', label: '徐集村' },
              { value: '031433108', label: '姜庄村' },
              { value: '031433109', label: '前刘村' },
              { value: '031433110', label: '付堂村' },
              { value: '031433111', label: '付王村' },
              { value: '031433112', label: '皮孙村' },
              { value: '031433113', label: '小樊村' },
              { value: '031433114', label: '季庄村' },
              { value: '031433115', label: '金李村' },
              { value: '031433116', label: '牛王村' },
              { value: '031433117', label: '齐集村' },
              { value: '031433118', label: '马庄村' },
              { value: '031433119', label: '袁庄村' },
              { value: '031433120', label: '碱李村' },
              { value: '031433121', label: '大郑村' },
              { value: '031433122', label: '司庄村' },
              { value: '031433123', label: '郭牛村' },
              { value: '031433124', label: '小邵村' },
              { value: '031433125', label: '靛王村' },
              { value: '031433126', label: '莒东村' }
            ]
          },
          {
            value: '031434',
            label: '梁家镇',
            children: [
              { value: '031433', label: '北城村' },
              { value: '031434127', label: '梁庄村' },
              { value: '031434128', label: '崔庄村' },
              { value: '031434129', label: '王化屯' },
              { value: '031434130', label: '大纪村' },
              { value: '031434131', label: '邢寨新村' },
              { value: '031434132', label: '红庙村' },
              { value: '031434133', label: '南陈村' },
              { value: '031434134', label: '辛庄村' },
              { value: '031434135', label: '武庄村' },
              { value: '031434136', label: '东孙村' },
              { value: '031434137', label: '满庄村' },
              { value: '031434138', label: '褚堂村' },
              { value: '031434139', label: '杨官营村' },
              { value: '031434140', label: '窦庄村' },
              { value: '031434141', label: '梁赵村' },
              { value: '031434142', label: '西店村' },
              { value: '031434143', label: '东店村' },
              { value: '031434144', label: '立新村' },
              { value: '031434145', label: '唐屯村' },
              { value: '031434146', label: '董程村' },
              { value: '031434147', label: '桂庄村' },
              { value: '031434148', label: '张老虎村' },
              { value: '031434149', label: '麻庄村' },
              { value: '031434150', label: '尼庄村' },
              { value: '031434151', label: '田辛村' },
              { value: '031434152', label: '徐郭村' },
              { value: '031434153', label: '西黄召村' },
              { value: '031434154', label: '夏庄村' },
              { value: '031434155', label: '来凤村' },
              { value: '031434156', label: '方杜村' },
              { value: '031434157', label: '小纪村' },
              { value: '031434158', label: '木槿王村' },
              { value: '031434159', label: '王义村' },
              { value: '031434160', label: '齐刘村' },
              { value: '031434161', label: '牛和村' },
              { value: '031434162', label: '双屯府村' },
              { value: '031434163', label: '大杨村' },
              { value: '031434164', label: '西小张村' },
              { value: '031434165', label: '范庙村' },
              { value: '031434166', label: '西吕洼村' },
              { value: '031434167', label: '东吕洼村' },
              { value: '031434168', label: '张邦村' },
              { value: '031434169', label: '郑庄村' },
              { value: '031434170', label: '英王村' },
              { value: '031434171', label: '王杨村' },
              { value: '031434172', label: '三友村' },
              { value: '031434173', label: '国北村' },
              { value: '031434174', label: '孙坊村' },
              { value: '031434175', label: '贾庄村' },
              { value: '031434176', label: '双庙屯村' },
              { value: '031434177', label: '马家庙村' },
              { value: '031434178', label: '大杜村' },
              { value: '031434179', label: '大小王村' },
              { value: '031434180', label: '王院村' },
              { value: '031434181', label: '吴院村' },
              { value: '031434182', label: '孙院村' },
              { value: '031434183', label: '明湖寨村' },
              { value: '031434184', label: '碱王村' },
              { value: '031434185', label: '毛子张村' },
              { value: '031434186', label: '长里孙村' }
            ]
          },
          {
            value: '031435',
            label: '伦镇',
            children: [
              { value: '031434', label: '袁营新村' },
              { value: '031435187', label: '兴和新村' },
              { value: '031435188', label: '凤吾新村' },
              { value: '031435189', label: '李庚崔村' },
              { value: '031435190', label: '孙张新村' },
              { value: '031435191', label: '赵庄新村' },
              { value: '031435192', label: '孙李村' },
              { value: '031435193', label: '水坡村' },
              { value: '031435194', label: '于庄新村' },
              { value: '031435195', label: '台楼村' },
              { value: '031435196', label: '禚屯村' },
              { value: '031435197', label: '郑庄村' },
              { value: '031435198', label: '韩庄村' },
              { value: '031435199', label: '薛后村' },
              { value: '031435200', label: '前簸箕营村' },
              { value: '031435201', label: '唐王村' },
              { value: '031435202', label: '毛庄村' },
              { value: '031435203', label: '城东村' },
              { value: '031435204', label: '温屯村' },
              { value: '031435205', label: '小坡村' },
              { value: '031435206', label: '北街村' },
              { value: '031435207', label: '小庄村' },
              { value: '031435208', label: '官庄村' },
              { value: '031435209', label: '宋寨子村' },
              { value: '031435210', label: '张架村' },
              { value: '031435211', label: '李茂芝村' },
              { value: '031435212', label: '贾庄村' },
              { value: '031435213', label: '五龙寺韩庄村' },
              { value: '031435214', label: '王水村' },
              { value: '031435215', label: '张水村' },
              { value: '031435216', label: '义合窦村' },
              { value: '031435217', label: '戎庄村' },
              { value: '031435218', label: '焦寨子村' },
              { value: '031435219', label: '郎屯村' },
              { value: '031435220', label: '付庄村' },
              { value: '031435221', label: '小孙村' },
              { value: '031435222', label: '莲红村' },
              { value: '031435223', label: '北选村' },
              { value: '031435224', label: '南选村' },
              { value: '031435225', label: '生张村' },
              { value: '031435226', label: '梁庄村' },
              { value: '031435227', label: '东杨村' },
              { value: '031435228', label: '安庄村' },
              { value: '031435229', label: '丁庄村' },
              { value: '031435230', label: '杜集村' },
              { value: '031435231', label: '大耿村' },
              { value: '031435232', label: '城西村' },
              { value: '031435233', label: '南杨村' },
              { value: '031435234', label: '西街村' },
              { value: '031435235', label: '宋庄村' },
              { value: '031435236', label: '燕东村' },
              { value: '031435237', label: '岩西村' },
              { value: '031435238', label: '后簸箕营村' },
              { value: '031435239', label: '水坡杨村' },
              { value: '031435240', label: '刘庄村' },
              { value: '031435241', label: '大孙村' },
              { value: '031435242', label: '太合村' },
              { value: '031435243', label: '河南宋村' },
              { value: '031435244', label: '沈屯村' },
              { value: '031435245', label: '岱屯村' },
              { value: '031435246', label: '南窦村' },
              { value: '031435247', label: '薛前村' },
              { value: '031435248', label: '军屯村' },
              { value: '031435249', label: '堂子街村' },
              { value: '031435250', label: '红庙李村' },
              { value: '031435251', label: '董庄村' },
              { value: '031435252', label: '东街村' },
              { value: '031435253', label: '陈栋村' },
              { value: '031435254', label: '河口李村' },
              { value: '031435255', label: '朱庄村' }
            ]
          },
          {
            value: '031436',
            label: '市中街道',
            children: [
              { value: '031435', label: '老城北街' },
              { value: '031436256', label: '老城西街（县级）' },
              { value: '031436257', label: '寺后李（县级）' },
              { value: '031436258', label: '张王' },
              { value: '031436259', label: '刘少胡' },
              { value: '031436260', label: '白衣堂' },
              { value: '031436261', label: '杨河套' },
              { value: '031436262', label: '万庄' },
              { value: '031436263', label: '任庄' },
              { value: '031436264', label: '罗庄' },
              { value: '031436265', label: '霍庄' },
              { value: '031436266', label: '石庄' },
              { value: '031436267', label: '西军张' },
              { value: '031436268', label: '西李全社区' },
              { value: '031436269', label: '月牙湾' },
              { value: '031436270', label: '北环村' },
              { value: '031436271', label: '城角韩社区' },
              { value: '031436272', label: '北七里' },
              { value: '031436273', label: '薛庙' },
              { value: '031436274', label: '魏寨' },
              { value: '031436275', label: '菜园' },
              { value: '031436276', label: '迎宾新村' },
              { value: '031436277', label: '崇德新村' },
              { value: '031436278', label: '鑫泉新村' },
              { value: '031436279', label: '尚德新村' },
              { value: '031436280', label: '大刘' },
              { value: '031436281', label: '杨桥新村' },
              { value: '031436282', label: '富华新村' },
              { value: '031436283', label: '火盆李' },
              { value: '031436284', label: '戚家桥' },
              { value: '031436285', label: '草寺' },
              { value: '031436286', label: '高寨' },
              { value: '031436287', label: '韩庄' },
              { value: '031436288', label: '张道口' },
              { value: '031436289', label: '马店' },
              { value: '031436290', label: '红旗社区' },
              {
                value: '031436291',
                label: '路口村'
              },
              { value: '031436292', label: '马庄' },
              { value: '031436293', label: '秦老庄' },
              { value: '031436294', label: '后寨子' },
              { value: '031436295', label: '前寨子' },
              { value: '031436296', label: '大纸坊' },
              { value: '031436297', label: '先锋村' },
              { value: '031436298', label: '站北社区' },
              { value: '031436299', label: '老城东街（县级）' },
              { value: '031436300', label: '老城南街（县级）' },
              { value: '031436301', label: '花园新村' },
              { value: '031436302', label: '泺清社区' },
              { value: '031436303', label: '群贤居花园社区' },
              { value: '031436304', label: '新湖社区' },
              { value: '031436305', label: '大禹社区' },
              { value: '031436306', label: '迎宾社区' },
              { value: '031436307', label: '糖城社区' },
              { value: '031436308', label: '汉槐社区' },
              { value: '031436309', label: '鬲津社区' }
            ]
          },
          {
            value: '031437',
            label: '辛店镇',
            children: [
              { value: '031436', label: '邹庄新村' },
              { value: '031437310', label: '大秦新村' },
              { value: '031437311', label: '王寨新村' },
              { value: '031437312', label: '周栾新村' },
              { value: '031437313', label: '辛西新村' },
              { value: '031437314', label: '窦马张村' },
              { value: '031437315', label: '董柳新村' },
              { value: '031437316', label: '辛连心村' },
              { value: '031437317', label: '永安新村' },
              { value: '031437318', label: '丁刘袁村' },
              { value: '031437319', label: '幸福新村' },
              { value: '031437320', label: '东站新村' },
              { value: '031437321', label: '苏梁河村' },
              { value: '031437322', label: '刘甲吴村' },
              { value: '031437323', label: '陈张新村' },
              { value: '031437324', label: '商李杨村' },
              { value: '031437325', label: '郭庄新村' },
              { value: '031437326', label: '三河新村' },
              { value: '031437327', label: '王夏新村' },
              { value: '031437328', label: '张西尧村' },
              { value: '031437329', label: '前刘村' },
              { value: '031437330', label: '西董村' },
              { value: '031437331', label: '双庙村' },
              { value: '031437332', label: '王山村' },
              { value: '031437333', label: '王石村' },
              { value: '031437334', label: '常刘村' },
              { value: '031437335', label: '刁庄村' },
              { value: '031437336', label: '官庄村' },
              { value: '031437337', label: '良合村' },
              { value: '031437338', label: '南田村' },
              { value: '031437339', label: '小崔村' },
              { value: '031437340', label: '辛店街村' },
              { value: '031437341', label: '姜牌寨村' },
              { value: '031437342', label: '西苑村' },
              { value: '031437343', label: '贾庄村' },
              { value: '031437344', label: '修庄村' },
              { value: '031437345', label: '牟庄村' },
              { value: '031437346', label: '陈忠村' },
              { value: '031437347', label: '沙河辛村' },
              { value: '031437348', label: '刘寨村（县级）' },
              { value: '031437349', label: '张集村（市级）' },
              { value: '031437350', label: '陈楼村（市级）' },
              { value: '031437351', label: '刘景吴村（市级）' },
              { value: '031437352', label: '李佰辛村（市级）' },
              { value: '031437353', label: '田楼村（县级）' },
              { value: '031437354', label: '大李村（县级）' },
              { value: '031437355', label: '侯庄村（市级）' },
              { value: '031437356', label: '崔楼村（市级）' },
              { value: '031437357', label: '张寺村（市级）' }
            ]
          },
          {
            value: '031438',
            label: '安仁镇',
            children: [
              { value: '031437', label: '安兴村' },
              { value: '031438358', label: '安楼村' },
              { value: '031438359', label: '两河村' },
              { value: '031438360', label: '庞家庄村' },
              { value: '031438361', label: '合福新村' },
              { value: '031438362', label: '安北村' },
              { value: '031438363', label: '贾寺村' },
              { value: '031438364', label: '孙庄村' },
              { value: '031438365', label: '齐庄村' },
              { value: '031438366', label: '王子付村' },
              { value: '031438367', label: '马庄村' },
              { value: '031438368', label: '大付村' },
              { value: '031438369', label: '赵集东街村' },
              { value: '031438370', label: '赵集西街村' },
              { value: '031438371', label: '颜坊村' },
              { value: '031438372', label: '大杨村' },
              { value: '031438373', label: '大卢村' },
              { value: '031438374', label: '高老吾村' },
              { value: '031438375', label: '孟庄村' },
              { value: '031438376', label: '韩庄村' },
              { value: '031438377', label: '魏栗村' },
              { value: '031438378', label: '武庄村' },
              { value: '031438379', label: '殷庄村' },
              { value: '031438380', label: '冯旺村' },
              { value: '031438381', label: '刁杨郭村' },
              { value: '031438382', label: '南街村' },
              { value: '031438383', label: '刘庄村' },
              { value: '031438384', label: '赵庄村' },
              { value: '031438385', label: '药王村' },
              { value: '031438386', label: '涳河崖村' },
              { value: '031438387', label: '张李店村' },
              { value: '031438388', label: '陈庄村' },
              { value: '031438389', label: '东西街村' },
              { value: '031438390', label: '齐尧村' }
            ]
          },
          {
            value: '031439',
            label: '张庄镇',
            children: [
              { value: '031438', label: '北丘新村' },
              { value: '031439391', label: '幸福新村' },
              { value: '031439392', label: '陆合新村' },
              { value: '031439393', label: '新合村' },
              { value: '031439394', label: '焦胡新村' },
              { value: '031439395', label: '大洼王村' },
              { value: '031439396', label: '孙薛新村' },
              { value: '031439397', label: '五合新村' },
              { value: '031439398', label: '黄林庄' },
              { value: '031439399', label: '洼里何新村' },
              { value: '031439400', label: '振兴新村' },
              { value: '031439401', label: '北杨村' },
              { value: '031439402', label: '北邢村' },
              { value: '031439403', label: '毕庄村' },
              { value: '031439404', label: '蔡窑村' },
              { value: '031439405', label: '大段村' },
              { value: '031439406', label: '大油坊村' },
              { value: '031439407', label: '董庄村' },
              { value: '031439408', label: '冯晏村' },
              { value: '031439409', label: '郝胡村' },
              { value: '031439410', label: '后王村' },
              { value: '031439411', label: '姜庄村' },
              { value: '031439412', label: '黎济寨村' },
              { value: '031439413', label: '李元庄村' },
              { value: '031439414', label: '琉璃庙村' },
              { value: '031439415', label: '马庄村' },
              { value: '031439416', label: '帽张村' },
              { value: '031439417', label: '前王村' },
              { value: '031439418', label: '三庙村' },
              { value: '031439419', label: '小洼王村' },
              { value: '031439420', label: '小油坊村' },
              { value: '031439421', label: '张庄村' },
              { value: '031439422', label: '周奎禹村' },
              { value: '031439423', label: '周庄村' },
              { value: '031439424', label: '宗集村' }
            ]
          },
          {
            value: '0314310',
            label: '禹兴街道',
            children: [
              { value: '031439', label: '古城社区' },
              { value: '0314310425', label: '站南社区' },
              { value: '0314310426', label: '李义张村' },
              { value: '0314310427', label: '果林村' },
              { value: '0314310428', label: '孙庄村' },
              { value: '0314310429', label: '闫庄村' },
              { value: '0314310430', label: '石屯赵庄村' },
              { value: '0314310431', label: '窦庄村' },
              { value: '0314310432', label: '石屯于庄村' },
              { value: '0314310433', label: '红庙村' },
              { value: '0314310434', label: '石屯新村' },
              { value: '0314310435', label: '祁庄村' },
              { value: '0314310436', label: '张陈村' },
              { value: '0314310437', label: '尚务头村' },
              { value: '0314310438', label: '石屯南街' },
              { value: '0314310439', label: '前马屯村' },
              { value: '0314310440', label: '后马屯村' },
              { value: '0314310441', label: '刘少文村' },
              { value: '0314310442', label: '石屯北街' },
              { value: '0314310443', label: '南陈村' },
              { value: '0314310444', label: '辛安村' },
              { value: '0314310445', label: '冢子村' },
              { value: '0314310446', label: '唐庄村' },
              { value: '0314310447', label: '黄店村' },
              { value: '0314310448', label: '廿里堡于庄村' },
              { value: '0314310449', label: '刘庄村' },
              { value: '0314310450', label: '王寺村' },
              { value: '0314310451', label: '张安村' },
              { value: '0314310452', label: '百合新村' },
              { value: '0314310453', label: '杨庄村' },
              { value: '0314310454', label: '打渔张村' },
              { value: '0314310455', label: '秦店子村' },
              { value: '0314310456', label: '杨城子村' },
              { value: '0314310457', label: '沈庄村' },
              { value: '0314310458', label: '王庄村' },
              { value: '0314310459', label: '维新街村' },
              { value: '0314310460', label: '兴华巷村' },
              { value: '0314310461', label: '小韩庄村' },
              { value: '0314310462', label: '夏季村' },
              { value: '0314310463', label: '天宫院村' },
              { value: '0314310464', label: '千户屯村' },
              { value: '0314310465', label: '田贝石村' },
              { value: '0314310466', label: '四兴村' },
              { value: '0314310467', label: '要邢村' },
              { value: '0314310468', label: '李鑫村' },
              { value: '0314310469', label: '张卢村' },
              { value: '0314310470', label: '郭辛村' },
              { value: '0314310471', label: '新冯村' },
              { value: '0314310472', label: '屯子村' },
              { value: '0314310473', label: '廿里堡北街村' },
              { value: '0314310474', label: '廿里堡西街村' },
              { value: '0314310475', label: '廿里堡东街村' },
              { value: '0314310476', label: '解合村' },
              { value: '0314310477', label: '何庄村' },
              { value: '0314310478', label: '肖寺新村' }
            ]
          },
          {
            value: '0314311',
            label: '辛寨镇',
            children: [
              { value: '0314310', label: '辛寨村' },
              { value: '0314311479', label: '魏寨子村' },
              { value: '0314311480', label: '油坊村' },
              { value: '0314311481', label: '质金赵村' },
              { value: '0314311482', label: '马官屯村' },
              { value: '0314311483', label: '刘方珠村' },
              { value: '0314311484', label: '鑫家园村' },
              { value: '0314311485', label: '锦绣村' },
              { value: '0314311486', label: '家旺村' },
              { value: '0314311487', label: '前大刘村' },
              { value: '0314311488', label: '后大刘村' },
              { value: '0314311489', label: '向前村' },
              { value: '0314311490', label: '小刘村' },
              { value: '0314311491', label: '庵任村' },
              { value: '0314311492', label: '徐各李村' },
              { value: '0314311493', label: '梁河新村' },
              { value: '0314311494', label: '永进村' },
              { value: '0314311495', label: '振兴村' },
              { value: '0314311496', label: '沈堂村' },
              { value: '0314311497', label: '红星村' },
              { value: '0314311498', label: '堂李村' },
              { value: '0314311499', label: '新和村' },
              { value: '0314311500', label: '安庄村' },
              { value: '0314311501', label: '陈寺村' },
              { value: '0314311502', label: '复兴村' },
              { value: '0314311503', label: '四友村' },
              { value: '0314311504', label: '友谊村' }
            ]
          },
          {
            value: '0314312',
            label: '十里望回族镇',
            children: [
              { value: '0314311', label: '禹迹社区' },
              { value: '0314312505', label: '禹泽社区' },
              { value: '0314312506', label: '韩寨新村' },
              { value: '0314312507', label: '高庄' },
              { value: '0314312508', label: '金庄' },
              { value: '0314312509', label: '小王楼' },
              { value: '0314312510', label: '大白' },
              { value: '0314312511', label: '小白' },
              { value: '0314312512', label: '黄桥新村' },
              { value: '0314312513', label: '十里望新村' },
              { value: '0314312514', label: '宋庄' },
              { value: '0314312515', label: '孙西' },
              { value: '0314312516', label: '万庄' },
              { value: '0314312517', label: '范庄' },
              { value: '0314312518', label: '后河' },
              { value: '0314312519', label: '南马' },
              { value: '0314312520', label: '汇侨新村' },
              { value: '0314312521', label: '骇河新村' },
              { value: '0314312522', label: '前河' },
              { value: '0314312523', label: '馨和村' },
              { value: '0314312524', label: '牛徐村' },
              { value: '0314312525', label: '桥西村' },
              { value: '0314312526', label: '郝高屯村' },
              { value: '0314312527', label: '郭宗冯村' },
              { value: '0314312528', label: '程杨村' },
              { value: '0314312529', label: '御桥新村' },
              { value: '0314312530', label: '南营新村' },
              { value: '0314312531', label: '张王芦' },
              { value: '0314312532', label: '方庄' },
              { value: '0314312533', label: '孟楼' },
              { value: '0314312534', label: '刘庄' },
              { value: '0314312535', label: '店子' },
              { value: '0314312536', label: '张庄' },
              { value: '0314312537', label: '尹彭石新村' },
              { value: '0314312538', label: '杨袁新村' },
              { value: '0314312539', label: '升斗李' },
              { value: '0314312540', label: '大庞' },
              { value: '0314312541', label: '小庞' },
              { value: '0314312542', label: '前谷' },
              { value: '0314312543', label: '后谷' },
              { value: '0314312544', label: '毛园' },
              { value: '0314312545', label: '盐官村' },
              { value: '0314312546', label: '邵吴村' },
              { value: '0314312547', label: '粉王' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '04',
    label: '乐陵市',
    children: [
      {
        value: '04154',
        label: '乐陵市',
        children: [
          {
            value: '041542',
            label: '市中街道',
            children: [
              { value: '041541', label: '中苑村' },
              { value: '0415421', label: '顺源村' },
              { value: '0415422', label: '顺河村' },
              { value: '0415423', label: '渤海村' },
              { value: '0415424', label: '阳光村' },
              { value: '0415425', label: '云祥村' }
            ]
          },
          {
            value: '041543',
            label: '郭家街道',
            children: [
              { value: '041542', label: '郭家新村' },
              { value: '0415436', label: '中兴村' },
              { value: '0415437', label: '枣王村' },
              { value: '0415438', label: '郑家新村' },
              { value: '0415439', label: '大张新村' },
              { value: '04154310', label: '华亿村' }
            ]
          },
          {
            value: '041544',
            label: '云红街道',
            children: [
              { value: '041543', label: '东兴村' },
              { value: '04154411', label: '龙悦村' },
              { value: '04154412', label: '忠义村' },
              { value: '04154413', label: '红云村' },
              { value: '04154414', label: '三和村' },
              { value: '04154415', label: '结义村' },
              { value: '04154416', label: '千红湖村' }
            ]
          },
          {
            value: '041545',
            label: '胡家街道',
            children: [
              { value: '041544', label: '胡家新村' },
              { value: '04154517', label: '王起新村' },
              { value: '04154518', label: '芦店新村' },
              { value: '04154519', label: '史家坟新村' },
              { value: '04154520', label: '赵木匠新村' },
              { value: '04154521', label: '大宋新村' },
              { value: '04154522', label: '康家新村' },
              { value: '04154523', label: '千顷张新村' }
            ]
          },
          {
            value: '041546',
            label: '铁营镇',
            children: [
              { value: '041545', label: '兴隆新村' },
              { value: '04154624', label: '桑庄新村' },
              { value: '04154625', label: '郑庙新村' },
              { value: '04154626', label: '铁营新村' },
              { value: '04154627', label: '陆祥居村' },
              { value: '04154628', label: '六星塬村' }
            ]
          },
          {
            value: '041547',
            label: '杨安镇',
            children: [
              { value: '041546', label: '百味佳新村' },
              { value: '04154729', label: '千都苑新村' },
              { value: '04154730', label: '万安居新村' },
              { value: '04154731', label: '颐杨城新村' }
            ]
          },
          {
            value: '041548',
            label: '朱集镇',
            children: [
              { value: '041547', label: '大徐村' },
              { value: '04154832', label: '高厦檐村' },
              { value: '04154833', label: '李胡马村' },
              { value: '04154834', label: '六寨村' },
              { value: '04154835', label: '三间堂村' },
              { value: '04154836', label: '王斗枢村' },
              { value: '04154837', label: '王玉讲村' },
              { value: '04154838', label: '席家村' },
              { value: '04154839', label: '园艺村' },
              { value: '04154840', label: '枣林村' },
              { value: '04154841', label: '灶户田村' },
              { value: '04154842', label: '朱集村' }
            ]
          },
          {
            value: '041549',
            label: '黄夹镇',
            children: [
              { value: '041548', label: '黄夹村' },
              { value: '04154943', label: '红旗村' },
              { value: '04154944', label: '祥瑞新村' },
              { value: '04154945', label: '建业新村' },
              { value: '04154946', label: '和谐新村' },
              { value: '04154947', label: '安邦新村' },
              { value: '04154948', label: '富平新村' },
              { value: '04154949', label: '兴国新村' },
              { value: '04154950', label: '景麒新村' },
              { value: '04154951', label: '时代新村' },
              { value: '04154952', label: '昌盛新村' }
            ]
          },
          {
            value: '0415410',
            label: '化楼镇',
            children: [
              { value: '041549', label: '富山村' },
              { value: '041541053', label: '丰泽村' },
              { value: '041541054', label: '化楼新村' },
              { value: '041541055', label: '粮苑村' },
              { value: '041541056', label: '和谐村' },
              { value: '041541057', label: '丰收村' },
              { value: '041541058', label: '五合新村' },
              { value: '041541059', label: '五星村' },
              { value: '041541060', label: '沿河村' },
              { value: '041541061', label: '张屯新村' },
              { value: '041541062', label: '河畔村' },
              { value: '041541063', label: '炉坊新村' },
              { value: '041541064', label: '白家村' }
            ]
          },
          {
            value: '0415411',
            label: '郑店镇',
            children: [
              { value: '0415410', label: '郑店新村' },
              { value: '041541165', label: '光明新村' },
              { value: '041541166', label: '朝阳新村' },
              { value: '041541167', label: '永昌新村' },
              { value: '041541168', label: '德丰新村' },
              { value: '041541169', label: '振兴新村' },
              { value: '041541170', label: '九联新村' },
              { value: '041541171', label: '镇东新村' },
              { value: '041541172', label: '新合新村' },
              { value: '041541173', label: '河南新村' },
              { value: '041541174', label: '盘古新村' },
              { value: '041541175', label: '镇西新村' }
            ]
          },
          {
            value: '0415412',
            label: '孔镇镇',
            children: [
              { value: '0415411', label: '孔府村' },
              { value: '041541276', label: '孔苑村' },
              { value: '041541277', label: '孔兴村' },
              { value: '041541278', label: '孔顺村' },
              { value: '041541279', label: '孔达村' },
              { value: '041541280', label: '孔安村' },
              { value: '041541281', label: '孔宁村' },
              { value: '041541282', label: '孔祥村' },
              { value: '041541283', label: '孔贤村' },
              { value: '041541284', label: '孔德村' }
            ]
          },
          {
            value: '0415413',
            label: '花园镇',
            children: [
              { value: '0415412', label: '王母殿新村' },
              { value: '041541385', label: '刘武官新村' },
              { value: '041541386', label: '三鲁村' },
              { value: '041541387', label: '五店村' },
              { value: '041541388', label: '大顾新村' },
              { value: '041541389', label: '大韩新村' },
              { value: '041541390', label: '新河崖村' },
              { value: '041541391', label: '房家新村' },
              { value: '041541392', label: '周家新村' },
              { value: '041541393', label: '花园新村' }
            ]
          },
          {
            value: '0415414',
            label: '丁坞镇',
            children: [
              { value: '0415413', label: '振兴村' },
              { value: '041541494', label: '复兴村' },
              { value: '041541495', label: '丁坞村' },
              { value: '041541496', label: '华兴村' },
              { value: '041541497', label: '杨盘村' },
              { value: '041541498', label: '杨寨村' },
              { value: '041541499', label: '中兴村' },
              { value: '0415414100', label: '张生村' }
            ]
          },
          {
            value: '0415415',
            label: '寨头堡乡',
            children: [
              { value: '0415414', label: '中心村' },
              { value: '0415415101', label: '永兴村' },
              { value: '0415415102', label: '永和村' },
              { value: '0415415103', label: '幸福村' },
              { value: '0415415104', label: '和谐村' },
              { value: '0415415105', label: '碧霞村' },
              { value: '0415415106', label: '振兴村' }
            ]
          },
          {
            value: '0415416',
            label: '西段乡',
            children: [
              { value: '0415415', label: '西段新村' },
              { value: '0415416107', label: '王家村' },
              { value: '0415416108', label: '程王村' },
              { value: '0415416109', label: '岔河村' },
              { value: '0415416110', label: '张梁村' }
            ]
          },
          {
            value: '0415417',
            label: '大孙乡',
            children: [
              { value: '0415416', label: '五合村' },
              { value: '0415417111', label: '中心村' },
              { value: '0415417112', label: '东升村' },
              { value: '0415417113', label: '西兴村' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '05',
    label: '宁津县',
    children: [
      {
        value: '05165',
        label: '宁津县',
        children: [
          {
            value: '051652',
            label: '宁城街道',
            children: [
              { value: '051651', label: '宁城街道安业社区' },
              { value: '0516521', label: '朝阳社区' },
              { value: '0516522', label: '福宁社区' },
              { value: '0516523', label: '惠宁社区' },
              { value: '0516524', label: '康宁社区' },
              { value: '0516525', label: '康平社区' },
              { value: '0516526', label: '希望社区' },
              { value: '0516527', label: '振华社区' },
              { value: '0516528', label: '正阳社区' }
            ]
          },
          {
            value: '051653',
            label: '柴胡店镇',
            children: [
              { value: '051652', label: '柴胡店镇柴胡店村' },
              { value: '0516539', label: '新河北村' },
              { value: '05165310', label: '店西刘村' },
              { value: '05165311', label: '大逯村' },
              { value: '05165312', label: '柴庙村' },
              { value: '05165313', label: '王知村' },
              { value: '05165314', label: '夏家村' },
              { value: '05165315', label: '前艾村' },
              { value: '05165316', label: '后艾村' },
              { value: '05165317', label: '二马苏村' },
              { value: '05165318', label: '路庄村' },
              { value: '05165319', label: '鲍权家村' },
              { value: '05165320', label: '王学堂村' },
              { value: '05165321', label: '彭胡同村' },
              { value: '05165322', label: '小艾家村' },
              { value: '05165323', label: '青积务村' },
              { value: '05165324', label: '小岳家村' },
              { value: '05165325', label: '孟集村' },
              { value: '05165326', label: '李士固村' },
              { value: '05165327', label: '小赵村' },
              { value: '05165328', label: '东崔村' },
              { value: '05165329', label: '方家村' },
              { value: '05165330', label: '魏于村' },
              { value: '05165331', label: '王家村' },
              { value: '05165332', label: '苑家村' },
              { value: '05165333', label: '皮虎林村' },
              { value: '05165334', label: '王德普村' },
              { value: '05165335', label: '孙沟小魏村' },
              { value: '05165336', label: '崔杨村' },
              { value: '05165337', label: '亓家村' },
              { value: '05165338', label: '李才村' },
              { value: '05165339', label: '孟豹村' },
              { value: '05165340', label: '白庙村' },
              { value: '05165341', label: '姜家村' },
              { value: '05165342', label: '王秀村' },
              { value: '05165343', label: '边家村' },
              { value: '05165344', label: '双庙崔村' },
              { value: '05165345', label: '冯邵小段村' },
              { value: '05165346', label: '小辛村' },
              { value: '05165347', label: '王月村' },
              { value: '05165348', label: '张庄村' },
              { value: '05165349', label: '大柴村' },
              { value: '05165350', label: '李马子村' },
              { value: '05165351', label: '大辛村' },
              { value: '05165352', label: '赵铁锅村' },
              { value: '05165353', label: '苇子湾村' },
              { value: '05165354', label: '李道口村' },
              { value: '05165355', label: '黑赵村' },
              { value: '05165356', label: '汤家村' },
              { value: '05165357', label: '张集村' },
              { value: '05165358', label: '朱庄村' },
              { value: '05165359', label: '马海村' },
              { value: '05165360', label: '王世英村' },
              { value: '05165361', label: '张明宇村' },
              { value: '05165362', label: '孔房村' },
              { value: '05165363', label: '郝家村' },
              { value: '05165364', label: '楼子王村' },
              { value: '05165365', label: '广明庵村' },
              { value: '05165366', label: '太平庄村' },
              { value: '05165367', label: '吕庄村' },
              { value: '05165368', label: '崔家村' },
              { value: '05165369', label: '闫集村' },
              { value: '05165370', label: '王庄村' },
              { value: '05165371', label: '张蜚村' },
              { value: '05165372', label: '葛勇村' },
              { value: '05165373', label: '新庄村' },
              { value: '05165374', label: '后寨子村' },
              { value: '05165375', label: '李帅村' },
              { value: '05165376', label: '马厂村' },
              { value: '05165377', label: '马道子村' },
              { value: '05165378', label: '马家村' },
              { value: '05165379', label: '毛家村' },
              { value: '05165380', label: '前寨子村' },
              { value: '05165381', label: '生家村' },
              { value: '05165382', label: '小寇村' },
              { value: '05165383', label: '杨家村' },
              { value: '05165384', label: '臧家村' },
              { value: '05165385', label: '安家村' },
              { value: '05165386', label: '陈家村' },
              { value: '05165387', label: '盖家村' },
              { value: '05165388', label: '明家村' },
              { value: '05165389', label: '田河村' },
              { value: '05165390', label: '吴家村' },
              { value: '05165391', label: '小白村' },
              { value: '05165392', label: '小李村' },
              { value: '05165393', label: '小周家村' },
              { value: '05165394', label: '薛家村' },
              { value: '05165395', label: '赵酒房村' },
              { value: '05165396', label: '尤集村' },
              { value: '05165397', label: '三联村' }
            ]
          },
          {
            value: '051654',
            label: '津城街道',
            children: [
              { value: '051653', label: '津成街道德尚新村' },
              { value: '05165498', label: '津东新村' },
              { value: '05165499', label: '爱心嘉园村' },
              { value: '051654100', label: '新兴村' },
              { value: '051654101', label: '双侯马村' },
              { value: '051654102', label: '岱夏和村' },
              { value: '051654103', label: '新合新村' },
              { value: '051654104', label: '王项新村' },
              { value: '051654105', label: '德惠新村' },
              { value: '051654106', label: '千陶新村' },
              { value: '051654107', label: '常庄村' },
              { value: '051654108', label: '仙淮新村' },
              { value: '051654109', label: '高庄新村' },
              { value: '051654110', label: '油坊贡村' },
              { value: '051654111', label: '晨阳新村' },
              { value: '051654112', label: '后园村' },
              { value: '051654113', label: '八里庄村' },
              { value: '051654114', label: '码头孙村' },
              { value: '051654115', label: '前园村' },
              { value: '051654116', label: '沙河董村' },
              { value: '051654117', label: '李庄村' },
              { value: '051654118', label: '时庄村' },
              { value: '051654119', label: '神牌村' },
              { value: '051654120', label: '杨宁村' },
              { value: '051654121', label: '前王村' },
              { value: '051654122', label: '后王村' },
              { value: '051654123', label: '刘言村' },
              { value: '051654124', label: '魏庄村' },
              { value: '051654125', label: '东滕村' },
              { value: '051654126', label: '西雒村' },
              { value: '051654127', label: '腾张村' },
              { value: '051654128', label: '东雒村' },
              { value: '051654129', label: '关庄村' },
              { value: '051654130', label: '苑庄村' },
              { value: '051654131', label: '王银村' },
              { value: '051654132', label: '前岳村' },
              { value: '051654133', label: '后岳村' },
              { value: '051654134', label: '皮洼村' },
              { value: '051654135', label: '李会村' },
              { value: '051654136', label: '皂户刘村' },
              { value: '051654137', label: '蔡庄村' },
              { value: '051654138', label: '小祁村' },
              { value: '051654139', label: '刘刚村' },
              { value: '051654140', label: '大苏村' },
              { value: '051654141', label: '谢集村' },
              { value: '051654142', label: '小付村' },
              { value: '051654143', label: '百佛堂村' },
              { value: '051654144', label: '张万村' },
              { value: '051654145', label: '洼刘村' },
              { value: '051654146', label: '前姜村' },
              { value: '051654147', label: '罗庄村' },
              { value: '051654148', label: '西镇村' },
              { value: '051654149', label: '东镇村' },
              { value: '051654150', label: '洼赵村' },
              { value: '051654151', label: '东店村' },
              { value: '051654152', label: '王昙村' },
              { value: '051654153', label: '小店村' },
              { value: '051654154', label: '苏陈村' },
              { value: '051654155', label: '崔茂村' },
              { value: '051654156', label: '西弥家河村' },
              { value: '051654157', label: '高楼寺姜村' },
              { value: '051654158', label: '吴碾村' },
              { value: '051654159', label: '东弥家河村' },
              { value: '051654160', label: '荆家村' }
            ]
          },
          {
            value: '051655',
            label: '时集镇',
            children: [
              { value: '051654', label: '时集镇西五新村' },
              { value: '051655161', label: '双翟姚村' },
              { value: '051655162', label: '洼周村' },
              { value: '051655163', label: '历亭北村' },
              { value: '051655164', label: '兴河村' },
              { value: '051655165', label: '闫黄村' },
              { value: '051655166', label: '杜韬村' },
              { value: '051655167', label: '郭李村' },
              { value: '051655168', label: '宁河新村' },
              { value: '051655169', label: '虎南村' },
              { value: '051655170', label: '双集村' },
              { value: '051655171', label: '益仓村' },
              { value: '051655172', label: '杨庄村' },
              { value: '051655173', label: '时集村' },
              { value: '051655174', label: '和平村' },
              { value: '051655175', label: '王河村' },
              { value: '051655176', label: '马庄村' },
              { value: '051655177', label: '赵庄村' },
              { value: '051655178', label: '前油周村' },
              { value: '051655179', label: '西刘村' },
              { value: '051655180', label: '博古张村' },
              { value: '051655181', label: '陈庄村' },
              { value: '051655182', label: '大曹村' },
              { value: '051655183', label: '杜阁村' },
              { value: '051655184', label: '盖庄村' },
              { value: '051655185', label: '后环村' },
              { value: '051655186', label: '李八卦村' },
              { value: '051655187', label: '马厂村' },
              { value: '051655188', label: '前环村' },
              { value: '051655189', label: '桑庄村' },
              { value: '051655190', label: '双庙村' },
              { value: '051655191', label: '孙处村' },
              { value: '051655192', label: '王岐山村' },
              { value: '051655193', label: '王菜村' },
              { value: '051655194', label: '王庄村' },
              { value: '051655195', label: '小耿村' },
              { value: '051655196', label: '郭皋村' },
              { value: '051655197', label: '杨西川村' },
              { value: '051655198', label: '油房李村' },
              { value: '051655199', label: '崔庄村' },
              { value: '051655200', label: '虎西村' },
              { value: '051655201', label: '虎东村' },
              { value: '051655202', label: '宋曹村' },
              { value: '051655203', label: '尹毕曹村' },
              { value: '051655204', label: '张菜村' },
              { value: '051655205', label: '坊子北村' },
              { value: '051655206', label: '坊子南村' },
              { value: '051655207', label: '批户李村' },
              { value: '051655208', label: '前焦村' }
            ]
          },
          {
            value: '051656',
            label: '保店镇',
            children: [
              { value: '051655', label: '保店镇聚福村' },
              { value: '051656209', label: '东南村' },
              { value: '051656210', label: '希望村' },
              { value: '051656211', label: '庞庄村' },
              { value: '051656212', label: '前刘村' },
              { value: '051656213', label: '向阳村' },
              { value: '051656214', label: '幸福新村' },
              { value: '051656215', label: '苏张村' },
              { value: '051656216', label: '许马铁村' },
              { value: '051656217', label: '乔庄村' },
              { value: '051656218', label: '苏王村' },
              { value: '051656219', label: '刘大碗村' },
              { value: '051656220', label: '曲庄村' },
              { value: '051656221', label: '王千村' },
              { value: '051656222', label: '迟庄村' },
              { value: '051656223', label: '孙古柳村' },
              { value: '051656224', label: '红庙李村' },
              { value: '051656225', label: '井庄村' },
              { value: '051656226', label: '惠民村' },
              { value: '051656227', label: '张宅村' },
              { value: '051656228', label: '长庄村' },
              { value: '051656229', label: '双丰新村' },
              { value: '051656230', label: '王杨新村' },
              { value: '051656231', label: '瑞泽新村' },
              { value: '051656232', label: '前杨新村' },
              { value: '051656233', label: '德望新村' },
              { value: '051656234', label: '胡苏新村' },
              { value: '051656235', label: '方庄村' },
              { value: '051656236', label: '吕庄村' },
              { value: '051656237', label: '牟益村' },
              { value: '051656238', label: '郑庄村' },
              { value: '051656239', label: '蒋庄村' },
              { value: '051656240', label: '许庄村' },
              { value: '051656241', label: '祁庄村' },
              { value: '051656242', label: '同新村' },
              { value: '051656243', label: '哱罗寨村' },
              { value: '051656244', label: '张袁雒村' },
              { value: '051656245', label: '黄镇村' },
              { value: '051656246', label: '临漳村' },
              { value: '051656247', label: '孙庄村' },
              { value: '051656248', label: '融惠村' },
              { value: '051656249', label: '蒙洼村' },
              { value: '051656250', label: '肖庄村' },
              { value: '051656251', label: '满庄村' },
              { value: '051656252', label: '灰刘村' },
              { value: '051656253', label: '义合新村' },
              { value: '051656254', label: '灰街村' },
              { value: '051656255', label: '战庄村' },
              { value: '051656256', label: '高庄村' },
              { value: '051656257', label: '王吏目村' },
              { value: '051656258', label: '邓李回村' }
            ]
          },
          {
            value: '051657',
            label: '杜集镇',
            children: [
              { value: '051656', label: '杜集镇宏运村' },
              { value: '051657259', label: '郭李村' },
              { value: '051657260', label: '张庄村' },
              { value: '051657261', label: '宁东村' },
              { value: '051657262', label: '姜庄村' },
              { value: '051657263', label: '范高村' },
              { value: '051657264', label: '王清溪村' },
              { value: '051657265', label: '兴农新村' },
              { value: '051657266', label: '固华村' },
              { value: '051657267', label: '三兴村' },
              { value: '051657268', label: '陈纸房村' },
              { value: '051657269', label: '苏庄村' },
              { value: '051657270', label: '东兴村' },
              { value: '051657271', label: '杨保村' },
              { value: '051657272', label: '兴华村' },
              { value: '051657273', label: '福隆村' },
              { value: '051657274', label: '富民村' },
              { value: '051657275', label: '新好村' },
              { value: '051657276', label: '舒庄村' },
              { value: '051657277', label: '张万新村' },
              { value: '051657278', label: '兴旺新村' },
              { value: '051657279', label: '段杜新村' },
              { value: '051657280', label: '张定村' },
              { value: '051657281', label: '薛杨村' },
              { value: '051657282', label: '贾卢村' },
              { value: '051657283', label: '前虎村' },
              { value: '051657284', label: '杜集村' },
              { value: '051657285', label: '李杨村' },
              { value: '051657286', label: '李镇村' },
              { value: '051657287', label: '普刘村' },
              { value: '051657288', label: '王纸村' },
              { value: '051657289', label: '小刘村' },
              { value: '051657290', label: '闫庄村' },
              { value: '051657291', label: '杨树高村' },
              { value: '051657292', label: '东段村' },
              { value: '051657293', label: '西段村' },
              { value: '051657294', label: '孙东村' },
              { value: '051657295', label: '孙西村' },
              { value: '051657296', label: '张旭村' },
              { value: '051657297', label: '李麻村' },
              { value: '051657298', label: '刘双全村' },
              { value: '051657299', label: '谢庄村' },
              { value: '051657300', label: '姚庄村' },
              { value: '051657301', label: '张纸村' },
              { value: '051657302', label: '崔庄村' },
              { value: '051657303', label: '大苏村' },
              { value: '051657304', label: '杜司村' },
              { value: '051657305', label: '大刘集村' },
              { value: '051657306', label: '后郝村' },
              { value: '051657307', label: '前郝村' },
              { value: '051657308', label: '小刘集村' },
              { value: '051657309', label: '仝庄村' },
              { value: '051657310', label: '张边头村' },
              { value: '051657311', label: '钟楼张村' },
              { value: '051657312', label: '伍大庄村' },
              { value: '051657313', label: '王庭府村' },
              { value: '051657314', label: '常洼村' },
              { value: '051657315', label: '洼陈村' },
              { value: '051657316', label: '菜王村' },
              { value: '051657317', label: '丁庄村' },
              { value: '051657318', label: '洼里高村' },
              { value: '051657319', label: '肖庄村' },
              { value: '051657320', label: '亚庄村' },
              { value: '051657321', label: '银相公村' },
              { value: '051657322', label: '张端村' },
              { value: '051657323', label: '仲伍街村' },
              { value: '051657324', label: '河沟王村' },
              { value: '051657325', label: '银庄村' },
              { value: '051657326', label: '毕庄村' },
              { value: '051657327', label: '博古寺村' },
              { value: '051657328', label: '宏治刘村' },
              { value: '051657329', label: '古庄村' },
              { value: '051657330', label: '后刘村' },
              { value: '051657331', label: '后水村' },
              { value: '051657332', label: '前刘村' },
              { value: '051657333', label: '来庄村' }
            ]
          },
          {
            value: '051658',
            label: '大柳镇',
            children: [
              { value: '051657', label: '大柳镇大东村' },
              { value: '051658334', label: '大西村' },
              { value: '051658335', label: '七间厅村' },
              { value: '051658336', label: '庞家寺村' },
              { value: '051658337', label: '黄庄村' },
              { value: '051658338', label: '李胡村' },
              { value: '051658339', label: '郑庄村' },
              { value: '051658340', label: '小郭村' },
              { value: '051658341', label: '张斋村' },
              { value: '051658342', label: '李智白村' },
              { value: '051658343', label: '桑庄村' },
              { value: '051658344', label: '谢庄村' },
              { value: '051658345', label: '李满村' },
              { value: '051658346', label: '大郭村' },
              { value: '051658347', label: '小马村' },
              { value: '051658348', label: '小姚村' },
              { value: '051658349', label: '邢庄村' },
              { value: '051658350', label: '杨小章村' },
              { value: '051658351', label: '五福刘村' },
              { value: '051658352', label: '鄄子村' },
              { value: '051658353', label: '小韩村' },
              { value: '051658354', label: '财帛李村' },
              { value: '051658355', label: '潘庄村' },
              { value: '051658356', label: '西陶村' },
              { value: '051658357', label: '中陶村' },
              { value: '051658358', label: '东陶村' },
              { value: '051658359', label: '双进村' },
              { value: '051658360', label: '小章村' },
              { value: '051658361', label: '孟王村' },
              { value: '051658362', label: '魏庄村' },
              { value: '051658363', label: '五湖村' },
              { value: '051658364', label: '石庄村' },
              { value: '051658365', label: '四合村' },
              { value: '051658366', label: '傅集村' },
              { value: '051658367', label: '筐杨村' }
            ]
          },
          {
            value: '051659',
            label: '大曹镇',
            children: [
              { value: '051658', label: '大曹镇南邢村' },
              { value: '051659368', label: '包庄村' },
              { value: '051659369', label: '武庄村' },
              { value: '051659370', label: '宋桥村' },
              { value: '051659371', label: '东谭村' },
              { value: '051659372', label: '尚庄村' },
              { value: '051659373', label: '霍庄村' },
              { value: '051659374', label: '后李村' },
              { value: '051659375', label: '西李村' },
              { value: '051659376', label: '西梁村' },
              { value: '051659377', label: '中梁村' },
              { value: '051659378', label: '东梁村' },
              { value: '051659379', label: '张珂村' },
              { value: '051659380', label: '乔王代村' },
              { value: '051659381', label: '西谭村' },
              { value: '051659382', label: '盖佃王村' },
              { value: '051659383', label: '毛庄村' },
              { value: '051659384', label: '大乔村' },
              { value: '051659385', label: '管庄村' },
              { value: '051659386', label: '宋蒋村' },
              { value: '051659387', label: '辛庄村' },
              { value: '051659388', label: '西武村' },
              { value: '051659389', label: '马庄村' },
              { value: '051659390', label: '沈庄村' },
              { value: '051659391', label: '前谭村' },
              { value: '051659392', label: '西塘村' },
              { value: '051659393', label: '高官村' },
              { value: '051659394', label: '刘槐村' },
              { value: '051659395', label: '张傲村' },
              { value: '051659396', label: '火盆陈村' },
              { value: '051659397', label: '谢庄村' },
              { value: '051659398', label: '董黄李村' },
              { value: '051659399', label: '刘朝村' },
              { value: '051659400', label: '东大孙村' },
              { value: '051659401', label: '棘棵王新村' },
              { value: '051659402', label: '郭李村' },
              { value: '051659403', label: '高王村' },
              { value: '051659404', label: '油房赵村' },
              { value: '051659405', label: '于寨村' },
              { value: '051659406', label: '赵郭孙' },
              { value: '051659407', label: '孙乔村' },
              { value: '051659408', label: '大姚村' },
              { value: '051659409', label: '兴业新村' },
              { value: '051659410', label: '邢王张' },
              { value: '051659411', label: '刘穆村' },
              { value: '051659412', label: '大赵村' },
              { value: '051659413', label: '黄河涯村' },
              { value: '051659414', label: '大曹村' },
              { value: '051659415', label: '万李村' },
              { value: '051659416', label: '野竹李新村' },
              { value: '051659417', label: '孙其宾村' }
            ]
          },
          {
            value: '0516510',
            label: '张大庄镇',
            children: [
              { value: '051659', label: '张大庄镇后白庄村' },
              { value: '0516510418', label: '张刘房村' },
              { value: '0516510419', label: '尹安村' },
              { value: '0516510420', label: '张高村' },
              { value: '0516510421', label: '齐田村' },
              { value: '0516510422', label: '双郑马村' },
              { value: '0516510423', label: '铁佛寺村' },
              { value: '0516510424', label: '前村' },
              { value: '0516510425', label: '中村' },
              { value: '0516510426', label: '后村' },
              { value: '0516510427', label: '李七村' },
              { value: '0516510428', label: '前徐村' },
              { value: '0516510429', label: '刘辉村' },
              { value: '0516510430', label: '杏行村' },
              { value: '0516510431', label: '白菜魏村' },
              { value: '0516510432', label: '沈庄村' },
              { value: '0516510433', label: '郑仪门村' },
              { value: '0516510434', label: '靳庄村' },
              { value: '0516510435', label: '张户头村' },
              { value: '0516510436', label: '姚口村' },
              { value: '0516510437', label: '王庄村' },
              { value: '0516510438', label: '冯庄村' },
              { value: '0516510439', label: '大鱼李村' },
              { value: '0516510440', label: '张香西村' },
              { value: '0516510441', label: '程庄村' },
              { value: '0516510442', label: '双碓村' },
              { value: '0516510443', label: '清明寺村' },
              { value: '0516510444', label: '小郭村' },
              { value: '0516510445', label: '高桥村' },
              { value: '0516510446', label: '王壕村' }
            ]
          },
          {
            value: '0516511',
            label: '相衙镇',
            children: [
              { value: '0516510', label: '相衙镇陈庞李村' },
              { value: '0516511447', label: '卢集村' },
              { value: '0516511448', label: '张范新村' },
              { value: '0516511449', label: '相衙新村' },
              { value: '0516511450', label: '郝王新村' },
              { value: '0516511451', label: '白厂新村' },
              { value: '0516511452', label: '王张新村' },
              { value: '0516511453', label: '杨于新村' },
              { value: '0516511454', label: '四平新村' },
              { value: '0516511455', label: '纸房村' },
              { value: '0516511456', label: '李王曹村' },
              { value: '0516511457', label: '京门新村' },
              { value: '0516511458', label: '刘廷石村' },
              { value: '0516511459', label: '张望南村' },
              { value: '0516511460', label: '孟王刘村' },
              { value: '0516511461', label: '八庄村' },
              { value: '0516511462', label: '大耿村' },
              { value: '0516511463', label: '刘道庄村' },
              { value: '0516511464', label: '大刘普村' },
              { value: '0516511465', label: '宋庄村' },
              { value: '0516511466', label: '朱冯庄村' },
              { value: '0516511467', label: '王圃囤村' },
              { value: '0516511468', label: '车李村' },
              { value: '0516511469', label: '编席杨村' },
              { value: '0516511470', label: '西彭村' },
              { value: '0516511471', label: '辛庄村' },
              { value: '0516511472', label: '张程村' },
              { value: '0516511473', label: '李家桥村' },
              { value: '0516511474', label: '田家庵村' },
              { value: '0516511475', label: '惺悟寨村' },
              { value: '0516511476', label: '谷白桂村' },
              { value: '0516511477', label: '黑白村' },
              { value: '0516511478', label: '李阜安村' },
              { value: '0516511479', label: '王铎村' },
              { value: '0516511480', label: '孙庄村' },
              { value: '0516511481', label: '苗马李' },
              { value: '0516511482', label: '邢庄村' },
              { value: '0516511483', label: '万庄村' },
              { value: '0516511484', label: '朱道口村' },
              { value: '0516511485', label: '张道口村' },
              { value: '0516511486', label: '杨老头村' },
              { value: '0516511487', label: '化牛李村' },
              { value: '0516511488', label: '码头张村' },
              { value: '0516511489', label: '楼子李村' },
              { value: '0516511490', label: '付庄村' },
              { value: '0516511491', label: '孔圣庙村' }
            ]
          },
          {
            value: '0516512',
            label: '长官镇',
            children: [
              { value: '0516511', label: '长官镇吉杨村' },
              { value: '0516512492', label: '长新村' },
              { value: '0516512493', label: '大苑村' },
              { value: '0516512494', label: '王德厚村' },
              { value: '0516512495', label: '祥和新村' },
              { value: '0516512496', label: '泰和新村' },
              { value: '0516512497', label: '振和新村' },
              { value: '0516512498', label: '曙光新村' },
              { value: '0516512499', label: '和兴新村' },
              { value: '0516512500', label: '刘廷献村' },
              { value: '0516512501', label: '路辛村' },
              { value: '0516512502', label: '荣胜新村' },
              { value: '0516512503', label: '西曹村' },
              { value: '0516512504', label: '东曹村' },
              { value: '0516512505', label: '李名杨村' },
              { value: '0516512506', label: '李庄村' },
              { value: '0516512507', label: '田庄村' },
              { value: '0516512508', label: '黄庄村' },
              { value: '0516512509', label: '艾庄村' },
              { value: '0516512510', label: '刘宅村' },
              { value: '0516512511', label: '小曹村' },
              { value: '0516512512', label: '小桑村' },
              { value: '0516512513', label: '长南村' },
              { value: '0516512514', label: '郭相村' },
              { value: '0516512515', label: '郑庄村' },
              { value: '0516512516', label: '薛庄村' },
              { value: '0516512517', label: '东一村' },
              { value: '0516512518', label: '东二村' },
              { value: '0516512519', label: '小高村' },
              { value: '0516512520', label: '贾庄村' },
              { value: '0516512521', label: '赵庄村' },
              { value: '0516512522', label: '长西村' },
              { value: '0516512523', label: '长北村' },
              { value: '0516512524', label: '仉庄村' },
              { value: '0516512525', label: '张凤巢村' }
            ]
          },
          {
            value: '0516513',
            label: '刘营伍乡',
            children: [
              { value: '0516512', label: '刘营伍乡兴业村' },
              { value: '0516513526', label: '商庄村' },
              { value: '0516513527', label: '宗庄村' },
              { value: '0516513528', label: '高塔寺村' },
              { value: '0516513529', label: '编筐刘村' },
              { value: '0516513530', label: '河北张村' },
              { value: '0516513531', label: '兴农村' },
              { value: '0516513532', label: '郭营伍村' },
              { value: '0516513533', label: '王营伍村' },
              { value: '0516513534', label: '刘营伍村' },
              { value: '0516513535', label: '张安村' },
              { value: '0516513536', label: '于庄村' },
              { value: '0516513537', label: '宋庄村' },
              { value: '0516513538', label: '龙潭村' },
              { value: '0516513539', label: '贾庄村' },
              { value: '0516513540', label: '刘旺言村' },
              { value: '0516513541', label: '赵庄村' },
              { value: '0516513542', label: '寨东村' },
              { value: '0516513543', label: '寨西村' },
              { value: '0516513544', label: '刘秋村' },
              { value: '0516513545', label: '庞寨村' },
              { value: '0516513546', label: '周庄村' },
              { value: '0516513547', label: '崔寨村' },
              { value: '0516513548', label: '老君堂村' },
              { value: '0516513549', label: '孙华门村' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '06',
    label: '齐河县',
    children: [
      {
        value: '06176',
        label: '齐河县',
        children: [
          {
            value: '061762',
            label: '安头乡',
            children: [
              { value: '061761', label: '蔡家庄村' },
              { value: '0617621', label: '三岔口村' },
              { value: '0617622', label: '张保屯北村' },
              { value: '0617623', label: '张保屯西村' },
              { value: '0617624', label: '张保屯东村' },
              { value: '0617625', label: '张保屯南村' },
              { value: '0617626', label: '南塘子村' },
              { value: '0617627', label: '钱官屯村' },
              { value: '0617628', label: '王京屯西村' },
              { value: '0617629', label: '王京屯东村' },
              { value: '06176210', label: '西里仁村' },
              { value: '06176211', label: '后里仁村' },
              { value: '06176212', label: '前里仁村' },
              { value: '06176213', label: '小吴现屯村' },
              { value: '06176214', label: '薄家岭村' },
              { value: '06176215', label: '小金家岭村' },
              { value: '06176216', label: '鲍官村' },
              { value: '06176217', label: '大吴现屯村' },
              { value: '06176218', label: '刘家小屯村' },
              { value: '06176219', label: '张孟杨村' },
              { value: '06176220', label: '裴庄村' },
              { value: '06176221', label: '任家庄村' },
              { value: '06176222', label: '苏官屯村' },
              { value: '06176223', label: '安头村村' },
              { value: '06176224', label: '于庄村' },
              { value: '06176225', label: '刘言村' },
              { value: '06176226', label: '谢庄村' },
              { value: '06176227', label: '徐庄村' },
              { value: '06176228', label: '郝佃屯村' },
              { value: '06176229', label: '王举人村' },
              { value: '06176230', label: '小王村' },
              { value: '06176231', label: '大彭家寺村' },
              { value: '06176232', label: '小彭家寺村' },
              { value: '06176233', label: '大孙村' },
              { value: '06176234', label: '小李村' },
              { value: '06176235', label: '冢子张村' }
            ]
          },
          {
            value: '061763',
            label: '刘桥镇',
            children: [
              { value: '061762', label: '西杨村' },
              { value: '06176336', label: '战庄村' },
              { value: '06176337', label: '赵店村' },
              { value: '06176338', label: '于屯村' },
              { value: '06176339', label: '西吴村' },
              { value: '06176340', label: '车王村' },
              { value: '06176341', label: '赵庄村' },
              { value: '06176342', label: '小刘村' },
              { value: '06176343', label: '邢庄村' },
              { value: '06176344', label: '孙庄村' },
              { value: '06176345', label: '倪辛村' },
              { value: '06176346', label: '流北村' },
              { value: '06176347', label: '流中村' },
              { value: '06176348', label: '焦集村' },
              { value: '06176349', label: '后郑村' },
              { value: '06176350', label: '大刘村' },
              { value: '06176351', label: '老李村' },
              { value: '06176352', label: '太平村' },
              { value: '06176353', label: '小孟村' },
              { value: '06176354', label: '郭庄村' },
              { value: '06176355', label: '邵庄村' },
              { value: '06176356', label: '栾庄村' },
              { value: '06176357', label: '张翟村' },
              { value: '06176358', label: '康庄村' },
              { value: '06176359', label: '田东村' },
              { value: '06176360', label: '田西村' },
              { value: '06176361', label: '武庄村' },
              { value: '06176362', label: '老焦村' },
              { value: '06176363', label: '葛庄村' },
              { value: '06176364', label: '纪庄村' },
              { value: '06176365', label: '新进屯村' },
              { value: '06176366', label: '陈庄村' },
              { value: '06176367', label: '大马张村' },
              { value: '06176368', label: '陈楼村' },
              { value: '06176369', label: '范庄村' },
              { value: '06176370', label: '于庄村' },
              { value: '06176371', label: '崔庄村' },
              { value: '06176372', label: '梁庄村' },
              { value: '06176373', label: '塘坊村' },
              { value: '06176374', label: '中焦村' },
              { value: '06176375', label: '李茂吾村' },
              { value: '06176376', label: '贾寺村' },
              { value: '06176377', label: '魏庄村' },
              { value: '06176378', label: '孟店村' },
              { value: '06176379', label: '乔庄村' },
              { value: '06176380', label: '大孟村' },
              { value: '06176381', label: '耿庄村' },
              { value: '06176382', label: '千佛阁村' },
              { value: '06176383', label: '小李村' },
              { value: '06176384', label: '东苑村' },
              { value: '06176385', label: '桑刘村' },
              { value: '06176386', label: '凌庄村' },
              { value: '06176387', label: '雷庄村' },
              { value: '06176388', label: '马庄村' },
              { value: '06176389', label: '朱庄村' },
              { value: '06176390', label: '高庄村' },
              { value: '06176391', label: '史庄村' },
              { value: '06176392', label: '刘桥村' },
              { value: '06176393', label: '朱官屯村' },
              { value: '06176394', label: '流南村' },
              { value: '06176395', label: '高桥村' },
              { value: '06176396', label: '十甲王村' },
              { value: '06176397', label: '蔡管屯村' },
              { value: '06176398', label: '宋庄村' },
              { value: '06176399', label: '东风村' }
            ]
          },
          {
            value: '061764',
            label: '祝阿镇',
            children: [
              { value: '061763', label: '石屯村' },
              { value: '061764100', label: '石门高村' },
              { value: '061764101', label: '官庄村' },
              { value: '061764102', label: '小朱村' },
              { value: '061764103', label: '小张村' },
              { value: '061764104', label: '小刘村' },
              { value: '061764105', label: '小魏村' },
              { value: '061764106', label: '崔庄村' },
              { value: '061764107', label: '耿庄村' },
              { value: '061764108', label: '南北郑村' },
              { value: '061764109', label: '小周村' },
              { value: '061764110', label: '七里闫村' },
              { value: '061764111', label: '池庄村' },
              { value: '061764112', label: '张岳村' },
              { value: '061764113', label: '小八里村' },
              { value: '061764114', label: '南吕村' },
              { value: '061764115', label: '李三里村' },
              { value: '061764116', label: '左三里村' },
              { value: '061764117', label: '王小尼村' },
              { value: '061764118', label: '葛谢村' },
              { value: '061764119', label: '吉王村' },
              { value: '061764120', label: '油房赵村' },
              { value: '061764121', label: '訾庄村' },
              { value: '061764122', label: '东十里村' },
              { value: '061764123', label: '杨珍村' },
              { value: '061764124', label: '大林郭村' },
              { value: '061764125', label: '李茂盛村' },
              { value: '061764126', label: '席道口村' },
              { value: '061764127', label: '王岳村' },
              { value: '061764128', label: '刘三里村' },
              { value: '061764129', label: '米三里村' },
              { value: '061764130', label: '王庄村' },
              { value: '061764131', label: '北坦村' },
              { value: '061764132', label: '马家园村' },
              { value: '061764133', label: '北关村' },
              { value: '061764134', label: '东北街村' },
              { value: '061764135', label: '大庞村' },
              { value: '061764136', label: '后河村' },
              { value: '061764137', label: '西南街村' },
              { value: '061764138', label: '西北街村' },
              { value: '061764139', label: '西关村' },
              { value: '061764140', label: '孟庄村' },
              { value: '061764141', label: '高房村' },
              { value: '061764142', label: '后刘村' },
              { value: '061764143', label: '索庄村' },
              { value: '061764144', label: '王府村' },
              { value: '061764145', label: '姜庄村' },
              { value: '061764146', label: '孙楼村' },
              { value: '061764147', label: '水牛赵村' },
              { value: '061764148', label: '贾坊村' },
              { value: '061764149', label: '房台村' },
              { value: '061764150', label: '宰庄村' },
              { value: '061764151', label: '前刘村' },
              { value: '061764152', label: '八里村' },
              { value: '061764153', label: '殷屯村' },
              { value: '061764154', label: '付庄村' },
              { value: '061764155', label: '杨井村' },
              { value: '061764156', label: '东郑村' },
              { value: '061764157', label: '西郑村' },
              { value: '061764158', label: '西宝村' },
              { value: '061764159', label: '马坊村' },
              { value: '061764160', label: '东颜村' },
              { value: '061764161', label: '西颜村' },
              { value: '061764162', label: '前颜村' },
              { value: '061764163', label: '后颜村' },
              { value: '061764164', label: '王辛村' },
              { value: '061764165', label: '果园村' },
              { value: '061764166', label: '坡赵村' },
              { value: '061764167', label: '肖屯村' },
              { value: '061764168', label: '高屯村' },
              { value: '061764169', label: '王坊村' },
              { value: '061764170', label: '西十里村' },
              { value: '061764171', label: '西小辛村' }
            ]
          },
          {
            value: '061765',
            label: '大黄乡',
            children: [
              { value: '061764', label: '大黄村' },
              { value: '061765172', label: '朱于村' },
              { value: '061765173', label: '王洪屯村' },
              { value: '061765174', label: '大埝村' },
              { value: '061765175', label: '陈赵村' },
              { value: '061765176', label: '西赵村' },
              { value: '061765177', label: '大赵村' },
              { value: '061765178', label: '生官屯村' },
              { value: '061765179', label: '袁李村' },
              { value: '061765180', label: '刘东村' },
              { value: '061765181', label: '刘西村' },
              { value: '061765182', label: '孔庄村' },
              { value: '061765183', label: '常庄村' },
              { value: '061765184', label: '程庄村' },
              { value: '061765185', label: '大李村' },
              { value: '061765186', label: '郝桥村' },
              { value: '061765187', label: '后王村' },
              { value: '061765188', label: '小李村' },
              { value: '061765189', label: '仓上村' },
              { value: '061765190', label: '黑牛村' },
              { value: '061765191', label: '义和村' },
              { value: '061765192', label: '河南孙村' },
              { value: '061765193', label: '邵庄村' },
              { value: '061765194', label: '祝楼村' },
              { value: '061765195', label: '西寨村' },
              { value: '061765196', label: '东寨村' },
              { value: '061765197', label: '稍瓜李村' },
              { value: '061765198', label: '彭太屯村' },
              { value: '061765199', label: '石碑杨村' },
              { value: '061765200', label: '大张村' },
              { value: '061765201', label: '张邱村' },
              { value: '061765202', label: '北段村' },
              { value: '061765203', label: '赵塘村' },
              { value: '061765204', label: '朱庄村' },
              { value: '061765205', label: '二郎庙村' },
              { value: '061765206', label: '王邱村' },
              { value: '061765207', label: '白庄村' },
              { value: '061765208', label: '韩庄村' },
              { value: '061765209', label: '甄庄村' },
              { value: '061765210', label: '南段村' },
              { value: '061765211', label: '小马村' }
            ]
          },
          {
            value: '061766',
            label: '华店镇',
            children: [
              { value: '061765', label: '史庄村' },
              { value: '061766212', label: '三堂村' },
              { value: '061766213', label: '东吕村' },
              { value: '061766214', label: '赵店村' },
              { value: '061766215', label: '小杨村' },
              { value: '061766216', label: '大杨村' },
              { value: '061766217', label: '王家楼村' },
              { value: '061766218', label: '马井村' },
              { value: '061766219', label: '张博士村' },
              { value: '061766220', label: '西油村' },
              { value: '061766221', label: '西吕村' },
              { value: '061766222', label: '前王村' },
              { value: '061766223', label: '巨庄村' },
              { value: '061766224', label: '贾庄村' },
              { value: '061766225', label: '华店村' },
              { value: '061766226', label: '曹庄村' },
              { value: '061766227', label: '蔡庄村' },
              { value: '061766228', label: '韩辛村' },
              { value: '061766229', label: '小张村' },
              { value: '061766230', label: '太平王村' },
              { value: '061766231', label: '翟庄村' },
              { value: '061766232', label: '后王村' },
              { value: '061766233', label: '小朱村' },
              { value: '061766234', label: '付庄村' },
              { value: '061766235', label: '北张村' },
              { value: '061766236', label: '宋庄村' },
              { value: '061766237', label: '后营村' },
              { value: '061766238', label: '王上寺村' },
              { value: '061766239', label: '邱铺村' },
              { value: '061766240', label: '前营村' },
              { value: '061766241', label: '士茂王村' },
              { value: '061766242', label: '东油村' },
              { value: '061766243', label: '楼王村' },
              { value: '061766244', label: '后拐村' },
              { value: '061766245', label: '大马村' },
              { value: '061766246', label: '滕庄村' },
              { value: '061766247', label: '侯庄村' },
              { value: '061766248', label: '小田村' },
              { value: '061766249', label: '小周村' },
              { value: '061766250', label: '老张村' },
              { value: '061766251', label: '杨庄村' },
              { value: '061766252', label: '前孙村' },
              { value: '061766253', label: '闫庄村' },
              { value: '061766254', label: '倪庄村' },
              { value: '061766255', label: '白毛李村' },
              { value: '061766256', label: '后庵村' },
              { value: '061766257', label: '龙庄村' },
              { value: '061766258', label: '于楼村' },
              { value: '061766259', label: '明机寨村' },
              { value: '061766260', label: '辛店村' },
              { value: '061766261', label: '中油村' },
              { value: '061766262', label: '范庄村' },
              { value: '061766263', label: '小高村' },
              { value: '061766264', label: '姜庄村' },
              { value: '061766265', label: '官庄村' },
              { value: '061766266', label: '姜南村' },
              { value: '061766267', label: '郭庄村' },
              { value: '061766268', label: '袁庄村' },
              { value: '061766269', label: '王楼村' },
              { value: '061766270', label: '董庄村' },
              { value: '061766271', label: '范楼村' },
              { value: '061766272', label: '尹屯村' },
              { value: '061766273', label: '甄孙村' },
              { value: '061766274', label: '韩庄村' },
              { value: '061766275', label: '赵井村' },
              { value: '061766276', label: '李舍村' },
              { value: '061766277', label: '大周村' },
              { value: '061766278', label: '姜北村' },
              { value: '061766279', label: '沙李村' },
              { value: '061766280', label: '大朱村' },
              { value: '061766281', label: '白庄村' },
              { value: '061766282', label: '张桥村' },
              { value: '061766283', label: '单庄村' }
            ]
          },
          {
            value: '061767',
            label: '胡官屯镇',
            children: [
              { value: '061766', label: '孔官村' },
              { value: '061767284', label: '司李村' },
              { value: '061767285', label: '大小段庄村' },
              { value: '061767286', label: '云庄村' },
              { value: '061767287', label: '牛王村' },
              { value: '061767288', label: '纸坊村' },
              { value: '061767289', label: '蛇窝村' },
              { value: '061767290', label: '郑官村' },
              { value: '061767291', label: '阴河村' },
              { value: '061767292', label: '李永富村' },
              { value: '061767293', label: '周庄村' },
              { value: '061767294', label: '荆庄村' },
              { value: '061767295', label: '边庄村' },
              { value: '061767296', label: '杨道口村' },
              { value: '061767297', label: '邢庄村' },
              { value: '061767298', label: '代庄村' },
              { value: '061767299', label: '马官屯村' },
              { value: '061767300', label: '官庄村' },
              { value: '061767301', label: '张庄村' },
              { value: '061767302', label: '房庄村' },
              { value: '061767303', label: '郑楼村' },
              { value: '061767304', label: '司营村' },
              { value: '061767305', label: '芦庄村' },
              { value: '061767306', label: '富足村' },
              { value: '061767307', label: '生金王村' },
              { value: '061767308', label: '孙楼村' },
              { value: '061767309', label: '吴店寺村' },
              { value: '061767310', label: '刘彭村' },
              { value: '061767311', label: '南小刘村' },
              { value: '061767312', label: '前朱楼村' },
              { value: '061767313', label: '后朱楼村' },
              { value: '061767314', label: '武庄村' },
              { value: '061767315', label: '大明村' },
              { value: '061767316', label: '二合村' },
              { value: '061767317', label: '郭陈村' },
              { value: '061767318', label: '徐洼村' },
              { value: '061767319', label: '赵庄村' },
              { value: '061767320', label: '北曹庄村' },
              { value: '061767321', label: '周苏' },
              { value: '061767322', label: '宋庄村' },
              { value: '061767323', label: '孔老' },
              { value: '061767324', label: '马集' },
              { value: '061767325', label: '十八户村' },
              { value: '061767326', label: '坟台村' },
              { value: '061767327', label: '沙张' },
              { value: '061767328', label: '贾王村' },
              { value: '061767329', label: '朱庄村' },
              { value: '061767330', label: '袁庄村' },
              { value: '061767331', label: '吴集村' },
              { value: '061767332', label: '大李村' },
              { value: '061767333', label: '潘庄村' },
              { value: '061767334', label: '赵官屯村' },
              { value: '061767335', label: '董庄村' },
              { value: '061767336', label: '陶庄' },
              { value: '061767337', label: '路庄村' },
              { value: '061767338', label: '大耿村' },
              { value: '061767339', label: '小耿村' },
              { value: '061767340', label: '付军屯村' },
              { value: '061767341', label: '刘坡头村' },
              { value: '061767342', label: '沟村村' },
              { value: '061767343', label: '梁官村' },
              { value: '061767344', label: '白草林村' },
              { value: '061767345', label: '孙名扬村' },
              { value: '061767346', label: '新付村' },
              { value: '061767347', label: '南李村' },
              { value: '061767348', label: '老付村' },
              { value: '061767349', label: '平稳村' },
              { value: '061767350', label: '胡官屯' },
              { value: '061767351', label: '姬庄村' },
              { value: '061767352', label: '白铺村' }
            ]
          },
          {
            value: '061768',
            label: '宣章镇',
            children: [
              { value: '061767', label: '宋庄村' },
              { value: '061768353', label: '小吕村' },
              { value: '061768354', label: '姚庄村' },
              { value: '061768355', label: '贾庄村' },
              { value: '061768356', label: '王庄村' },
              { value: '061768357', label: '戚官屯村' },
              { value: '061768358', label: '王保村' },
              { value: '061768359', label: '前王村' },
              { value: '061768360', label: '明庄村' },
              { value: '061768361', label: '老吕村' },
              { value: '061768362', label: '耿庄村' },
              { value: '061768363', label: '大张村' },
              { value: '061768364', label: '辛法屯村' },
              { value: '061768365', label: '王井子村' },
              { value: '061768366', label: '小魏村' },
              { value: '061768367', label: '小曹村' },
              { value: '061768368', label: '范桥村' },
              { value: '061768369', label: '宋庵村' },
              { value: '061768370', label: '麦坡口村' },
              { value: '061768371', label: '胡楼村' },
              { value: '061768372', label: '甘东村' },
              { value: '061768373', label: '甘西村' },
              { value: '061768374', label: '胡辛村' },
              { value: '061768375', label: '钱玉屯村' },
              { value: '061768376', label: '宋店村' },
              { value: '061768377', label: '辛兴村' },
              { value: '061768378', label: '高桥村' }
            ]
          },
          {
            value: '061769',
            label: '潘店镇',
            children: [
              { value: '061768', label: '西赵村' },
              { value: '061769379', label: '西腰站村' },
              { value: '061769380', label: '务头村' },
              { value: '061769381', label: '盐场村' },
              { value: '061769382', label: '小赵村' },
              { value: '061769383', label: '朱庄村' },
              { value: '061769384', label: '刘洼村' },
              { value: '061769385', label: '王洲潘村' },
              { value: '061769386', label: '王显武村' },
              { value: '061769387', label: '曲庄村' },
              { value: '061769388', label: '洪孙村' },
              { value: '061769389', label: '何庄村' },
              { value: '061769390', label: '北街村' },
              { value: '061769391', label: '魏台子村' },
              { value: '061769392', label: '靖庄村' },
              { value: '061769393', label: '老庄村' },
              { value: '061769394', label: '前刘楼村' },
              { value: '061769395', label: '田庄村' },
              { value: '061769396', label: '十里雾村' },
              { value: '061769397', label: '郝庄村' },
              { value: '061769398', label: '胡楼村' },
              { value: '061769399', label: '李汉武村' },
              { value: '061769400', label: '徐庄村' },
              { value: '061769401', label: '樊庄村' },
              { value: '061769402', label: '北段村' },
              { value: '061769403', label: '邵庄村' },
              { value: '061769404', label: '王堂村' },
              { value: '061769405', label: '魏庄村' },
              { value: '061769406', label: '西屯村' },
              { value: '061769407', label: '坊子村' },
              { value: '061769408', label: '季庄村' },
              { value: '061769409', label: '果园刘村' },
              { value: '061769410', label: '兴隆村' },
              { value: '061769411', label: '东腰站村' },
              { value: '061769412', label: '李保元村' },
              { value: '061769413', label: '臧庄村' },
              { value: '061769414', label: '孔贯村' },
              { value: '061769415', label: '沈庄村' },
              { value: '061769416', label: '孟庄村' },
              { value: '061769417', label: '西祁村' },
              { value: '061769418', label: '车屯村' },
              { value: '061769419', label: '杨家河口村' },
              { value: '061769420', label: '邱段村' },
              { value: '061769421', label: '李官屯村' },
              { value: '061769422', label: '徐楼村' },
              { value: '061769423', label: '于屯村' },
              { value: '061769424', label: '赵屯村' },
              { value: '061769425', label: '肖庄村' },
              { value: '061769426', label: '王对宇村' },
              { value: '061769427', label: '庙杨村' },
              { value: '061769428', label: '后刘楼村' },
              { value: '061769429', label: '金马村' },
              { value: '061769430', label: '魏楼村' },
              { value: '061769431', label: '井王村' },
              { value: '061769432', label: '许庄村' },
              { value: '061769433', label: '大官村' },
              { value: '061769434', label: '贾宋村' },
              { value: '061769435', label: '龙王庙村' },
              { value: '061769436', label: '南祁村' },
              { value: '061769437', label: '太平村' },
              { value: '061769438', label: '吴庄村' },
              { value: '061769439', label: '岳刘村' },
              { value: '061769440', label: '药王庙村' },
              { value: '061769441', label: '有粮村' },
              { value: '061769442', label: '南街村' },
              { value: '061769443', label: '东元村' },
              { value: '061769444', label: '盐古村' },
              { value: '061769445', label: '小庄村' },
              { value: '061769446', label: '后宋村' },
              { value: '061769447', label: '葛庄村' },
              { value: '061769448', label: '李杨村' },
              { value: '061769449', label: '于科村' },
              { value: '061769450', label: '翟庄村' },
              { value: '061769451', label: '洪张村' },
              { value: '061769452', label: '曹庙村' },
              { value: '061769453', label: '中屯村' },
              { value: '061769454', label: '陈屯村' },
              { value: '061769455', label: '田海子村' },
              { value: '061769456', label: '大杨村' },
              { value: '061769457', label: '张楼村' },
              { value: '061769458', label: '郑刘村' },
              { value: '061769459', label: '马庄村' },
              { value: '061769460', label: '潘庄村' },
              { value: '061769461', label: '李营村' },
              { value: '061769462', label: '孙堂村' },
              { value: '061769463', label: '王西川村' },
              { value: '061769464', label: '前杨村' },
              { value: '061769465', label: '后杨村' },
              { value: '061769466', label: '蜂王村' },
              { value: '061769467', label: '姚庄村' },
              { value: '061769468', label: '鸡鸣王村' },
              { value: '061769469', label: '张庄村' },
              { value: '061769470', label: '赵庄村' },
              { value: '061769471', label: '西街村' },
              { value: '061769472', label: '陈庄村' }
            ]
          },
          {
            value: '0617610',
            label: '焦庙镇',
            children: [
              { value: '061769', label: '宋坊村' },
              { value: '0617610473', label: '东张村' },
              { value: '0617610474', label: '西张村' },
              { value: '0617610475', label: '周庄村' },
              { value: '0617610476', label: '纸营村' },
              { value: '0617610477', label: '黄屯村' },
              { value: '0617610478', label: '曲屯村' },
              { value: '0617610479', label: '李楼村' },
              { value: '0617610480', label: '耿庄村' },
              { value: '0617610481', label: '曹虎村' },
              { value: '0617610482', label: '孙黄村' },
              { value: '0617610483', label: '谯庄村' },
              { value: '0617610484', label: '老菜村' },
              { value: '0617610485', label: '小尹村' },
              { value: '0617610486', label: '王老村' },
              { value: '0617610487', label: '吴庄村' },
              { value: '0617610488', label: '华集村' },
              { value: '0617610489', label: '白庄村' },
              { value: '0617610490', label: '张拱辰村' },
              { value: '0617610491', label: '黑马村' },
              { value: '0617610492', label: '邓庄村' },
              { value: '0617610493', label: '冯庄村' },
              { value: '0617610494', label: '张林西村' },
              { value: '0617610495', label: '杨场村' },
              { value: '0617610496', label: '双庙村' },
              { value: '0617610497', label: '赵官屯村' },
              { value: '0617610498', label: '辛庄村' },
              { value: '0617610499', label: '新马村' },
              { value: '0617610500', label: '路庄村' },
              { value: '0617610501', label: '团元村' },
              { value: '0617610502', label: '钟庄村' },
              { value: '0617610503', label: '前郑村' },
              { value: '0617610504', label: '潘赵村' },
              { value: '0617610505', label: '三合村' },
              { value: '0617610506', label: '吕庄村' },
              { value: '0617610507', label: '解庄村' },
              { value: '0617610508', label: '西贾庄村' },
              { value: '0617610509', label: '洼孙村' },
              { value: '0617610510', label: '冯李村' },
              { value: '0617610511', label: '大孙村' },
              { value: '0617610512', label: '西李楼村' },
              { value: '0617610513', label: '王庄村' },
              { value: '0617610514', label: '小寨村' },
              { value: '0617610515', label: '张杨村' },
              { value: '0617610516', label: '絮庄村' },
              { value: '0617610517', label: '白马村' },
              { value: '0617610518', label: '南北菜村' },
              { value: '0617610519', label: '郭坊村' },
              { value: '0617610520', label: '石门张村' },
              { value: '0617610521', label: '董庄村' },
              { value: '0617610522', label: '炮姜村' },
              { value: '0617610523', label: '席庵村' },
              { value: '0617610524', label: '西姜村' },
              { value: '0617610525', label: '郭窑村' },
              { value: '0617610526', label: '三王村' },
              { value: '0617610527', label: '苇叶村' },
              { value: '0617610528', label: '流水村' },
              { value: '0617610529', label: '杜庄村' },
              { value: '0617610530', label: '老王村' },
              { value: '0617610531', label: '尚庄村' },
              { value: '0617610532', label: '陶庄村' },
              { value: '0617610533', label: '范庄村' },
              { value: '0617610534', label: '东贾庄村' },
              { value: '0617610535', label: '芦庄村' },
              { value: '0617610536', label: '韩庄村' },
              { value: '0617610537', label: '姜堂村' },
              { value: '0617610538', label: '王桥村' },
              { value: '0617610539', label: '相庄村' },
              { value: '0617610540', label: '西袁村' },
              { value: '0617610541', label: '徐弓匠村' },
              { value: '0617610542', label: '李官屯村' },
              { value: '0617610543', label: '小李村' },
              { value: '0617610544', label: '贾市村' },
              { value: '0617610545', label: '十槐村' },
              { value: '0617610546', label: '焦庙村' },
              { value: '0617610547', label: '齐营村' },
              { value: '0617610548', label: '小刘村' },
              { value: '0617610549', label: '马坊村' },
              { value: '0617610550', label: '靛池村' },
              { value: '0617610551', label: '程庄村' },
              { value: '0617610552', label: '许庄村' },
              { value: '0617610553', label: '彭庄村' },
              { value: '0617610554', label: '季中村' },
              { value: '0617610555', label: '季东村' },
              { value: '0617610556', label: '季西村' },
              { value: '0617610557', label: '常庄村' },
              { value: '0617610558', label: '张庄村' },
              { value: '0617610559', label: '黄马村' },
              { value: '0617610560', label: '红庙村' }
            ]
          },
          {
            value: '0617611',
            label: '晏城街道',
            children: [
              { value: '0617610', label: '大魏村' },
              { value: '0617611561', label: '十二里阁村' },
              { value: '0617611562', label: '红庙朱' },
              { value: '0617611563', label: '朱君村' },
              { value: '0617611564', label: '大杨村' },
              { value: '0617611565', label: '河口闫村' },
              { value: '0617611566', label: '毛官屯村' },
              { value: '0617611567', label: '池庄村' },
              { value: '0617611568', label: '鲍庄村' },
              { value: '0617611569', label: '晏城街村' },
              { value: '0617611570', label: '小魏村' },
              { value: '0617611571', label: '西寨村' },
              { value: '0617611572', label: '三合村' },
              { value: '0617611573', label: '前甄村' },
              { value: '0617611574', label: '孟孙村' },
              { value: '0617611575', label: '孟铺村' },
              { value: '0617611576', label: '老肖村' },
              { value: '0617611577', label: '东宋村' },
              { value: '0617611578', label: '孟井村' },
              { value: '0617611579', label: '小赵村' },
              { value: '0617611580', label: '兴隆村' },
              { value: '0617611581', label: '小王村' },
              { value: '0617611582', label: '东寨村' },
              { value: '0617611583', label: '后甄村' },
              { value: '0617611584', label: '小高村' },
              { value: '0617611585', label: '小杨村' },
              { value: '0617611586', label: '东辛村' },
              { value: '0617611587', label: '北郭村' },
              { value: '0617611588', label: '王庄村' },
              { value: '0617611589', label: '赫庄村' },
              { value: '0617611590', label: '岔河杨村' },
              { value: '0617611591', label: '鲍西村' },
              { value: '0617611592', label: '小郭村' },
              { value: '0617611593', label: '鲍东村' },
              { value: '0617611594', label: '狮子张村' },
              { value: '0617611595', label: '姜屯村' },
              { value: '0617611596', label: '葛李村' },
              { value: '0617611597', label: '中寨村' },
              { value: '0617611598', label: '朱楼村' },
              { value: '0617611599', label: '三王村' },
              { value: '0617611600', label: '大冀村' },
              { value: '0617611601', label: '小冀村' },
              { value: '0617611602', label: '小营村' },
              { value: '0617611603', label: '张相村' }
            ]
          },
          {
            value: '0617612',
            label: '晏北街道',
            children: [
              { value: '0617611', label: '桑园赵村' },
              { value: '0617612604', label: '火把张村' },
              { value: '0617612605', label: '韩庄村' },
              { value: '0617612606', label: '杜东村' },
              { value: '0617612607', label: '刘安村' },
              { value: '0617612608', label: '小辛村' },
              { value: '0617612609', label: '瓦屋店村' },
              { value: '0617612610', label: '纯李村' },
              { value: '0617612611', label: '汤庄村' },
              { value: '0617612612', label: '瓦宋村' },
              { value: '0617612613', label: '马庄（南）村' },
              { value: '0617612614', label: '孙庄村' },
              { value: '0617612615', label: '双庙杨村' },
              { value: '0617612616', label: '河李村' },
              { value: '0617612617', label: '西魏村' },
              { value: '0617612618', label: '姚庄村' },
              { value: '0617612619', label: '小黄村' },
              { value: '0617612620', label: '北孙村' },
              { value: '0617612621', label: '梯门村' },
              { value: '0617612622', label: '栗庄村' },
              { value: '0617612623', label: '袁辛村' },
              { value: '0617612624', label: '小崔村' },
              { value: '0617612625', label: '老徐村' },
              { value: '0617612626', label: '谭策屯村' },
              { value: '0617612627', label: '法王村' },
              { value: '0617612628', label: '葛庄村' },
              { value: '0617612629', label: '陈庄（北）村' },
              { value: '0617612630', label: '后寺村' },
              { value: '0617612631', label: '北魏村' },
              { value: '0617612632', label: '徐坊村' },
              { value: '0617612633', label: '楼子张村' },
              { value: '0617612634', label: '东高村' },
              { value: '0617612635', label: '西高村' },
              { value: '0617612636', label: '全玉村' },
              { value: '0617612637', label: '安付村' },
              { value: '0617612638', label: '刘庙村' },
              { value: '0617612639', label: '福王村' },
              { value: '0617612640', label: '王老实村' },
              { value: '0617612641', label: '王良村' },
              { value: '0617612642', label: '双庙宋村' },
              { value: '0617612643', label: '大费村' },
              { value: '0617612644', label: '丁庄村' },
              { value: '0617612645', label: '南街村' },
              { value: '0617612646', label: '北街村' },
              { value: '0617612647', label: '安辛村' },
              { value: '0617612648', label: '王庄村' },
              { value: '0617612649', label: '豆腐匠村' },
              { value: '0617612650', label: '高官村' },
              { value: '0617612651', label: '马杜村' },
              { value: '0617612652', label: '芦庄村' },
              { value: '0617612653', label: '赵庄村' },
              { value: '0617612654', label: '郝庄村' },
              { value: '0617612655', label: '马庄（北）村' },
              { value: '0617612656', label: '周庄村' },
              { value: '0617612657', label: '老刘村' },
              { value: '0617612658', label: '柳杭村' },
              { value: '0617612659', label: '马官村' },
              { value: '0617612660', label: '小安村' },
              { value: '0617612661', label: '黄铺村' },
              { value: '0617612662', label: '义和村' },
              { value: '0617612663', label: '刘明村' },
              { value: '0617612664', label: '袁庄村' },
              { value: '0617612665', label: '鲍官村' },
              { value: '0617612666', label: '马庄（东）村' },
              { value: '0617612667', label: '宗吴村' },
              { value: '0617612668', label: '高庄村' },
              { value: '0617612669', label: '蔡王村' },
              { value: '0617612670', label: '前后随村' },
              { value: '0617612671', label: '蔡东村' },
              { value: '0617612672', label: '蔡西村' },
              { value: '0617612673', label: '大漠刘村' },
              { value: '0617612674', label: '李官村' },
              { value: '0617612675', label: '贾庄村' },
              { value: '0617612676', label: '刘庄村' },
              { value: '0617612677', label: '刘善村' },
              { value: '0617612678', label: '徐屯村' },
              { value: '0617612679', label: '石庙村' },
              { value: '0617612680', label: '林庄村' },
              { value: '0617612681', label: '柳东村' },
              { value: '0617612682', label: '小费村' },
              { value: '0617612683', label: '陈庄（东）村' },
              { value: '0617612684', label: '小代村' },
              { value: '0617612685', label: '杜西村' },
              { value: '0617612686', label: '柳西村' },
              { value: '0617612687', label: '辛法村' },
              { value: '0617612688', label: '唐庄村' },
              { value: '0617612689', label: '碱场村' },
              { value: '0617612690', label: '胡官村' }
            ]
          },
          {
            value: '0617613',
            label: '马集镇',
            children: [
              { value: '0617612', label: '石拐村' },
              { value: '0617613691', label: '油坊村' },
              { value: '0617613692', label: '孙庄村' },
              { value: '0617613693', label: '齐庄村' },
              { value: '0617613694', label: '方翟村' },
              { value: '0617613695', label: '北方寺村' },
              { value: '0617613696', label: '小辛村' },
              { value: '0617613697', label: '南方寺村' },
              { value: '0617613698', label: '杨孟村' },
              { value: '0617613699', label: '杨庄村' },
              { value: '0617613700', label: '娄集村' },
              { value: '0617613701', label: '西侯村' },
              { value: '0617613702', label: '韩庄村' },
              { value: '0617613703', label: '后郑村' },
              { value: '0617613704', label: '秋王村' },
              { value: '0617613705', label: '周庄村' },
              { value: '0617613706', label: '后刘村' },
              { value: '0617613707', label: '顾道口村' },
              { value: '0617613708', label: '西郑村' },
              { value: '0617613709', label: '西代村' },
              { value: '0617613710', label: '马集村' },
              { value: '0617613711', label: '燕庄村' },
              { value: '0617613712', label: '东张村' },
              { value: '0617613713', label: '北五庙村' },
              { value: '0617613714', label: '大辛村' },
              { value: '0617613715', label: '东代村' },
              { value: '0617613716', label: '前刘村' },
              { value: '0617613717', label: '宋庄村' },
              { value: '0617613718', label: '闫庄村' },
              { value: '0617613719', label: '尹庄村' },
              { value: '0617613720', label: '南五庙村' },
              { value: '0617613721', label: '东朱村' },
              { value: '0617613722', label: '李岿村' },
              { value: '0617613723', label: '邱集村' },
              { value: '0617613724', label: '潘庄村' },
              { value: '0617613725', label: '路庄村' },
              { value: '0617613726', label: '石庙杨村' },
              { value: '0617613727', label: '吴庄村' },
              { value: '0617613728', label: '东侯村' },
              { value: '0617613729', label: '西朱村' },
              { value: '0617613730', label: '红堂村' },
              { value: '0617613731', label: '西张村' },
              { value: '0617613732', label: '东郑村' },
              { value: '0617613733', label: '苑庄村' },
              { value: '0617613734', label: '封官村' },
              { value: '0617613735', label: '王楼村' },
              { value: '0617613736', label: '雷屯村' },
              { value: '0617613737', label: '赵庄村' }
            ]
          },
          {
            value: '0617614',
            label: '表白寺镇',
            children: [
              { value: '0617613', label: '崔许村' },
              { value: '0617614738', label: '古庙村' },
              { value: '0617614739', label: '谭家村' },
              { value: '0617614740', label: '西小刘村' },
              { value: '0617614741', label: '孙东村' },
              { value: '0617614742', label: '小董村' },
              { value: '0617614743', label: '钱家村' },
              { value: '0617614744', label: '张举西村' },
              { value: '0617614745', label: '红庙李村' },
              { value: '0617614746', label: '盐店村' },
              { value: '0617614747', label: '魏家村' },
              { value: '0617614748', label: '北陈村' },
              { value: '0617614749', label: '东于门村' },
              { value: '0617614750', label: '南陈村' },
              { value: '0617614751', label: '大周村' },
              { value: '0617614752', label: '王家村' },
              { value: '0617614753', label: '东小刘村' },
              { value: '0617614754', label: '韩楼村' },
              { value: '0617614755', label: '潘郝村' },
              { value: '0617614756', label: '三里村' },
              { value: '0617614757', label: '梁家村' },
              { value: '0617614758', label: '小李村' },
              { value: '0617614759', label: '表白寺村' },
              { value: '0617614760', label: '孙北村' },
              { value: '0617614761', label: '孙西村' },
              { value: '0617614762', label: '老聂村' },
              { value: '0617614763', label: '小聂村' },
              { value: '0617614764', label: '后孙村' },
              { value: '0617614765', label: '西于门村' },
              { value: '0617614766', label: '赵席村' },
              { value: '0617614767', label: '李见村' },
              { value: '0617614768', label: '张沛村' },
              { value: '0617614769', label: '李英村' },
              { value: '0617614770', label: '生家村' },
              { value: '0617614771', label: '前杨村' },
              { value: '0617614772', label: '贾庄村' },
              { value: '0617614773', label: '彦家村' },
              { value: '0617614774', label: '单家村' },
              { value: '0617614775', label: '刁家村' },
              { value: '0617614776', label: '后杨村' },
              { value: '0617614777', label: '小张村' },
              { value: '0617614778', label: '小代村' },
              { value: '0617614779', label: '张举东村' },
              { value: '0617614780', label: '张举中村' },
              { value: '0617614781', label: '大代村' },
              { value: '0617614782', label: '小营村' },
              { value: '0617614783', label: '袁家村' },
              { value: '0617614784', label: '前孙村' },
              { value: '0617614785', label: '官家村' },
              { value: '0617614786', label: '张铁锅村' },
              { value: '0617614787', label: '孔家村' },
              { value: '0617614788', label: '朱家村' },
              { value: '0617614789', label: '义和村' },
              { value: '0617614790', label: '后于门村' },
              { value: '0617614791', label: '簸箕匠村' }
            ]
          },
          {
            value: '0617615',
            label: '仁里集镇',
            children: [
              { value: '0617614', label: '后刘村' },
              { value: '0617615792', label: '姚庄村' },
              { value: '0617615793', label: '西柴村' },
              { value: '0617615794', label: '郭庄村' },
              { value: '0617615795', label: '前刘村' },
              { value: '0617615796', label: '犍子张村' },
              { value: '0617615797', label: '史庄村' },
              { value: '0617615798', label: '仁东村' },
              { value: '0617615799', label: '仁南村' },
              { value: '0617615800', label: '仁西村' },
              { value: '0617615801', label: '东李村' },
              { value: '0617615802', label: '梁庄村' },
              { value: '0617615803', label: '王东村' },
              { value: '0617615804', label: '王西村' },
              { value: '0617615805', label: '王南村' },
              { value: '0617615806', label: '王北村' },
              { value: '0617615807', label: '刘庄村' },
              { value: '0617615808', label: '荣庄村' },
              { value: '0617615809', label: '菜园村' },
              { value: '0617615810', label: '曼庄村' },
              { value: '0617615811', label: '边庄村' },
              { value: '0617615812', label: '左庄村' },
              { value: '0617615813', label: '前屯村' },
              { value: '0617615814', label: '后屯村' },
              { value: '0617615815', label: '马庄村' },
              { value: '0617615816', label: '律墓赵村' },
              { value: '0617615817', label: '大张村' },
              { value: '0617615818', label: '东张村' },
              { value: '0617615819', label: '翟寺村' },
              { value: '0617615820', label: '索庄村' },
              { value: '0617615821', label: '肖姚村' },
              { value: '0617615822', label: '前王村' },
              { value: '0617615823', label: '后王村' },
              { value: '0617615824', label: '董营子村' },
              { value: '0617615825', label: '郑营子村' },
              { value: '0617615826', label: '尚庄村' },
              { value: '0617615827', label: '朱庄村' },
              { value: '0617615828', label: '南张村' },
              { value: '0617615829', label: '黄楼村' },
              { value: '0617615830', label: '高赵村' },
              { value: '0617615831', label: '李集村' },
              { value: '0617615832', label: '桑海子村' },
              { value: '0617615833', label: '王堂村' },
              { value: '0617615834', label: '郑坊村' },
              { value: '0617615835', label: '大柴村' },
              { value: '0617615836', label: '柴洼村' },
              { value: '0617615837', label: '后宋村' },
              { value: '0617615838', label: '后燕村' },
              { value: '0617615839', label: '前宋村' },
              { value: '0617615840', label: '前燕村' },
              { value: '0617615841', label: '周庄村' },
              { value: '0617615842', label: '段庄村' },
              { value: '0617615843', label: '靖池村' },
              { value: '0617615844', label: '三合村' },
              { value: '0617615845', label: '石围子村' },
              { value: '0617615846', label: '苏塘子村' },
              { value: '0617615847', label: '张塘子村' },
              { value: '0617615848', label: '西李村' },
              { value: '0617615849', label: '牛庄村' },
              { value: '0617615850', label: '北王村' },
              { value: '0617615851', label: '松林赵村' },
              { value: '0617615852', label: '曹庄村' },
              { value: '0617615853', label: '郑庄村' },
              { value: '0617615854', label: '董集村' },
              { value: '0617615855', label: '孙庄村' },
              { value: '0617615856', label: '国庄村' },
              { value: '0617615857', label: '黄庄村' },
              { value: '0617615858', label: '蒋庄村' },
              { value: '0617615859', label: '靳庄村' },
              { value: '0617615860', label: '客王村' },
              { value: '0617615861', label: '梅庄村' },
              { value: '0617615862', label: '牛集村' },
              { value: '0617615863', label: '田东村' },
              { value: '0617615864', label: '田西村' },
              { value: '0617615865', label: '东潘村' },
              { value: '0617615866', label: '官庄村' },
              { value: '0617615867', label: '辛北村' },
              { value: '0617615868', label: '辛东村' },
              { value: '0617615869', label: '辛南村' },
              { value: '0617615870', label: '辛铺村' },
              { value: '0617615871', label: '辛西村' },
              { value: '0617615872', label: '辛中村' },
              { value: '0617615873', label: '魏庄村' },
              { value: '0617615874', label: '南潘村' },
              { value: '0617615875', label: '西高村' },
              { value: '0617615876', label: '大高村' },
              { value: '0617615877', label: '宋集村' },
              { value: '0617615878', label: '西刘村' },
              { value: '0617615879', label: '汝庄村' },
              { value: '0617615880', label: '武庄村' },
              { value: '0617615881', label: '张铺村' },
              { value: '0617615882', label: '北泮村' },
              { value: '0617615883', label: '枣杨村' },
              { value: '0617615884', label: '大田村' },
              { value: '0617615885', label: '石桥村' },
              { value: '0617615886', label: '花赵村' },
              { value: '0617615887', label: '魏官村' },
              { value: '0617615888', label: '韩胡村' },
              { value: '0617615889', label: '东王村' }
            ]
          },
          {
            value: '0617616',
            label: '赵官镇',
            children: [
              { value: '0617615', label: '大徐村' },
              { value: '0617616890', label: '付庄村' },
              { value: '0617616891', label: '刘庄村' },
              { value: '0617616892', label: '北二村' },
              { value: '0617616893', label: '银杏树村' },
              { value: '0617616894', label: '于宅子村' },
              { value: '0617616895', label: '大马头村' },
              { value: '0617616896', label: '古河村' },
              { value: '0617616897', label: '水西村' },
              { value: '0617616898', label: '刘集西村' },
              { value: '0617616899', label: '刘集东村' },
              { value: '0617616900', label: '董家寺村' },
              { value: '0617616901', label: '程官庄村' },
              { value: '0617616902', label: '东街村' },
              { value: '0617616903', label: '李全庄村' },
              { value: '0617616904', label: '靖庄村' },
              { value: '0617616905', label: '邢庄村' },
              { value: '0617616906', label: '葛庄村' },
              { value: '0617616907', label: '黄口村' },
              { value: '0617616908', label: '小胡村' },
              { value: '0617616909', label: '西街村' },
              { value: '0617616910', label: '小王村' },
              { value: '0617616911', label: '西尹村' },
              { value: '0617616912', label: '西韩村' },
              { value: '0617616913', label: '季北王村' },
              { value: '0617616914', label: '刘黄村' },
              { value: '0617616915', label: '张庄村' },
              { value: '0617616916', label: '东何村' },
              { value: '0617616917', label: '小马头村' },
              { value: '0617616918', label: '东韩村' },
              { value: '0617616919', label: '吴庄村' },
              { value: '0617616920', label: '东尹村' },
              { value: '0617616921', label: '孟宅村' },
              { value: '0617616922', label: '北一村' },
              { value: '0617616923', label: '南街村' },
              { value: '0617616924', label: '律北村' },
              { value: '0617616925', label: '邵庄村' },
              { value: '0617616926', label: '小郭村' },
              { value: '0617616927', label: '冯厅村' },
              { value: '0617616928', label: '东水坡村' },
              { value: '0617616929', label: '邱庄村' },
              { value: '0617616930', label: '崔桥村' },
              { value: '0617616931', label: '官庄村' },
              { value: '0617616932', label: '南何村' },
              { value: '0617616933', label: '律东村' },
              { value: '0617616934', label: '律西村' },
              { value: '0617616935', label: '水东村' },
              { value: '0617616936', label: '崔庄村' },
              { value: '0617616937', label: '王厅村' },
              { value: '0617616938', label: '西赵村' },
              { value: '0617616939', label: '董桥村' },
              { value: '0617616940', label: '阮庄村' },
              { value: '0617616941', label: '大胡村' },
              { value: '0617616942', label: '东赵村' },
              { value: '0617616943', label: '周娄村' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '07',
    label: '临邑县',
    children: [
      {
        value: '07187',
        label: '临邑县',
        children: [
          {
            value: '071872',
            label: '临邑县恒源街道',
            children: [
              { value: '071871', label: '柳行新村' },
              { value: '0718721', label: '三里河村' },
              { value: '0718722', label: '后仓新村' },
              { value: '0718723', label: '恒旗村' },
              { value: '0718724', label: '张庙联村' },
              { value: '0718725', label: '恒新村' },
              { value: '0718726', label: '恒丰村' },
              { value: '0718727', label: '馨园社区' },
              { value: '0718728', label: '草寺村' },
              { value: '0718729', label: '十里堡村' },
              { value: '07187210', label: '毛张村' },
              { value: '07187211', label: '张油官村' },
              { value: '07187212', label: '大孙村' },
              { value: '07187213', label: '李官道村' },
              { value: '07187214', label: '刘波海村' },
              { value: '07187215', label: '刘家村' },
              { value: '07187216', label: '崔家村' },
              { value: '07187217', label: '龙湾村' },
              { value: '07187218', label: '牛家村' },
              { value: '07187219', label: '后八里村' },
              { value: '07187220', label: '崔老村' },
              { value: '07187221', label: '梆子村' },
              { value: '07187222', label: '汤家村' },
              { value: '07187223', label: '于庙村' },
              { value: '07187224', label: '大柳树村' },
              { value: '07187225', label: '乔家村' },
              { value: '07187226', label: '李家胡同村' },
              { value: '07187227', label: '梁家村' },
              { value: '07187228', label: '沙河村' },
              { value: '07187229', label: '张圣村' },
              { value: '07187230', label: '辛庄村' },
              { value: '07187231', label: '前仓村' },
              { value: '07187232', label: '大卢村' },
              { value: '07187233', label: '陈庙村' },
              { value: '07187234', label: '前八里村' }
            ]
          },
          {
            value: '071873',
            label: '临邑县邢侗街道',
            children: [
              { value: '071872', label: '洛源新村' },
              { value: '07187335', label: '五福苑新村' },
              { value: '07187336', label: '同昶新村' },
              { value: '07187337', label: '开元新村' },
              { value: '07187338', label: '同曦新村' },
              { value: '07187339', label: '同旭新村' },
              { value: '07187340', label: '瑞恒社区' },
              { value: '07187341', label: '凯旋社区' },
              { value: '07187342', label: '广场社区' },
              { value: '07187343', label: '鑫兴社区' },
              { value: '07187344', label: '明德社区' }
            ]
          },
          {
            value: '071874',
            label: '临邑县临盘街道',
            children: [
              { value: '071873', label: '崔大新村' },
              { value: '07187445', label: '刘庙新村' },
              { value: '07187446', label: '大杨新村' },
              { value: '07187447', label: '盘河新村' },
              { value: '07187448', label: '高家新村' },
              { value: '07187449', label: '集贤新村' },
              { value: '07187450', label: '门刘新村' },
              { value: '07187451', label: '太平新村' },
              { value: '07187452', label: '任家新村' },
              { value: '07187453', label: '夏家新村' },
              { value: '07187454', label: '马璋寨新村' },
              { value: '07187455', label: '肖家新村' },
              { value: '07187456', label: '辛集新村' },
              { value: '07187457', label: '曹店新村' },
              { value: '07187458', label: '贺家新村' },
              { value: '07187459', label: '牛角店新村' },
              { value: '07187460', label: '尚德新村' },
              { value: '07187461', label: '袁郑新村' },
              { value: '07187462', label: '毕寨新村' },
              { value: '07187463', label: '兴德新村' },
              { value: '07187464', label: '前杨新村' },
              { value: '07187465', label: '曙光社区' },
              { value: '07187466', label: '宏宇社区' },
              { value: '07187467', label: '宏达社区' }
            ]
          },
          {
            value: '071875',
            label: '临邑县临邑镇',
            children: [
              { value: '071874', label: '陈赵新村' },
              { value: '07187568', label: '和谐新村' },
              { value: '07187569', label: '廉家村' },
              { value: '07187570', label: '李吴村' },
              { value: '07187571', label: '幸福村' },
              { value: '07187572', label: '团结村' },
              { value: '07187573', label: '华安村' },
              { value: '07187574', label: '永盛村' },
              { value: '07187575', label: '李仙台联合新村' },
              { value: '07187576', label: '利民村' },
              { value: '07187577', label: '大小陈村' },
              { value: '07187578', label: '庞祥新村' },
              { value: '07187579', label: '五联新村' },
              { value: '07187580', label: '常寨吴村' },
              { value: '07187581', label: '陶苏村' },
              { value: '07187582', label: '苏望村' },
              { value: '07187583', label: '兴和苑新村' },
              { value: '07187584', label: '李寨村' },
              { value: '07187585', label: '国寨村' },
              { value: '07187586', label: '钟家村' },
              { value: '07187587', label: '季寨村' },
              { value: '07187588', label: '王草村' },
              { value: '07187589', label: '毛家村' },
              { value: '07187590', label: '后凡村' },
              { value: '07187591', label: '卞庙村' },
              { value: '07187592', label: '前凡村' },
              { value: '07187593', label: '后关村' },
              { value: '07187594', label: '崔湾村' },
              { value: '07187595', label: '前关村' },
              { value: '07187596', label: '李耀明村' },
              { value: '07187597', label: '大韩村' },
              { value: '07187598', label: '石洼村' },
              { value: '07187599', label: '北石村' },
              { value: '071875100', label: '洼里王' },
              { value: '071875101', label: '毛寺村' },
              { value: '071875102', label: '宋庙村' },
              { value: '071875103', label: '寇家村' },
              { value: '071875104', label: '赵家村（毛寺）' },
              { value: '071875105', label: '靳家村' },
              { value: '071875106', label: '东邢村' },
              { value: '071875107', label: '西邢村' },
              { value: '071875108', label: '白庙村' },
              { value: '071875109', label: '宋家村' },
              { value: '071875110', label: '齐官寨村' },
              { value: '071875111', label: '孙家村' },
              { value: '071875112', label: '张法古村' },
              { value: '071875113', label: '任楼村' },
              { value: '071875114', label: '朱家胡同村' },
              { value: '071875115', label: '赵家村' },
              { value: '071875116', label: '八里庙村' },
              { value: '071875117', label: '老马家村' },
              { value: '071875118', label: '张家村' },
              { value: '071875119', label: '东孙庙村' },
              { value: '071875120', label: '刘道行村' },
              { value: '071875121', label: '郑家村' },
              { value: '071875122', label: '张木村' },
              { value: '071875123', label: '西孙庙村' },
              { value: '071875124', label: '高家村' },
              { value: '071875125', label: '杨家村' },
              { value: '071875126', label: '毕家村' },
              { value: '071875127', label: '演马村' }
            ]
          },
          {
            value: '071876',
            label: '临邑县德平镇                 ',
            children: [
              { value: '071875', label: '宫屯村' },
              { value: '071876128', label: '茄子李村' },
              { value: '071876129', label: '王赞恒村' },
              { value: '071876130', label: '郭桥村' },
              { value: '071876131', label: '陈寨村' },
              { value: '071876132', label: '曹徐新村' },
              { value: '071876133', label: '郭湾新村' },
              { value: '071876134', label: '满家新村' },
              { value: '071876135', label: '团结新村' },
              { value: '071876136', label: '和谐新村' },
              { value: '071876137', label: '振兴联村' },
              { value: '071876138', label: '碱场李村' },
              { value: '071876139', label: '友谊村' },
              { value: '071876140', label: '丁王新村' },
              { value: '071876141', label: '郭杨新村' },
              { value: '071876142', label: '单家村' },
              { value: '071876143', label: '陈王庄村' },
              { value: '071876144', label: '三联庙村' },
              { value: '071876145', label: '崔刘范村' },
              { value: '071876146', label: '龙泉新村' },
              { value: '071876147', label: '闫家新村' },
              { value: '071876148', label: '静家联村' },
              { value: '071876149', label: '八里庄村' },
              { value: '071876150', label: '十里新村' },
              { value: '071876151', label: '林寨新村' },
              { value: '071876152', label: '大刘新村' },
              { value: '071876153', label: '崇德新村' },
              { value: '071876154', label: '明家联合新村' },
              { value: '071876155', label: '大鲍村' },
              { value: '071876156', label: '夏屯村' },
              { value: '071876157', label: '张茂寒村' },
              { value: '071876158', label: '曹冢新村' },
              { value: '071876159', label: '高王庄村' },
              { value: '071876160', label: '炉房新村' },
              { value: '071876161', label: '养马新村' },
              { value: '071876162', label: '王朝阳新村' },
              { value: '071876163', label: '葛老庄新村' }
            ]
          },
          {
            value: '071877',
            label: '临邑县临南镇',
            children: [
              { value: '071876', label: '李屯新村' },
              { value: '071877164', label: '旭升新村' },
              { value: '071877165', label: '双丰新村' },
              { value: '071877166', label: '同心新村' },
              { value: '071877167', label: '富源新村' },
              { value: '071877168', label: '刘屯新村' },
              { value: '071877169', label: '边马新村' },
              { value: '071877170', label: '和谐新村' },
              { value: '071877171', label: '齐心新村' },
              { value: '071877172', label: '周徐新村' },
              { value: '071877173', label: '杜苗新村' },
              { value: '071877174', label: '胜利新村' },
              { value: '071877175', label: '双庙新村' },
              { value: '071877176', label: '夏口新村' },
              { value: '071877177', label: '石家村' },
              { value: '071877178', label: '广旺村' },
              { value: '071877179', label: '杨香村' },
              { value: '071877180', label: '宁楼村' },
              { value: '071877181', label: '解家村' },
              { value: '071877182', label: '吴马村' },
              { value: '071877183', label: '朱楼村' },
              { value: '071877184', label: '王楼村' },
              { value: '071877185', label: '钟楼村' },
              { value: '071877186', label: '宋洼庄村' },
              { value: '071877187', label: '太平辛村' },
              { value: '071877188', label: '王寨村' },
              { value: '071877189', label: '李集村' },
              { value: '071877190', label: '王圈村' },
              { value: '071877191', label: '常家村' },
              { value: '071877192', label: '宁寺村' },
              { value: '071877193', label: '于辛庄村' },
              { value: '071877194', label: '马道口村' },
              { value: '071877195', label: '周道口村' },
              { value: '071877196', label: '马呈黄村' },
              { value: '071877197', label: '李庙村' },
              { value: '071877198', label: '韩家村' },
              { value: '071877199', label: '齐集村' },
              { value: '071877200', label: '王家村' },
              { value: '071877201', label: '宋家村' },
              { value: '071877202', label: '火把张村' },
              { value: '071877203', label: '张站吴村' },
              { value: '071877204', label: '于庙村' },
              { value: '071877205', label: '小洼村' },
              { value: '071877206', label: '刘双庙村' },
              { value: '071877207', label: '夏河沟村' },
              { value: '071877208', label: '白官庄村' },
              { value: '071877209', label: '张牧羊村' },
              { value: '071877210', label: '牛毛徐村' },
              { value: '071877211', label: '清凉店村' },
              { value: '071877212', label: '赵家村' },
              { value: '071877213', label: '李佛头村' },
              { value: '071877214', label: '马坡村' },
              { value: '071877215', label: '才庙村' },
              { value: '071877216', label: '李家村' }
            ]
          },
          {
            value: '071878',
            label: '临邑县林子镇',
            children: [
              { value: '071877', label: '榆林一区' },
              { value: '071878217', label: '河畔新村' },
              { value: '071878218', label: '榆林二区' },
              { value: '071878219', label: '站北新村' },
              { value: '071878220', label: '孙张村' },
              { value: '071878221', label: '天庙村' },
              { value: '071878222', label: '官道村' },
              { value: '071878223', label: '双兴村' },
              { value: '071878224', label: '双张村' },
              { value: '071878225', label: '连四庄村' },
              { value: '071878226', label: '马章寨村' },
              { value: '071878227', label: '李元寨村' },
              { value: '071878228', label: '梨杭村' },
              { value: '071878229', label: '刘北辰村' },
              { value: '071878230', label: '刘双槐村' },
              { value: '071878231', label: '李道士村' },
              { value: '071878232', label: '徐店村' },
              { value: '071878233', label: '马寺村' },
              { value: '071878234', label: '于家村' },
              { value: '071878235', label: '信家村' },
              { value: '071878236', label: '朱二歪村' },
              { value: '071878237', label: '林子街村' },
              { value: '071878238', label: '郑家村' },
              { value: '071878239', label: '大庞村' },
              { value: '071878240', label: '宋家村' },
              { value: '071878241', label: '赵龙岗村' },
              { value: '071878242', label: '苗甫庵村' },
              { value: '071878243', label: '西郑村' }
            ]
          },
          {
            value: '071879',
            label: '临邑县兴隆镇',
            children: [
              { value: '071878', label: '兴隆村' },
              { value: '071879244', label: '前寨村' },
              { value: '071879245', label: '彭边村' },
              { value: '071879246', label: '王志会' },
              { value: '071879247', label: '王坊村' },
              { value: '071879248', label: '振兴新村' },
              { value: '071879249', label: '段店村' },
              { value: '071879250', label: '五福源' },
              { value: '071879251', label: '苗屯村' },
              { value: '071879252', label: '唐庙村' },
              { value: '071879253', label: '后坊村' },
              { value: '071879254', label: '东马村' },
              { value: '071879255', label: '王家村' },
              { value: '071879256', label: '化家村' },
              { value: '071879257', label: '范家村' },
              { value: '071879258', label: '张天玉' },
              { value: '071879259', label: '张刘徐' },
              { value: '071879260', label: '西袁联' },
              { value: '071879261', label: '西寨村' },
              { value: '071879262', label: '东寨村' },
              { value: '071879263', label: '王花村' },
              { value: '071879264', label: '祁家村' },
              { value: '071879265', label: '宋家村' },
              { value: '071879266', label: '北魏村' },
              { value: '071879267', label: '季寨村' },
              { value: '071879268', label: '任寨村' },
              { value: '071879269', label: '纸坊村' },
              { value: '071879270', label: '闫家村' },
              { value: '071879271', label: '田口村' },
              { value: '071879272', label: '王相村' },
              { value: '071879273', label: '汪家村' },
              { value: '071879274', label: '史家村' },
              { value: '071879275', label: '杨家村' },
              { value: '071879276', label: '南魏村' },
              { value: '071879277', label: '高家村' },
              { value: '071879278', label: '郭集村' },
              { value: '071879279', label: '孟家村' },
              { value: '071879280', label: '郎家村' },
              { value: '071879281', label: '刘友村' },
              { value: '071879282', label: '王孝吴' },
              { value: '071879283', label: '黄召村' },
              { value: '071879284', label: '刘辛村' },
              { value: '071879285', label: '老屯村' },
              { value: '071879286', label: '冯屯村' },
              { value: '071879287', label: '夏三屯' },
              { value: '071879288', label: '小辛庄' },
              { value: '071879289', label: '车芦徐' }
            ]
          },
          {
            value: '0718710',
            label: '临邑县孟寺镇',
            children: [
              { value: '071879', label: '聂李村' },
              { value: '0718710290', label: '胡庙村' },
              { value: '0718710291', label: '贾家联村' },
              { value: '0718710292', label: '王母店村' },
              { value: '0718710293', label: '坊康村' },
              { value: '0718710294', label: '沙洼村' },
              { value: '0718710295', label: '袁姚村' },
              { value: '0718710296', label: '刘于村' },
              { value: '0718710297', label: '芳华村' },
              { value: '0718710298', label: '和美村' },
              { value: '0718710299', label: '解福里村' },
              { value: '0718710300', label: '刘寨村' },
              { value: '0718710301', label: '东方新居' },
              { value: '0718710302', label: '安康村' },
              { value: '0718710303', label: '肖武村' },
              { value: '0718710304', label: '周韩村' },
              { value: '0718710305', label: '崔曹村' },
              { value: '0718710306', label: '孙马村' },
              { value: '0718710307', label: '孟寺村' },
              { value: '0718710308', label: '李官村' },
              { value: '0718710309', label: '崔马村' },
              { value: '0718710310', label: '巩家村' },
              { value: '0718710311', label: '蒋家村' },
              { value: '0718710312', label: '小解村' },
              { value: '0718710313', label: '王书村' },
              { value: '0718710314', label: '耿辛村' },
              { value: '0718710315', label: '耿刘村' },
              { value: '0718710316', label: '刘楼村' },
              { value: '0718710317', label: '中店村' },
              { value: '0718710318', label: '宁家村' },
              { value: '0718710319', label: '西店村' },
              { value: '0718710320', label: '东店村' },
              { value: '0718710321', label: '东张村' },
              { value: '0718710322', label: '被马村' },
              { value: '0718710323', label: '刘家村' },
              { value: '0718710324', label: '岳王石村' },
              { value: '0718710325', label: '北崔村' },
              { value: '0718710326', label: '赵家村' },
              { value: '0718710327', label: '孔家村' },
              { value: '0718710328', label: '程家村' },
              { value: '0718710329', label: '堤口陈村' },
              { value: '0718710330', label: '前范村' },
              { value: '0718710331', label: '后范村' },
              { value: '0718710332', label: '大马湾村' },
              { value: '0718710333', label: '杨寿村' },
              { value: '0718710334', label: '朴张村' },
              { value: '0718710335', label: '张六村' },
              { value: '0718710336', label: '马保村' },
              { value: '0718710337', label: '油坊村' },
              { value: '0718710338', label: '昝家村' },
              { value: '0718710339', label: '枣园村' },
              { value: '0718710340', label: '营子村' },
              { value: '0718710341', label: '孙安村' },
              { value: '0718710342', label: '南北庄村' },
              { value: '0718710343', label: '郑家村' },
              { value: '0718710344', label: '大孙村' },
              { value: '0718710345', label: '南梁村' },
              { value: '0718710346', label: '寄庄户村' }
            ]
          },
          {
            value: '0718711',
            label: '临邑县翟家镇',
            children: [
              { value: '0718710', label: '徐理还村' },
              { value: '0718711347', label: '吴田村' },
              { value: '0718711348', label: '周家村' },
              { value: '0718711349', label: '马家村' },
              { value: '0718711350', label: '孟王村' },
              { value: '0718711351', label: '四联村' },
              { value: '0718711352', label: '四合村' },
              { value: '0718711353', label: '赵王村' },
              { value: '0718711354', label: '解吴村' },
              { value: '0718711355', label: '宫家新村' },
              { value: '0718711356', label: '翟家新村' },
              { value: '0718711357', label: '小刘家村' },
              { value: '0718711358', label: '后屯村' },
              { value: '0718711359', label: '孙家村' },
              { value: '0718711360', label: '坊子街村' },
              { value: '0718711361', label: '后于村' },
              { value: '0718711362', label: '赵家湾村' },
              { value: '0718711363', label: '高榆树杨村' },
              { value: '0718711364', label: '郑家湾村' },
              { value: '0718711365', label: '前于村' },
              { value: '0718711366', label: '前吴村' },
              { value: '0718711367', label: '金集村' },
              { value: '0718711368', label: '前党村' },
              { value: '0718711369', label: '郭庙村' },
              { value: '0718711370', label: '王营村' },
              { value: '0718711371', label: '贾家村' },
              { value: '0718711372', label: '高家村' },
              { value: '0718711373', label: '董寨村' },
              { value: '0718711374', label: '王舒耀村' },
              { value: '0718711375', label: '小杨家村' },
              { value: '0718711376', label: '前屯村' },
              { value: '0718711377', label: '黄集村' },
              { value: '0718711378', label: '李家村' },
              { value: '0718711379', label: '鲧堤刘村' },
              { value: '0718711380', label: '后党村' }
            ]
          },
          {
            value: '0718712',
            label: '临邑县理合务镇',
            children: [
              { value: '0718711', label: '牛家村' },
              { value: '0718712381', label: '尹家村' },
              { value: '0718712382', label: '王辛村' },
              { value: '0718712383', label: '田寨村' },
              { value: '0718712384', label: '前王村' },
              { value: '0718712385', label: '孙天赐村' },
              { value: '0718712386', label: '林寨联村' },
              { value: '0718712387', label: '孙镇村' },
              { value: '0718712388', label: '唐家村' },
              { value: '0718712389', label: '焦楼村' },
              { value: '0718712390', label: '东宫村' },
              { value: '0718712391', label: '张庙联村' },
              { value: '0718712392', label: '沙于村' },
              { value: '0718712393', label: '姜家村' },
              { value: '0718712394', label: '大蔺家村' },
              { value: '0718712395', label: '王寨联村' },
              { value: '0718712396', label: '理合务街联村' },
              { value: '0718712397', label: '鲁庙联村' },
              { value: '0718712398', label: '谢家联村' },
              { value: '0718712399', label: '田庵联村' },
              { value: '0718712400', label: '夏家联村' },
              {
                value: '0718712401',
                label: '合润新村（已拆迁未安置）'
              }
            ]
          },
          {
            value: '0718713',
            label: '临邑县宿安乡',
            children: [
              { value: '0718712', label: '高徐村' },
              { value: '0718713402', label: '徐郝新村' },
              { value: '0718713403', label: '耿张村' },
              { value: '0718713404', label: '旭升新村' },
              { value: '0718713405', label: '幸福新村' },
              { value: '0718713406', label: '宿安馨村' },
              { value: '0718713407', label: '孟家村' },
              { value: '0718713408', label: '杨家村' },
              { value: '0718713409', label: '小营新村' },
              { value: '0718713410', label: '振兴村' },
              { value: '0718713411', label: '辛家村' },
              { value: '0718713412', label: '徐家楼村' },
              { value: '0718713413', label: '邢仙龙村' },
              { value: '0718713414', label: '夏家村' },
              { value: '0718713415', label: '鲍家村' },
              { value: '0718713416', label: '五龙堂村' },
              { value: '0718713417', label: '东张村' },
              { value: '0718713418', label: '坯子张村' },
              { value: '0718713419', label: '许家寨村' },
              { value: '0718713420', label: '崔家村' },
              { value: '0718713421', label: '熊家村' },
              { value: '0718713422', label: '邓家村' },
              { value: '0718713423', label: '姜家寨村' },
              { value: '0718713424', label: '陶家寨村' },
              { value: '0718713425', label: '赵家寨村' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '08',
    label: '平原县',
    children: [
      {
        value: '08198',
        label: '平原县',
        children: [
          {
            value: '081982',
            label: '龙门街道',
            children: [
              { value: '081981', label: '郭庄' },
              { value: '0819821', label: '刘庄' },
              { value: '0819822', label: '大张' },
              { value: '0819823', label: '小张' },
              { value: '0819824', label: '郑庄' },
              { value: '0819825', label: '隋庄' },
              { value: '0819826', label: '水坑王' },
              { value: '0819827', label: '五里庄' },
              { value: '0819828', label: '炉坊' },
              { value: '0819829', label: '军仓新村' },
              { value: '08198210', label: '林庄' },
              { value: '08198211', label: '康庄' },
              { value: '08198212', label: '镰把张' }
            ]
          },
          {
            value: '081983',
            label: '桃园街道',
            children: [
              { value: '081982', label: '仇庄' },
              { value: '08198313', label: '东园村' },
              { value: '08198314', label: '魏东村' },
              { value: '08198315', label: '魏北村' },
              { value: '08198316', label: '魏中村' },
              { value: '08198317', label: '饮马店' },
              { value: '08198318', label: '高寨村' },
              { value: '08198319', label: '李勇庄' },
              { value: '08198320', label: '韩宋村' },
              { value: '08198321', label: '齐庄' },
              { value: '08198322', label: '尚庙村' },
              { value: '08198323', label: '野庄' },
              { value: '08198324', label: '卜庄' },
              { value: '08198325', label: '石庄' },
              { value: '08198326', label: '周寨村' },
              { value: '08198327', label: '迟赵村' },
              { value: '08198328', label: '荆堂村' },
              { value: '08198329', label: '七里屯' },
              { value: '08198330', label: '张堂村' },
              { value: '08198331', label: '桃园新村' },
              { value: '08198332', label: '马庄' },
              { value: '08198333', label: '田坊村' },
              { value: '08198334', label: '十里墅村' },
              { value: '08198335', label: '苇子园村' },
              { value: '08198336', label: '大芝坊村' }
            ]
          },
          {
            value: '081984',
            label: '德原街道',
            children: [
              { value: '081983', label: '三仓村' },
              { value: '08198437', label: '三义村' },
              { value: '08198438', label: '毛庄' },
              { value: '08198439', label: '大五里村' },
              { value: '08198440', label: '南任村' },
              { value: '08198441', label: '高村' },
              { value: '08198442', label: '崔庄' },
              { value: '08198443', label: '前耿村' },
              { value: '08198444', label: '后耿村' },
              { value: '08198445', label: '张仁村' },
              { value: '08198446', label: '任楼村' },
              { value: '08198447', label: '庞张村' },
              { value: '08198448', label: '祁格村' },
              { value: '08198449', label: '旭和新村' },
              { value: '08198450', label: '红庙村' },
              { value: '08198451', label: '陈蔡村' },
              { value: '08198452', label: '津河东村' },
              { value: '08198453', label: '叶庄新村' },
              { value: '08198454', label: '合兴村' },
              { value: '08198455', label: '前坊子村' },
              { value: '08198456', label: '亭子村' },
              { value: '08198457', label: '富民村' },
              { value: '08198458', label: '厚坊村' },
              { value: '08198459', label: '德坊村' }
            ]
          },
          {
            value: '081985',
            label: '王凤楼镇',
            children: [
              { value: '081984', label: '官道李村' },
              { value: '08198560', label: '前何寺村' },
              { value: '08198561', label: '前屯村' },
              { value: '08198562', label: '后屯村' },
              { value: '08198563', label: '大刘村' },
              { value: '08198564', label: '艾庄村' },
              { value: '08198565', label: '南任村' },
              { value: '08198566', label: '李汉曲村' },
              { value: '08198567', label: '老官村' },
              { value: '08198568', label: '后何寺村' },
              { value: '08198569', label: '贾牟新村' },
              { value: '08198570', label: '陈梁潘村' },
              { value: '08198571', label: '石庄村' },
              { value: '08198572', label: '后卢村' },
              { value: '08198573', label: '前卢村' },
              { value: '08198574', label: '崔庄村' },
              { value: '08198575', label: '宋升村' },
              { value: '08198576', label: '田庄村' },
              { value: '08198577', label: '小吴村' },
              { value: '08198578', label: '邱安石村' },
              { value: '08198579', label: '张士唐村' },
              { value: '08198580', label: '小王庄村' },
              { value: '08198581', label: '和谐新村' },
              { value: '08198582', label: '姜庄村' },
              { value: '08198583', label: '古郡村' },
              { value: '08198584', label: '大王庄村' },
              { value: '08198585', label: '红旗村' },
              { value: '08198586', label: '朱庄村' },
              { value: '08198587', label: '马务村' },
              { value: '08198588', label: '宋寨村' },
              { value: '08198589', label: '匡李村' },
              { value: '08198590', label: '邓庄村' },
              { value: '08198591', label: '张许杨村' },
              { value: '08198592', label: '小刘村' },
              { value: '08198593', label: '水务村' },
              { value: '08198594', label: '匡张村' },
              { value: '08198595', label: '店后王村' },
              { value: '08198596', label: '店后徐村' },
              { value: '08198597', label: '冯李新村' },
              { value: '08198598', label: '天柴新村' },
              { value: '08198599', label: '曹庙村' },
              { value: '081985100', label: '王汉村' },
              { value: '081985101', label: '西冯村' },
              { value: '081985102', label: '郝家屯村' },
              { value: '081985103', label: '张辛村' },
              { value: '081985104', label: '东陈村' },
              { value: '081985105', label: '王丙真村' },
              { value: '081985106', label: '周庄村' },
              { value: '081985107', label: '小宋村' },
              { value: '081985108', label: '杜屯村' },
              { value: '081985109', label: '郝庄村' },
              { value: '081985110', label: '西魏村' },
              { value: '081985111', label: '王付廷村' },
              { value: '081985112', label: '高庄村' },
              { value: '081985113', label: '张府村' },
              { value: '081985114', label: '胡尧新村' },
              { value: '081985115', label: '王凤楼村' },
              { value: '081985116', label: '曙光新村' },
              { value: '081985117', label: '红星新村' },
              { value: '081985118', label: '赵河沟村' },
              { value: '081985119', label: '陈麻新村' },
              { value: '081985120', label: '五杨村' },
              { value: '081985121', label: '王功臣村' },
              { value: '081985122', label: '五麻村' },
              { value: '081985123', label: '古楼店村' },
              { value: '081985124', label: '代庄村' },
              { value: '081985125', label: '曹塘坊村' },
              { value: '081985126', label: '刘百户村' },
              { value: '081985127', label: '岳庄村' },
              { value: '081985128', label: '富民新村' },
              { value: '081985129', label: '陈魏新村' },
              { value: '081985130', label: '刘智毛村' },
              { value: '081985131', label: '小陶村' },
              { value: '081985132', label: '王牌村' },
              { value: '081985133', label: '大仇村' },
              { value: '081985134', label: '北潘村' },
              { value: '081985135', label: '南街新村' },
              { value: '081985136', label: '李家楼村' },
              { value: '081985137', label: '毕庄村' },
              { value: '081985138', label: '三大李村' },
              { value: '081985139', label: '辛寨村' },
              { value: '081985140', label: '小姚村' },
              { value: '081985141', label: '王河沟村' },
              { value: '081985142', label: '老姚村' },
              { value: '081985143', label: '于姚村' }
            ]
          },
          {
            value: '081986',
            label: '恩城镇',
            children: [
              { value: '081985', label: '红运村' },
              { value: '081986144', label: '城西村' },
              { value: '081986145', label: '大李村' },
              { value: '081986146', label: '付庄' },
              { value: '081986147', label: '五里庄' },
              { value: '081986148', label: '大洞村' },
              { value: '081986149', label: '西赵庄' },
              { value: '081986150', label: '周全' },
              { value: '081986151', label: '三義村' },
              { value: '081986152', label: '陈东屯' },
              { value: '081986153', label: '振兴村' },
              { value: '081986154', label: '雷魏石村' },
              { value: '081986155', label: '东西展村' },
              { value: '081986156', label: '刘官村' },
              { value: '081986157', label: '陈营村' },
              { value: '081986158', label: '岗子刘村' },
              { value: '081986159', label: '三合村' },
              { value: '081986160', label: '南关村' },
              { value: '081986161', label: '西关村' },
              { value: '081986162', label: '西四村' },
              { value: '081986163', label: '东四村' },
              { value: '081986164', label: '大北关' },
              { value: '081986165', label: '小北关' },
              { value: '081986166', label: '东关村' },
              { value: '081986167', label: '北四合村' },
              { value: '081986168', label: '河东村' },
              { value: '081986169', label: '恩北村' },
              { value: '081986170', label: '北城村' },
              { value: '081986171', label: '大杨村' },
              { value: '081986172', label: '耿庄' },
              { value: '081986173', label: '东于村' },
              { value: '081986174', label: '银王村' },
              { value: '081986175', label: '北马庄' },
              { value: '081986176', label: '南城村' },
              { value: '081986177', label: '八里河村' },
              { value: '081986178', label: '三贤庄' },
              { value: '081986179', label: '沙河村' },
              { value: '081986180', label: '高庄' },
              { value: '081986181', label: '后夏村' },
              { value: '081986182', label: '秦庄' },
              { value: '081986183', label: '前夏村' },
              { value: '081986184', label: '大军营村' },
              { value: '081986185', label: '马吴新村' },
              { value: '081986186', label: '南庞村' },
              { value: '081986187', label: '南十里村' },
              { value: '081986188', label: '滨河村' },
              { value: '081986189', label: '元官屯' },
              { value: '081986190', label: '临河村' },
              { value: '081986191', label: '胡新河村' }
            ]
          },
          {
            value: '081987',
            label: '前曹镇',
            children: [
              { value: '081986', label: '兴和庄村' },
              { value: '081987192', label: '三合庄村' },
              { value: '081987193', label: '顺河村' },
              { value: '081987194', label: '崔魏寨村' },
              { value: '081987195', label: '铁嘴村' },
              { value: '081987196', label: '双合庄村' },
              { value: '081987197', label: '刘寨村' },
              { value: '081987198', label: '毛孙村' },
              { value: '081987199', label: '东兴村' },
              { value: '081987200', label: '新兴村' },
              { value: '081987201', label: '方屯村' },
              { value: '081987202', label: '尹屯村' },
              { value: '081987203', label: '惠和新村' },
              { value: '081987204', label: '四平村' },
              { value: '081987205', label: '鑫源村' },
              { value: '081987206', label: '华兴村' },
              { value: '081987207', label: '前曹村' },
              { value: '081987208', label: '新秀苑' },
              { value: '081987209', label: '新雅苑' },
              { value: '081987210', label: '长安村' },
              { value: '081987211', label: '张庄村' },
              { value: '081987212', label: '杨柳寺村' },
              { value: '081987213', label: '张常村' },
              { value: '081987214', label: '西马村' },
              { value: '081987215', label: '鸣鸡店村' },
              { value: '081987216', label: '郑庄村' },
              { value: '081987217', label: '刘庄新村' },
              { value: '081987218', label: '宫徐村' },
              { value: '081987219', label: '田庄村' },
              { value: '081987220', label: '陈袁村' },
              { value: '081987221', label: '谢家洼村' },
              { value: '081987222', label: '苏家洼村' },
              { value: '081987223', label: '官庄村' },
              { value: '081987224', label: '五福新村' },
              { value: '081987225', label: '古台寺村' },
              { value: '081987226', label: '永盛村' },
              { value: '081987227', label: '三寨子村' },
              { value: '081987228', label: '孙寨村' },
              { value: '081987229', label: '邵庙村' },
              { value: '081987230', label: '滨河村' },
              { value: '081987231', label: '古寨村' },
              { value: '081987232', label: '枣棍刘村' },
              { value: '081987233', label: '兴旺村' },
              { value: '081987234', label: '河东村' },
              { value: '081987235', label: '宋陈村' },
              { value: '081987236', label: '祝庄村' }
            ]
          },
          {
            value: '081988',
            label: '张华镇',
            children: [
              { value: '081987', label: '小张村' },
              { value: '081988237', label: '盆吴村' },
              { value: '081988238', label: '望海村' },
              { value: '081988239', label: '高范村' },
              { value: '081988240', label: '李当村' },
              { value: '081988241', label: '北白村' },
              { value: '081988242', label: '小尹村' },
              { value: '081988243', label: '张华村' },
              { value: '081988244', label: '华南村' },
              { value: '081988245', label: '郑官村' },
              { value: '081988246', label: '华新村' },
              { value: '081988247', label: '朝阳村' },
              { value: '081988248', label: '侯庄村' },
              { value: '081988249', label: '蔺庄村' },
              { value: '081988250', label: '大陈村' },
              { value: '081988251', label: '小崔村' },
              { value: '081988252', label: '黄庄村' },
              { value: '081988253', label: '南园村' },
              { value: '081988254', label: '贺沟村' },
              { value: '081988255', label: '南赵村' },
              { value: '081988256', label: '韩庄村' },
              { value: '081988257', label: '顺和村' },
              { value: '081988258', label: '高陈村' },
              { value: '081988259', label: '范庙村' },
              { value: '081988260', label: '刘悦村' },
              { value: '081988261', label: '王达村' },
              { value: '081988262', label: '何庙村' },
              { value: '081988263', label: '皮张村' },
              { value: '081988264', label: '六联社村' },
              { value: '081988265', label: '祖庄村' },
              { value: '081988266', label: '大崔村' },
              { value: '081988267', label: '梨园村' },
              { value: '081988268', label: '和西村' }
            ]
          },
          {
            value: '081989',
            label: '王庙镇',
            children: [
              { value: '081988', label: '李寨村' },
              { value: '081989269', label: '张老虎村' },
              { value: '081989270', label: '辛屯村' },
              { value: '081989271', label: '大杜村' },
              { value: '081989272', label: '吴闫田村' },
              { value: '081989273', label: '前李村' },
              { value: '081989274', label: '唐杜王村' },
              { value: '081989275', label: '方刘村' },
              { value: '081989276', label: '程裴崔村' },
              { value: '081989277', label: '韩何村' },
              { value: '081989278', label: '洼后李村' },
              { value: '081989279', label: '郭庄村' },
              { value: '081989280', label: '孙庄村' },
              { value: '081989281', label: '刘新环东村' },
              { value: '081989282', label: '刘新环西村' },
              { value: '081989283', label: '五邻好村' },
              { value: '081989284', label: '陈霍王村' },
              { value: '081989285', label: '大务位村' },
              { value: '081989286', label: '王兴明村' },
              { value: '081989287', label: '车王庄西村' },
              { value: '081989288', label: '车王庄东村' },
              { value: '081989289', label: '李庄村' },
              { value: '081989290', label: '邱庄村' },
              { value: '081989291', label: '张官店村' },
              { value: '081989292', label: '朱于村' },
              { value: '081989293', label: '双兴村' },
              { value: '081989294', label: '刘娄王村' },
              { value: '081989295', label: '李邱俭村' },
              { value: '081989296', label: '佳联村' },
              { value: '081989297', label: '兴旺新村' },
              { value: '081989298', label: '三合村' },
              { value: '081989299', label: '临河村' },
              { value: '081989300', label: '苏集村' },
              { value: '081989301', label: '辛章村' },
              { value: '081989302', label: '顿庄村' },
              { value: '081989303', label: '段集村' },
              { value: '081989304', label: '后李张村' },
              { value: '081989305', label: '前刘村' },
              { value: '081989306', label: '拖肖村' },
              { value: '081989307', label: '四合庄' },
              { value: '081989308', label: '五合庄' },
              { value: '081989309', label: '堤下赵村' },
              { value: '081989310', label: '王木匠村' },
              { value: '081989311', label: '友谊村' },
              { value: '081989312', label: '和谐村' }
            ]
          },
          {
            value: '0819810',
            label: '王杲铺镇',
            children: [
              { value: '081989', label: '双博泉村' },
              { value: '0819810313', label: '曹庄' },
              { value: '0819810314', label: '董博村' },
              { value: '0819810315', label: '韩庄' },
              { value: '0819810316', label: '后程村' },
              { value: '0819810317', label: '贾庄' },
              { value: '0819810318', label: '泊庄' },
              { value: '0819810319', label: '双庙村' },
              { value: '0819810320', label: '王杲铺村' },
              { value: '0819810321', label: '邢博村' },
              { value: '0819810322', label: '杨诗庄' },
              { value: '0819810323', label: '张博村' },
              { value: '0819810324', label: '刘德路庄村' },
              { value: '0819810325', label: '大冯村' },
              { value: '0819810326', label: '道口村' },
              { value: '0819810327', label: '胡庄村' },
              { value: '0819810328', label: '甜北村' },
              { value: '0819810329', label: '甜南村' },
              { value: '0819810330', label: '甜中村' },
              { value: '0819810331', label: '小冯村' },
              { value: '0819810332', label: '杨黑村' },
              { value: '0819810333', label: '杨文村' },
              { value: '0819810334', label: '张庄' },
              { value: '0819810335', label: '赵庄' },
              { value: '0819810336', label: '大胥村' },
              { value: '0819810337', label: '焦家寺村' },
              { value: '0819810338', label: '刘庄' },
              { value: '0819810339', label: '栾庄' },
              { value: '0819810340', label: '马庄' },
              { value: '0819810341', label: '前程村' },
              { value: '0819810342', label: '王杲屯村' },
              { value: '0819810343', label: '王其村' },
              { value: '0819810344', label: '小胥村' },
              { value: '0819810345', label: '肖屯村' },
              { value: '0819810346', label: '徐官屯' },
              { value: '0819810347', label: '于庄' },
              { value: '0819810348', label: '臧庄' },
              { value: '0819810349', label: '崔家坊村' },
              { value: '0819810350', label: '董路口村' },
              { value: '0819810351', label: '杜庄' },
              { value: '0819810352', label: '洪庄' },
              { value: '0819810353', label: '后梅村' },
              { value: '0819810354', label: '看水村' },
              { value: '0819810355', label: '马庄铺' },
              { value: '0819810356', label: '前梅村' },
              { value: '0819810357', label: '洼董村' },
              { value: '0819810358', label: '洼刘村' },
              { value: '0819810359', label: '王岑村' },
              { value: '0819810360', label: '小王村' },
              { value: '0819810361', label: '张牌村' }
            ]
          },
          {
            value: '0819811',
            label: '腰站镇',
            children: [
              { value: '0819810', label: '槐荫村' },
              { value: '0819811362', label: '槐阳村' },
              { value: '0819811363', label: '双邻村' },
              { value: '0819811364', label: '三邻村' },
              { value: '0819811365', label: '小康村' },
              { value: '0819811366', label: '土屋村' },
              { value: '0819811367', label: '姚庄村' },
              { value: '0819811368', label: '新月村' },
              { value: '0819811369', label: '白布屯村' },
              { value: '0819811370', label: '福园村' },
              { value: '0819811371', label: '大张村' },
              { value: '0819811372', label: '郭槐村' },
              { value: '0819811373', label: '文化村' },
              { value: '0819811374', label: '韩营村' },
              { value: '0819811375', label: '大堤村' },
              { value: '0819811376', label: '堂槐村' },
              { value: '0819811377', label: '阚辛村' },
              { value: '0819811378', label: '锅培口村' },
              { value: '0819811379', label: '红源村' },
              { value: '0819811380', label: '骏桥村' }
            ]
          },
          {
            value: '0819812',
            label: '王打卦镇',
            children: [
              { value: '0819811', label: '代家口村' },
              { value: '0819812381', label: '宋家口村' },
              { value: '0819812382', label: '众和村' },
              { value: '0819812383', label: '东屯村' },
              { value: '0819812384', label: '王打卦新村' },
              { value: '0819812385', label: '郭家堂新村' },
              { value: '0819812386', label: '花园新村' },
              { value: '0819812387', label: '潘邓新村' },
              { value: '0819812388', label: '打渔李新村' },
              { value: '0819812389', label: '新王管村' },
              { value: '0819812390', label: '北侯新村' },
              { value: '0819812391', label: '碧景新村' },
              { value: '0819812392', label: '领航新村' },
              { value: '0819812393', label: '夏家口村' }
            ]
          },
          {
            value: '0819813',
            label: '三唐乡',
            children: [
              { value: '0819812', label: '协和村' },
              { value: '0819813394', label: '中兴村' },
              { value: '0819813395', label: '通达村' },
              { value: '0819813396', label: '正大村' },
              { value: '0819813397', label: '郑屯村' },
              { value: '0819813398', label: '祥安村' },
              { value: '0819813399', label: '祥和村' },
              { value: '0819813400', label: '中原村' },
              { value: '0819813401', label: '泰和村' },
              { value: '0819813402', label: '兴旺村' },
              { value: '0819813403', label: '兴牧村' },
              { value: '0819813404', label: '兴唐村' },
              { value: '0819813405', label: '千佛塔村' },
              { value: '0819813406', label: '四合庄村' },
              { value: '0819813407', label: '崔家庙' },
              { value: '0819813408', label: '结义村' },
              { value: '0819813409', label: '兴工村' },
              { value: '0819813410', label: '兴达村' },
              { value: '0819813411', label: '兴通村' },
              { value: '0819813412', label: '兴业村' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '09',
    label: '武城县',
    children: [
      {
        value: '091109',
        label: '武城县',
        children: [
          {
            value: '0911092',
            label: '鲁权屯镇',
            children: [
              { value: '0911091', label: '石庄村' },
              { value: '09110921', label: '朱家圈村' },
              { value: '09110922', label: '八屯村' },
              { value: '09110923', label: '大史庄村' },
              { value: '09110924', label: '宋王庄村' },
              { value: '09110925', label: '马庄村' },
              { value: '09110926', label: '张官屯村' },
              { value: '09110927', label: '西王屯村' },
              { value: '09110928', label: '鲁权屯村' },
              { value: '09110929', label: '郭庄村' },
              { value: '091109210', label: '国庄村' },
              { value: '091109211', label: '小堤口村' },
              { value: '091109212', label: '王贤屯村' },
              { value: '091109213', label: '林庄村' },
              { value: '091109214', label: '二屯村' },
              { value: '091109215', label: '后九屯村' },
              { value: '091109216', label: '闫庄村' },
              { value: '091109217', label: '北甘泉村' },
              { value: '091109218', label: '漳南镇村' },
              { value: '091109219', label: '西王庄村' },
              { value: '091109220', label: '小史庄村' },
              { value: '091109221', label: '辛厂村' },
              {
                value: '091109222',
                label: '西赵庄村（拆迁村）'
              },
              { value: '091109223', label: '满庄村' },
              { value: '091109224', label: '李庄村' },
              { value: '091109225', label: '北赵庄村' },
              { value: '091109226', label: '代官屯村' },
              { value: '091109227', label: '小魏庄村' },
              { value: '091109228', label: '东赵庄村' },
              { value: '091109229', label: '西邱庄村' },
              { value: '091109230', label: '孔官屯村' },
              { value: '091109231', label: '东场村' },
              { value: '091109232', label: '东王屯村' },
              { value: '091109233', label: '东良庄村' },
              { value: '091109234', label: '西良庄村' },
              { value: '091109235', label: '前九屯村' },
              { value: '091109236', label: '第十屯村' },
              { value: '091109237', label: '张郭秦村' },
              { value: '091109238', label: '大于庄村' },
              { value: '091109239', label: '南宋庄村' },
              { value: '091109240', label: '青苏厂村' },
              { value: '091109241', label: '师庄村' },
              { value: '091109242', label: '苏庄村' },
              { value: '091109243', label: '南郑庄村' },
              { value: '091109244', label: '罗厂村（拆迁村）' },
              { value: '091109245', label: '袁厂村' },
              { value: '091109246', label: '刘军户村' },
              { value: '091109247', label: '李堂村' },
              { value: '091109248', label: '沙虎兰庄村' },
              { value: '091109249', label: '桑庄村' },
              { value: '091109250', label: '刘庄村' },
              { value: '091109251', label: '大吴庄村' },
              { value: '091109252', label: '小于庄村' },
              { value: '091109253', label: '西吴庄村' },
              { value: '091109254', label: '潘庄村' },
              { value: '091109255', label: '陈庄村' },
              { value: '091109256', label: '胡家洼村' },
              { value: '091109257', label: '朱庄村' },
              { value: '091109258', label: '张马尧村' },
              { value: '091109259', label: '小贾庄村' },
              { value: '091109260', label: '滕庄村' },
              { value: '091109261', label: '南甘泉村' },
              { value: '091109262', label: '邢庄村' },
              { value: '091109263', label: '李贤屯村' },
              { value: '091109264', label: '韩家洼村' },
              { value: '091109265', label: '付家坊村' },
              { value: '091109266', label: '付家楼村' },
              { value: '091109267', label: '燕庄村' },
              { value: '091109268', label: '西郑庄村' },
              { value: '091109269', label: '高官屯村' },
              { value: '091109270', label: '小张庄村' },
              { value: '091109271', label: '北宋庄村' },
              { value: '091109272', label: '北郑庄村' },
              { value: '091109273', label: '杨楼村' },
              { value: '091109274', label: '北伍旗村' }
            ]
          },
          {
            value: '0911093',
            label: '武城镇',
            children: [
              { value: '0911092', label: '肖邢王庄村' },
              { value: '091109375', label: '董王庄村' },
              { value: '091109376', label: '予里官村' },
              { value: '091109377', label: '牛杏村' },
              { value: '091109378', label: '户王庄村' },
              { value: '091109379', label: '候王庄村' },
              { value: '091109380', label: '东杨官屯村' },
              { value: '091109381', label: '东肖河庄村' },
              { value: '091109382', label: '诗壁新村' },
              { value: '091109383', label: '孟王庄村' },
              { value: '091109384', label: '孙尔庄村' },
              { value: '091109385', label: '李善屯村' },
              { value: '091109386', label: '大屯村' },
              { value: '091109387', label: '岳觉寺村' },
              { value: '091109388', label: '南北官庄村' },
              { value: '091109389', label: '东七里庄村' },
              { value: '091109390', label: '西杨官屯村' },
              { value: '091109391', label: '贾庄村' },
              { value: '091109392', label: '张王庄村' },
              { value: '091109393', label: '东小屯村' },
              { value: '091109394', label: '方吴河沟村' },
              { value: '091109395', label: '高王庄村' },
              { value: '091109396', label: '刘寨村' },
              { value: '091109397', label: '翟刘新村' },
              { value: '091109398', label: '西庞坡村' },
              { value: '091109399', label: '东曹庄村' },
              { value: '0911093100', label: '辛王庄村' },
              { value: '0911093101', label: '马良庄村' },
              { value: '0911093102', label: '马言庄村' },
              {
                value: '0911093103',
                label: '尚石庄村（拆迁村）'
              },
              { value: '0911093104', label: '付王庄村' },
              { value: '0911093105', label: '田尔庄村' },
              { value: '0911093106', label: '桃花店村' },
              { value: '0911093107', label: '丁王庄村' },
              { value: '0911093108', label: '杨刘庄村' },
              { value: '0911093109', label: '三合兴村' },
              { value: '0911093110', label: '安集庄村' },
              { value: '0911093111', label: '新孙庄村' },
              { value: '0911093112', label: '李塘坊村' },
              { value: '0911093113', label: '中姜庄村' },
              { value: '0911093114', label: '上孙庄村' },
              { value: '0911093115', label: '西肖河庄村' },
              { value: '0911093116', label: '孔庄村' },
              { value: '0911093117', label: '大邢王庄村' },
              { value: '0911093118', label: '万庄村' },
              { value: '0911093119', label: '东苏庄村' },
              { value: '0911093120', label: '吕庄村' },
              { value: '0911093121', label: '西七里庄村' },
              { value: '0911093122', label: '后马棚村' },
              { value: '0911093123', label: '前马棚村' },
              { value: '0911093124', label: '小董王庄村' },
              { value: '0911093125', label: '李庄村' },
              { value: '0911093126', label: '西小屯村' },
              { value: '0911093127', label: '霍庄村' },
              { value: '0911093128', label: '姜王庄村' }
            ]
          },
          {
            value: '0911094',
            label: '老城镇',
            children: [
              { value: '0911093', label: '小王庄村' },
              { value: '0911094129', label: '东屯村' },
              { value: '0911094130', label: '南关村' },
              { value: '0911094131', label: '饮马庄村' },
              { value: '0911094132', label: '沙河新村' },
              { value: '0911094133', label: '三合街村' },
              {
                value: '0911094134',
                label: '大赵庄村（拆迁村）'
              },
              { value: '0911094135', label: '西徐村' },
              { value: '0911094136', label: '祝官屯村' },
              { value: '0911094137', label: '祖寨村' },
              { value: '0911094138', label: '三义村' },
              { value: '0911094139', label: '东关村' },
              { value: '0911094140', label: '西关村' },
              { value: '0911094141', label: '双兴新村' },
              { value: '0911094142', label: '张古庄村' },
              { value: '0911094143', label: '陈庄村' },
              { value: '0911094144', label: '北街村' },
              { value: '0911094145', label: '孟庄村' },
              { value: '0911094146', label: '仓上村' },
              { value: '0911094147', label: '戚庄村' },
              { value: '0911094148', label: '同富新村' },
              { value: '0911094149', label: '后庄村' },
              { value: '0911094150', label: '东徐村' },
              { value: '0911094151', label: '六合村' },
              { value: '0911094152', label: '梁寨村' },
              { value: '0911094153', label: '小屯村' },
              { value: '0911094154', label: '三合村' },
              { value: '0911094155', label: '南街村' },
              { value: '0911094156', label: '镇东新村' },
              { value: '0911094157', label: '李庄村' },
              { value: '0911094158', label: '闫沟村' },
              { value: '0911094159', label: '黄沟村' },
              { value: '0911094160', label: '韩寨村' },
              { value: '0911094161', label: '东杨村' },
              { value: '0911094162', label: '姜圈村' },
              { value: '0911094163', label: '军营村' },
              { value: '0911094164', label: '魏官屯村' },
              { value: '0911094165', label: '范庄村' },
              { value: '0911094166', label: '大十八户村' },
              { value: '0911094167', label: '小十八户村' },
              { value: '0911094168', label: '前杨村' },
              { value: '0911094169', label: '随庄村' },
              { value: '0911094170', label: '西杨村' }
            ]
          },
          {
            value: '0911095',
            label: '郝王庄镇',
            children: [
              { value: '0911094', label: '李古寺村' },
              { value: '0911095171', label: '草一村' },
              { value: '0911095172', label: '草二村' },
              { value: '0911095173', label: '罗庄村' },
              { value: '0911095174', label: '大吕王庄村' },
              { value: '0911095175', label: '付庄村' },
              { value: '0911095176', label: '大霍庄村' },
              { value: '0911095177', label: '庞庄村' },
              { value: '0911095178', label: '郝二村' },
              { value: '0911095179', label: '小王庄村' },
              { value: '0911095180', label: '后玄帝庙村' },
              { value: '0911095181', label: '郝三村' },
              { value: '0911095182', label: '大祁庄村' },
              { value: '0911095183', label: '赵家庙村' },
              { value: '0911095184', label: '南王庄村' },
              { value: '0911095185', label: '高明庄村' },
              { value: '0911095186', label: '小吕王庄村' },
              { value: '0911095187', label: '小祁庄村' },
              { value: '0911095188', label: '孟庄村' },
              { value: '0911095189', label: '仁德庄村' },
              { value: '0911095190', label: '长屯村' },
              { value: '0911095191', label: '小孙庄村' },
              { value: '0911095192', label: '郝一村' },
              { value: '0911095193', label: '唐庄村' },
              { value: '0911095194', label: '双庙李庄村' },
              { value: '0911095195', label: '大姜庄村' },
              { value: '0911095196', label: '陈武庄村' },
              { value: '0911095197', label: '前玄帝庙村' },
              { value: '0911095198', label: '谷刘庄村' },
              { value: '0911095199', label: '御马园村' },
              { value: '0911095200', label: '大王庄村' },
              {
                value: '0911095201',
                label: '邱王庄村（拆迁村）'
              }
            ]
          },
          {
            value: '0911096',
            label: '甲马营镇',
            children: [
              { value: '0911095', label: '东堤口村' },
              { value: '0911096202', label: '后曹店村' },
              { value: '0911096203', label: '北王庄村' },
              { value: '0911096204', label: '董白三村' },
              { value: '0911096205', label: '甲马营村' },
              { value: '0911096206', label: '凤凰台村' },
              { value: '0911096207', label: '前庙村' },
              { value: '0911096208', label: '七机营村' },
              { value: '0911096209', label: '花园村' },
              { value: '0911096210', label: '魏村屯村' },
              { value: '0911096211', label: '新屯村' },
              { value: '0911096212', label: '千户营村' },
              { value: '0911096213', label: '前曹店村' },
              { value: '0911096214', label: '盐庄村' },
              { value: '0911096215', label: '龙湾村' },
              { value: '0911096216', label: '田庄村' },
              { value: '0911096217', label: '徐庄村' },
              { value: '0911096218', label: '刘古庄村' },
              { value: '0911096219', label: '西堤口村' },
              { value: '0911096220', label: '后庙村' },
              { value: '0911096221', label: '王虎庄村' },
              { value: '0911096222', label: '耿时潘村' },
              { value: '0911096223', label: '塔坡村' },
              { value: '0911096224', label: '河北营村' },
              { value: '0911096225', label: '占官屯村' },
              { value: '0911096226', label: '谈庄村' }
            ]
          },
          {
            value: '0911097',
            label: '四女寺镇',
            children: [
              { value: '0911096', label: '东张庄村' },
              { value: '0911097227', label: '白庄村' },
              { value: '0911097228', label: '张官寺村' },
              { value: '0911097229', label: '刘茂庄村' },
              { value: '0911097230', label: '李庄村' },
              { value: '0911097231', label: '商庄村' },
              { value: '0911097232', label: '聂官屯村' },
              { value: '0911097233', label: '铁官屯村' },
              { value: '0911097234', label: '小刘庄村' },
              { value: '0911097235', label: '吕庄子村' },
              { value: '0911097236', label: '东蒋家佛堂村' },
              { value: '0911097237', label: '温庄村' },
              { value: '0911097238', label: '庙留庄村' },
              { value: '0911097239', label: '卧虎庄村' },
              { value: '0911097240', label: '四女寺村' },
              { value: '0911097241', label: '东吴庄村' },
              { value: '0911097242', label: '南小李村' },
              { value: '0911097243', label: '小馆村' },
              { value: '0911097244', label: '王庄村' },
              { value: '0911097245', label: '卜官屯村' },
              { value: '0911097246', label: '殷庄村' },
              { value: '0911097247', label: '四屯村' },
              { value: '0911097248', label: '达官营村' },
              { value: '0911097249', label: '韩庄村' },
              { value: '0911097250', label: '崔张邱村' },
              { value: '0911097251', label: '北小李村' },
              { value: '0911097252', label: '李大楼村' },
              { value: '0911097253', label: '荣寨村' },
              { value: '0911097254', label: '中礼义庄村' },
              { value: '0911097255', label: '西礼义庄村' },
              { value: '0911097256', label: '小营村' },
              { value: '0911097257', label: '岳官屯村' },
              { value: '0911097258', label: '大孙庄村' },
              { value: '0911097259', label: '三合村' },
              { value: '0911097260', label: '李馆村' },
              { value: '0911097261', label: '东赵馆村' },
              { value: '0911097262', label: '阮庄村' },
              { value: '0911097263', label: '蔡中村' },
              { value: '0911097264', label: '蔡后村' },
              { value: '0911097265', label: '罗小屯村' },
              { value: '0911097266', label: '谢张庄村' },
              { value: '0911097267', label: '董庄村' },
              { value: '0911097268', label: '油坊村' },
              { value: '0911097269', label: '高海村' },
              { value: '0911097270', label: '大刘庄村' },
              { value: '0911097271', label: '高庄村' },
              { value: '0911097272', label: '辛立庄村' },
              { value: '0911097273', label: '蔡西村' },
              { value: '0911097274', label: '祁村' },
              { value: '0911097275', label: '齐馆村' },
              { value: '0911097276', label: '头屯村' },
              { value: '0911097277', label: '五屯村' },
              { value: '0911097278', label: '东礼仪庄村' },
              { value: '0911097279', label: '西蒋家佛堂村' },
              { value: '0911097280', label: '肖庄村' },
              { value: '0911097281', label: '辛桥庄村' },
              { value: '0911097282', label: '西赵馆村' }
            ]
          },
          {
            value: '0911098',
            label: '李家户镇',
            children: [
              { value: '0911097', label: '西店村' },
              {
                value: '0911098283',
                label: '刘王庄村（拆迁村）'
              },
              { value: '0911098284', label: '党庄村' },
              { value: '0911098285', label: '后王庄村' },
              { value: '0911098286', label: '东升村' },
              { value: '0911098287', label: '魏庄村' },
              { value: '0911098288', label: '耿庄村' },
              { value: '0911098289', label: '石官屯村' },
              { value: '0911098290', label: '苑寨村' },
              { value: '0911098291', label: '李官屯村' },
              { value: '0911098292', label: '盐厂村' },
              { value: '0911098293', label: '仁里庄村' },
              { value: '0911098294', label: '大王庄村' },
              { value: '0911098295', label: '郑官屯村' },
              { value: '0911098296', label: '巩庄村' },
              { value: '0911098297', label: '王家户村' },
              { value: '0911098298', label: '代庄村' },
              { value: '0911098299', label: '郎寨村' },
              { value: '0911098300', label: '张庄村' },
              { value: '0911098301', label: '辛庄村' },
              { value: '0911098302', label: '梁庄村' },
              { value: '0911098303', label: '李家户村' },
              { value: '0911098304', label: '东店村' },
              { value: '0911098305', label: '刘官屯村' }
            ]
          },
          {
            value: '0911099',
            label: '广运街道',
            children: [
              { value: '0911098', label: '后王立屯村' },
              {
                value: '0911099306',
                label: '曲庄村（拆迁村）'
              },
              {
                value: '0911099307',
                label: '沙中村（拆迁村）'
              },
              { value: '0911099308', label: '棘围村' },
              {
                value: '0911099309',
                label: '沙西村（拆迁村）'
              },
              { value: '0911099310', label: '东关村' },
              { value: '0911099311', label: '北关村' },
              { value: '0911099312', label: '王前坡村' },
              { value: '0911099313', label: '前王立屯村' },
              { value: '0911099314', label: '西关村' },
              { value: '0911099315', label: '杜前坡村' },
              { value: '0911099316', label: '西刘庄村' },
              { value: '0911099317', label: '东刘庄村' },
              { value: '0911099318', label: '赵前坡村' },
              { value: '0911099319', label: '董前坡村' },
              { value: '0911099320', label: '高庄村' },
              { value: '0911099321', label: '祝庄村' },
              { value: '0911099322', label: '南关村' },
              { value: '0911099323', label: '林庄村' },
              { value: '0911099324', label: '军庄村' },
              { value: '0911099325', label: '孙家河沟村' },
              { value: '0911099326', label: '任家河沟村' },
              { value: '0911099327', label: '盛寨村' },
              {
                value: '0911099328',
                label: '沙东村（拆迁村）'
              },
              {
                value: '0911099329',
                label: '林尔庄村（拆迁村）'
              },
              { value: '0911099330', label: '钱庄村（拆迁村）' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '010',
    label: '夏津县',
    children: [
      {
        value: '01011110',
        label: '夏津县',
        children: [
          {
            value: '010111102',
            label: '北城街道',
            children: [
              { value: '010111101', label: '艾庄村' },
              { value: '0101111021', label: '孔庄村' },
              { value: '0101111022', label: '刘庄村' },
              { value: '0101111023', label: '孔市村' },
              { value: '0101111024', label: '管庄村' },
              { value: '0101111025', label: '王庄村' },
              { value: '0101111026', label: '马辛庄村' },
              { value: '0101111027', label: '平安湖村' },
              { value: '0101111028', label: '茶屯村' },
              { value: '0101111029', label: '唐堤村' },
              { value: '01011110210', label: '杨堤村' },
              { value: '01011110211', label: '董仓村' },
              { value: '01011110212', label: '朱仓村' },
              { value: '01011110213', label: '宋仓村' },
              { value: '01011110214', label: '西闫庙村' },
              { value: '01011110215', label: '齐庄村' },
              { value: '01011110216', label: '东闫庙村' },
              { value: '01011110217', label: '于家仓村' },
              { value: '01011110218', label: '刘堤村' },
              { value: '01011110219', label: '马道村' },
              { value: '01011110220', label: '三十里铺村' },
              { value: '01011110221', label: '西杨村' },
              { value: '01011110222', label: '刘曹庄村' },
              { value: '01011110223', label: '前周村' },
              { value: '01011110224', label: '后周村' },
              { value: '01011110225', label: '温辛庄村' },
              { value: '01011110226', label: '后屯村' },
              { value: '01011110227', label: '南双庙村' },
              { value: '01011110228', label: '北铺店村' },
              { value: '01011110229', label: '义和庄村' },
              { value: '01011110230', label: '前屯村' },
              { value: '01011110231', label: '许小庄村' },
              { value: '01011110232', label: '苦水村' },
              { value: '01011110233', label: '李楼村' },
              { value: '01011110234', label: '胡里长屯村' },
              { value: '01011110235', label: '孟韩村' },
              { value: '01011110236', label: '许老庄村' },
              { value: '01011110237', label: '会盟社区' },
              { value: '01011110238', label: '舜泉社区' },
              { value: '01011110239', label: '福泽社区' },
              { value: '01011110240', label: '华夏社区' },
              { value: '01011110241', label: '金都社区' },
              { value: '01011110242', label: '四季城社区' },
              { value: '01011110243', label: '银山社区' },
              { value: '01011110244', label: '锦绣社区' },
              { value: '01011110245', label: '滨湖社区' },
              { value: '01011110246', label: '阳光社区' }
            ]
          },
          {
            value: '010111103',
            label: '银城街道',
            children: [
              { value: '010111102', label: '八里庄村' },
              { value: '01011110347', label: '陈庄村' },
              { value: '01011110348', label: '代庄村' },
              { value: '01011110349', label: '淡南村' },
              { value: '01011110350', label: '淡北村' },
              { value: '01011110351', label: '淡西村' },
              { value: '01011110352', label: '淡东村' },
              { value: '01011110353', label: '冯庄村' },
              { value: '01011110354', label: '郭寨村' },
              { value: '01011110355', label: '后赵庄村' },
              { value: '01011110356', label: '李集村' },
              { value: '01011110357', label: '刘江庄村' },
              { value: '01011110358', label: '孟堂村' },
              { value: '01011110359', label: '前屯村' },
              { value: '01011110360', label: '前王庄村' },
              { value: '01011110361', label: '冉楼庄村' },
              { value: '01011110362', label: '冉庄村' },
              { value: '01011110363', label: '十里庙村' },
              { value: '01011110364', label: '十五里铺村' },
              { value: '01011110365', label: '四联村' },
              { value: '01011110366', label: '孙庄村' },
              { value: '01011110367', label: '王皮庄村' },
              { value: '01011110368', label: '五里庄村' },
              { value: '01011110369', label: '新王楼村' },
              { value: '01011110370', label: '朱寿庄村' },
              { value: '01011110371', label: '许集村' },
              { value: '01011110372', label: '泰和社区' },
              { value: '01011110373', label: '康达社区' },
              { value: '01011110374', label: '中山社区' },
              { value: '01011110375', label: '东苑社区' },
              { value: '01011110376', label: '丰华社区' },
              { value: '01011110377', label: '朝阳社区' },
              { value: '01011110378', label: '兴隆社区' },
              { value: '01011110379', label: '育英社区' }
            ]
          },
          {
            value: '010111104',
            label: '南城镇',
            children: [
              { value: '010111103', label: '吕堂村' },
              { value: '01011110480', label: '栾庄村' },
              { value: '01011110481', label: '大殷庄村' },
              { value: '01011110482', label: '商庄村' },
              { value: '01011110483', label: '拐里一村' },
              { value: '01011110484', label: '莫庄村' },
              { value: '01011110485', label: '北大刘村' },
              { value: '01011110486', label: '大朱庄村' },
              { value: '01011110487', label: '丁坊村' },
              { value: '01011110488', label: '刘钦庄村' },
              { value: '01011110489', label: '赵坊村' },
              { value: '01011110490', label: '后刘洪石村' },
              { value: '01011110491', label: '张东吴村' },
              { value: '01011110492', label: '小吴庄村' },
              { value: '01011110493', label: '地藏寺村' },
              { value: '01011110494', label: '蒋寨村' },
              { value: '01011110495', label: '白庙村' },
              { value: '01011110496', label: '小朱庄村' },
              { value: '01011110497', label: '别坊村' },
              { value: '01011110498', label: '苗堂村' },
              { value: '01011110499', label: '朱庙村' },
              { value: '010111104100', label: '李楼村' },
              { value: '010111104101', label: '张庄村' },
              { value: '010111104102', label: '刘庄村' },
              { value: '010111104103', label: '袁庄村' },
              { value: '010111104104', label: '乔官屯村' },
              { value: '010111104105', label: '银子王村' },
              { value: '010111104106', label: '红庙村' },
              { value: '010111104107', label: '由楼村' },
              { value: '010111104108', label: '拐里三村' },
              { value: '010111104109', label: '卢庄村' },
              { value: '010111104110', label: '徐里长村' },
              { value: '010111104111', label: '小殷庄村' },
              { value: '010111104112', label: '南王村' },
              { value: '010111104113', label: '王太来村' },
              { value: '010111104114', label: '义和镇村' },
              { value: '010111104115', label: '常庄村' },
              { value: '010111104116', label: '贾庄村' },
              { value: '010111104117', label: '张寨村' },
              { value: '010111104118', label: '王井村' },
              { value: '010111104119', label: '拐里二村' },
              { value: '010111104120', label: '秦庄村' },
              { value: '010111104121', label: '王仁庄村' },
              { value: '010111104122', label: '闫孙庄村' },
              { value: '010111104123', label: '翟庄村姚寨村' },
              { value: '010111104124', label: '代楼村' },
              { value: '010111104125', label: '白杨村' },
              { value: '010111104126', label: '前刘洪石村' },
              { value: '010111104127', label: '庞庄村' }
            ]
          },
          {
            value: '010111105',
            label: '东李官屯镇',
            children: [
              { value: '010111104', label: '宋桥村' },
              { value: '010111105128', label: '臧庄村' },
              { value: '010111105129', label: '陶桥村' },
              { value: '010111105130', label: '刘兴裕村' },
              { value: '010111105131', label: '邓庄村' },
              { value: '010111105132', label: '张官屯村' },
              { value: '010111105133', label: '史官屯村' },
              { value: '010111105134', label: '前赵庄村' },
              { value: '010111105135', label: '东高庄村' },
              { value: '010111105136', label: '张里庄村' },
              { value: '010111105137', label: '东李楼村' },
              { value: '010111105138', label: '段庄村' },
              { value: '010111105139', label: '后马庄村' },
              { value: '010111105140', label: '东崔庄村' },
              { value: '010111105141', label: '贺屯村' },
              { value: '010111105142', label: '邹庄村' },
              { value: '010111105143', label: '程庄村' },
              { value: '010111105144', label: '东靳庄村' },
              { value: '010111105145', label: '东肖官屯村' },
              { value: '010111105146', label: '西肖官屯村' },
              { value: '010111105147', label: '于桥村' },
              { value: '010111105148', label: '东街村' },
              { value: '010111105149', label: '西街村' },
              { value: '010111105150', label: '小屯村' },
              { value: '010111105151', label: '小杨庄村' },
              { value: '010111105152', label: '东陈庄村' },
              { value: '010111105153', label: '张法寺村' },
              { value: '010111105154', label: '房庄村' },
              { value: '010111105155', label: '卞官桥村' },
              { value: '010111105156', label: '王世寨村' },
              { value: '010111105157', label: '昝庄村' },
              { value: '010111105158', label: '北韩庄村' },
              { value: '010111105159', label: '东范庄村' }
            ]
          },
          {
            value: '010111106',
            label: '苏留庄镇',
            children: [
              { value: '010111105', label: '肖里官屯村' },
              { value: '010111106160', label: '东韩村' },
              { value: '010111106161', label: '西韩村' },
              { value: '010111106162', label: '梁吴庄村' },
              { value: '010111106163', label: '郭堤口村' },
              { value: '010111106164', label: '苏留庄村' },
              { value: '010111106165', label: '大兴庄村' },
              { value: '010111106166', label: '任庄村' },
              { value: '010111106167', label: '蔡庄村' },
              { value: '010111106168', label: '北双庙村' },
              { value: '010111106169', label: '北郭寨村' },
              { value: '010111106170', label: '霍庄村' },
              { value: '010111106171', label: '小王庄村' },
              { value: '010111106172', label: '封庄村' },
              { value: '010111106173', label: '仁育官庄村' },
              { value: '010111106174', label: '新金庄村' },
              { value: '010111106175', label: '报效屯村' },
              { value: '010111106176', label: '大郭庄村' },
              { value: '010111106177', label: '前杏村' },
              { value: '010111106178', label: '后杏村' },
              { value: '010111106179', label: '毛王庄村' },
              { value: '010111106180', label: '尤王庄村' },
              { value: '010111106181', label: '北官庄村' },
              { value: '010111106182', label: '小石堂村' },
              { value: '010111106183', label: '大石堂村' },
              { value: '010111106184', label: '石庄村' },
              { value: '010111106185', label: '东管庄村' },
              { value: '010111106186', label: '谢庄村' },
              { value: '010111106187', label: '孙贺拐村' },
              { value: '010111106188', label: '大王庄村' },
              { value: '010111106189', label: '北于庄村' },
              { value: '010111106190', label: '北徐庄村' },
              { value: '010111106191', label: '范窑村' }
            ]
          },
          {
            value: '010111107',
            label: '新盛店镇',
            children: [
              { value: '010111106', label: '新盛店村' },
              { value: '010111107192', label: '东菜园村' },
              { value: '010111107193', label: '西菜园村' },
              { value: '010111107194', label: '中菜园村' },
              { value: '010111107195', label: '刘宅庄村' },
              { value: '010111107196', label: '新韩庄村' },
              { value: '010111107197', label: '佘庄村' },
              { value: '010111107198', label: '小李庄村' },
              { value: '010111107199', label: '张堂村' },
              { value: '010111107200', label: '老金庄村' },
              { value: '010111107201', label: '纪家户村' },
              { value: '010111107202', label: '陈屯村' },
              { value: '010111107203', label: '永安庄村' },
              { value: '010111107204', label: '曹庄村' },
              { value: '010111107205', label: '周寨村' },
              { value: '010111107206', label: '三教堂村' },
              { value: '010111107207', label: '前霍村' },
              { value: '010111107208', label: '大李庄村' },
              { value: '010111107209', label: '魏庄村' },
              { value: '010111107210', label: '后霍村' },
              { value: '010111107211', label: '侯庄村' },
              { value: '010111107212', label: '岳集村' },
              { value: '010111107213', label: '东马村' },
              { value: '010111107214', label: '周庄村' },
              { value: '010111107215', label: '左王庄村' },
              { value: '010111107216', label: '张石庄村' },
              { value: '010111107217', label: '北刘庄村' },
              { value: '010111107218', label: '白龙王庙村' },
              { value: '010111107219', label: '前肖村' },
              { value: '010111107220', label: '后肖村' },
              { value: '010111107221', label: '西肖村' },
              { value: '010111107222', label: '拐尔庄村' },
              { value: '010111107223', label: '张大屯村' },
              { value: '010111107224', label: '郑庄村' },
              { value: '010111107225', label: '徐庄村' },
              { value: '010111107226', label: '东屯村' },
              { value: '010111107227', label: '前堂村' },
              { value: '010111107228', label: '任宫庄村' },
              { value: '010111107229', label: '忠信寨村' },
              { value: '010111107230', label: '陈寨村' },
              { value: '010111107231', label: '五安庄村' },
              { value: '010111107232', label: '滕庄村' },
              { value: '010111107233', label: '季庄村' },
              { value: '010111107234', label: '小辛庄村' },
              { value: '010111107235', label: '北马村' },
              { value: '010111107236', label: '毕庄村' },
              { value: '010111107237', label: '孙小屯村' },
              { value: '010111107238', label: '万庄村' },
              { value: '010111107239', label: '东风村' },
              { value: '010111107240', label: '西蔡庄村' },
              { value: '010111107241', label: '雷庄村' },
              { value: '010111107242', label: '孙家窑村' },
              { value: '010111107243', label: '乔庄村' },
              { value: '010111107244', label: '西寨村' },
              { value: '010111107245', label: '东寨村' },
              { value: '010111107246', label: '于堤口村' },
              { value: '010111107247', label: '王卞庄村' },
              { value: '010111107248', label: '盐厂村' },
              { value: '010111107249', label: '张堤口村' },
              { value: '010111107250', label: '殷堤口村' },
              { value: '010111107251', label: '西李村' },
              { value: '010111107252', label: '宋屯村' },
              { value: '010111107253', label: '冉庄村' },
              { value: '010111107254', label: '孟庄村' },
              { value: '010111107255', label: '刘辛庄村' },
              { value: '010111107256', label: '老庄村' },
              { value: '010111107257', label: '前屯村' },
              { value: '010111107258', label: '后堂村' },
              { value: '010111107259', label: '韩庄村' }
            ]
          },
          {
            value: '010111108',
            label: '郑保屯镇',
            children: [
              { value: '010111107', label: '郑保屯村' },
              { value: '010111108260', label: '五屯村' },
              { value: '010111108261', label: '七屯村' },
              { value: '010111108262', label: '八屯村' },
              { value: '010111108263', label: '柳元庄村' },
              { value: '010111108264', label: '李庄村' },
              { value: '010111108265', label: '珠东村' },
              { value: '010111108266', label: '珠中村' },
              { value: '010111108267', label: '珠西村' },
              { value: '010111108268', label: '邢庄村' },
              { value: '010111108269', label: '南口村' },
              { value: '010111108270', label: '北口村' },
              { value: '010111108271', label: '杨东村' },
              { value: '010111108272', label: '杨中村' },
              { value: '010111108273', label: '杨西村' }
            ]
          },
          {
            value: '010111109',
            label: '白马湖镇',
            children: [
              { value: '010111108', label: '白马湖村' },
              { value: '010111109274', label: '九营村' },
              { value: '010111109275', label: '崔楼村' },
              { value: '010111109276', label: '枣林村' },
              { value: '010111109277', label: '陈庄村' },
              { value: '010111109278', label: '崔庄村' },
              { value: '010111109279', label: '韩桥村' },
              { value: '010111109280', label: '白辛村' },
              { value: '010111109281', label: '高庄村' },
              { value: '010111109282', label: '郭庄村' },
              { value: '010111109283', label: '前梅村' },
              { value: '010111109284', label: '后梅村' },
              { value: '010111109285', label: '白庄村' },
              { value: '010111109286', label: '东店村' },
              { value: '010111109287', label: '北店村' },
              { value: '010111109288', label: '南店村' },
              { value: '010111109289', label: '东梁村' },
              { value: '010111109290', label: '西梁村' },
              { value: '010111109291', label: '祁庄村' },
              { value: '010111109292', label: '屯里村' },
              { value: '010111109293', label: '箭口村' },
              { value: '010111109294', label: '杜堤村' },
              { value: '010111109295', label: '马堤村' },
              { value: '010111109296', label: '师堤村' },
              { value: '010111109297', label: '花园村' },
              { value: '010111109298', label: '付庄村' }
            ]
          },
          {
            value: '0101111010',
            label: '雷集镇',
            children: [
              { value: '010111109', label: '常安集村' },
              { value: '0101111010299', label: '陈尤庄村' },
              { value: '0101111010300', label: '大官屯村' },
              { value: '0101111010301', label: '大姜庄村' },
              { value: '0101111010302', label: '大张庄村' },
              { value: '0101111010303', label: '东马庄村' },
              { value: '0101111010304', label: '东双庙村' },
              { value: '0101111010305', label: '东于村' },
              { value: '0101111010306', label: '东郑庄村' },
              { value: '0101111010307', label: '范庄村' },
              { value: '0101111010308', label: '冯堂村' },
              { value: '0101111010309', label: '付庄村' },
              { value: '0101111010310', label: '高庄村' },
              { value: '0101111010311', label: '耿庄村' },
              { value: '0101111010312', label: '沟王庄村' },
              { value: '0101111010313', label: '古城村' },
              { value: '0101111010314', label: '郭蔡庄村' },
              { value: '0101111010315', label: '后魏寨村' },
              { value: '0101111010316', label: '后于村' },
              { value: '0101111010317', label: '黄庄村' },
              { value: '0101111010318', label: '北贾庄村' },
              { value: '0101111010319', label: '津期店村' },
              { value: '0101111010320', label: '康寺村' },
              { value: '0101111010321', label: '郎庄村' },
              { value: '0101111010322', label: '雷集村' },
              { value: '0101111010323', label: '刘宪庄村' },
              { value: '0101111010324', label: '马官屯村' },
              { value: '0101111010325', label: '马辛庄村' },
              { value: '0101111010326', label: '牟庄村' },
              { value: '0101111010327', label: '穆王庄村' },
              { value: '0101111010328', label: '倪庄村' },
              { value: '0101111010329', label: '北庞庄村' },
              { value: '0101111010330', label: '齐营村' },
              { value: '0101111010331', label: '前纪庄村' },
              { value: '0101111010332', label: '前魏寨村' },
              { value: '0101111010333', label: '前于村' },
              { value: '0101111010334', label: '三教堂村' },
              { value: '0101111010335', label: '申张大村' },
              { value: '0101111010336', label: '沈庄村' },
              { value: '0101111010337', label: '宋庄村' },
              { value: '0101111010338', label: '谭庄村' },
              { value: '0101111010339', label: '田刘庄村' },
              { value: '0101111010340', label: '甜水庄村' },
              { value: '0101111010341', label: '西马庄村' },
              { value: '0101111010342', label: '西于村' },
              { value: '0101111010343', label: '小郭庄村' },
              { value: '0101111010344', label: '小石庄村' },
              { value: '0101111010345', label: '小张庄村' },
              { value: '0101111010346', label: '肖庄村' },
              { value: '0101111010347', label: '谢王庄村' },
              { value: '0101111010348', label: '许庄村' },
              { value: '0101111010349', label: '杨庄村' },
              { value: '0101111010350', label: '姚庄村' },
              { value: '0101111010351', label: '张集村' },
              { value: '0101111010352', label: '赵庄村' },
              { value: '0101111010353', label: '朱庄村' },
              { value: '0101111010354', label: '左庄村' }
            ]
          },
          {
            value: '0101111011',
            label: '宋楼镇',
            children: [
              { value: '0101111010', label: '靳庄村' },
              { value: '0101111011355', label: '潘马庄村' },
              { value: '0101111011356', label: '侯王庄村' },
              { value: '0101111011357', label: '刘李庄村' },
              { value: '0101111011358', label: '栗寨村' },
              { value: '0101111011359', label: '赵官屯村' },
              { value: '0101111011360', label: '东张官屯村' },
              { value: '0101111011361', label: '西张官屯村' },
              { value: '0101111011362', label: '黄官屯村' },
              { value: '0101111011363', label: '红寺高李庄村' },
              { value: '0101111011364', label: '苑庄村' },
              { value: '0101111011365', label: '前王沟村' },
              { value: '0101111011366', label: '后王沟村' },
              { value: '0101111011367', label: '王楼村' },
              { value: '0101111011368', label: '时庄村' },
              { value: '0101111011369', label: '许堤村' },
              { value: '0101111011370', label: '任堤村' },
              { value: '0101111011371', label: '侯堤村' },
              { value: '0101111011372', label: '张堤村' },
              { value: '0101111011373', label: '宋楼村' },
              { value: '0101111011374', label: '朱官屯村' },
              { value: '0101111011375', label: '姚庄村' },
              { value: '0101111011376', label: '时庙村' },
              { value: '0101111011377', label: '张庄村' },
              { value: '0101111011378', label: '刘芦村' },
              { value: '0101111011379', label: '赵沟村' },
              { value: '0101111011380', label: '魏店村' },
              { value: '0101111011381', label: '韩庙村' }
            ]
          },
          {
            value: '0101111012',
            label: '香赵庄镇',
            children: [
              { value: '0101111011', label: '香赵庄村' },
              { value: '0101111012382', label: '史王庄村' },
              { value: '0101111012383', label: '官道李村' },
              { value: '0101111012384', label: '西张屯村' },
              { value: '0101111012385', label: '兴马庄村' },
              { value: '0101111012386', label: '南邢庄村' },
              { value: '0101111012387', label: '东张屯一村' },
              { value: '0101111012388', label: '东张屯二村' },
              { value: '0101111012389', label: '东张屯三村' },
              { value: '0101111012390', label: '周哈庄村' },
              { value: '0101111012391', label: '左庄村' },
              { value: '0101111012392', label: '韩庄村' },
              { value: '0101111012393', label: '东姚寨村' },
              { value: '0101111012394', label: '西仓村' },
              { value: '0101111012395', label: '东仓村' },
              { value: '0101111012396', label: '纸房头村' },
              { value: '0101111012397', label: '宗庄村' },
              { value: '0101111012398', label: '于庄村' },
              { value: '0101111012399', label: '肖庄村' },
              { value: '0101111012400', label: '张庵村' },
              { value: '0101111012401', label: '齐庄村' },
              { value: '0101111012402', label: '琉璃庙村' },
              { value: '0101111012403', label: '王曲庄村' },
              { value: '0101111012404', label: '王集村' },
              { value: '0101111012405', label: '五龙堂村' },
              { value: '0101111012406', label: '马桥村' },
              { value: '0101111012407', label: '王寨村' },
              { value: '0101111012408', label: '刘铺村' },
              { value: '0101111012409', label: '王铺村' },
              { value: '0101111012410', label: '莫庄村' },
              { value: '0101111012411', label: '东张庄村' },
              { value: '0101111012412', label: '小孙庄村' },
              { value: '0101111012413', label: '仉庄村' },
              { value: '0101111012414', label: '打帘王村' },
              { value: '0101111012415', label: '前马庄村' },
              { value: '0101111012416', label: '升斗张村' },
              { value: '0101111012417', label: '北邢庄村' }
            ]
          },
          {
            value: '0101111013',
            label: '双庙镇',
            children: [
              { value: '0101111012', label: '范楼村' },
              { value: '0101111013418', label: '营子村' },
              { value: '0101111013419', label: '前柳村' },
              { value: '0101111013420', label: '李堂村' },
              { value: '0101111013421', label: '双庙村' },
              { value: '0101111013422', label: '六屯村' },
              { value: '0101111013423', label: '孙庄村' },
              { value: '0101111013424', label: '清凉寺村' },
              { value: '0101111013425', label: '崔庄村' },
              { value: '0101111013426', label: '王堂村' },
              { value: '0101111013427', label: '郭庄村' },
              { value: '0101111013428', label: '吴庄村' },
              { value: '0101111013429', label: '郝庄村' },
              { value: '0101111013430', label: '东鸭村' },
              { value: '0101111013431', label: '中鸭村' },
              { value: '0101111013432', label: '汉王庙村' },
              { value: '0101111013433', label: '曹庄村' },
              { value: '0101111013434', label: '后柳村' },
              { value: '0101111013435', label: '李文庄村' },
              { value: '0101111013436', label: '西鸭村' }
            ]
          },
          {
            value: '0101111014',
            label: '田庄乡',
            children: [
              { value: '0101111013', label: '张堡村' },
              { value: '0101111014437', label: '露观寺村' },
              { value: '0101111014438', label: '范庄村' },
              { value: '0101111014439', label: '东滕庄村' },
              { value: '0101111014440', label: '西滕庄村' },
              { value: '0101111014441', label: '田庄村' },
              { value: '0101111014442', label: '北张庄村' },
              { value: '0101111014443', label: '大于庄村' },
              { value: '0101111014444', label: '小于庄村' },
              { value: '0101111014445', label: '阎庙村' },
              { value: '0101111014446', label: '曲庄村' },
              { value: '0101111014447', label: '谷庄村' },
              { value: '0101111014448', label: '西谷庄村' },
              { value: '0101111014449', label: '西郑庄村' },
              { value: '0101111014450', label: '裴官屯村' },
              { value: '0101111014451', label: '大张庄东村' },
              { value: '0101111014452', label: '大张庄西村' },
              { value: '0101111014453', label: '八方塔村' },
              { value: '0101111014454', label: '周邢村' },
              { value: '0101111014455', label: '姜庄村' },
              { value: '0101111014456', label: '陈庄村' },
              { value: '0101111014457', label: '西孔庄村' },
              { value: '0101111014458', label: '孙举庄村' },
              { value: '0101111014459', label: '小韩庄村' }
            ]
          },
          {
            value: '0101111015',
            label: '渡口驿乡',
            children: [
              { value: '0101111014', label: '东渡口驿村' },
              { value: '0101111015460', label: '西渡口驿村' },
              { value: '0101111015461', label: '管新庄村' },
              { value: '0101111015462', label: '二屯村' },
              { value: '0101111015463', label: '许胡同村' },
              { value: '0101111015464', label: '闫庄村' },
              { value: '0101111015465', label: '太平庄村' },
              { value: '0101111015466', label: '殷小庄村' },
              { value: '0101111015467', label: '夏庄村' },
              { value: '0101111015468', label: '三屯村' },
              { value: '0101111015469', label: '曲堤村' },
              { value: '0101111015470', label: '季王庄村' },
              { value: '0101111015471', label: '四屯村' },
              { value: '0101111015472', label: '李庄村' },
              { value: '0101111015473', label: '西刘堤村' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '011',
    label: '庆云县',
    children: [
      {
        value: '01111211',
        label: '庆云县',
        children: [
          {
            value: '011112112',
            label: '渤海路街道',
            children: [
              { value: '011112111', label: '中心社区' },
              { value: '0111121121', label: '开元社区' },
              { value: '0111121122', label: '西湖社区' },
              { value: '0111121123', label: '新兴社区' },
              { value: '0111121124', label: '学苑社区' },
              { value: '0111121125', label: '滨河社区' },
              { value: '0111121126', label: '新华社区' },
              { value: '0111121127', label: '北海社区' },
              { value: '0111121128', label: '小解村' },
              { value: '0111121129', label: '东刘村' },
              { value: '01111211210', label: '李云曲村' },
              { value: '01111211211', label: '养马王村' },
              { value: '01111211212', label: '北侯村' },
              { value: '01111211213', label: '郭楼村' },
              { value: '01111211214', label: '姜杨李村' },
              { value: '01111211215', label: '齐家村' },
              { value: '01111211216', label: '任店村' },
              { value: '01111211217', label: '魏洼村' },
              { value: '01111211218', label: '西刘村' },
              { value: '01111211219', label: '席刘村' },
              { value: '01111211220', label: '杨习武村' },
              { value: '01111211221', label: '于店村' },
              { value: '01111211222', label: '毕凌霄村' },
              { value: '01111211223', label: '东后马村' },
              { value: '01111211224', label: '东石村' },
              { value: '01111211225', label: '东歪村' },
              { value: '01111211226', label: '东杨村' },
              { value: '01111211227', label: '窦家村' },
              { value: '01111211228', label: '韩家村' },
              { value: '01111211229', label: '和尚村' },
              { value: '01111211230', label: '后乔村' },
              { value: '01111211231', label: '后张村' },
              { value: '01111211232', label: '刘南纯村' },
              { value: '01111211233', label: '撒家村' },
              { value: '01111211234', label: '王南津村' },
              { value: '01111211235', label: '西后马村' },
              { value: '01111211236', label: '西石村' },
              { value: '01111211237', label: '西歪村' },
              { value: '01111211238', label: '西杨村' },
              { value: '01111211239', label: '香坊村' },
              { value: '01111211240', label: '小李村' },
              { value: '01111211241', label: '小田村' },
              { value: '01111211242', label: '小徐村' },
              { value: '01111211243', label: '小郑村' },
              { value: '01111211244', label: '袁家村' },
              { value: '01111211245', label: '甄家村' },
              { value: '01111211246', label: '中马村' },
              { value: '01111211247', label: '中石村' }
            ]
          },
          {
            value: '011112113',
            label: '庆云镇',
            children: [
              { value: '011112112', label: '汾水王村' },
              { value: '01111211348', label: '前官村' },
              { value: '01111211349', label: '杨庄子村' },
              { value: '01111211350', label: '张桃符村' },
              { value: '01111211351', label: '蔡王村' },
              { value: '01111211352', label: '陈瑞芝村' },
              { value: '01111211353', label: '慈家村' },
              { value: '01111211354', label: '崔家村' },
              { value: '01111211355', label: '李博士村' },
              { value: '01111211356', label: '李泮池村' },
              { value: '01111211357', label: '前马村' },
              { value: '01111211358', label: '石佛寺村' },
              { value: '01111211359', label: '陶家村' },
              { value: '01111211360', label: '王知县村' },
              { value: '01111211361', label: '韦家村' },
              { value: '01111211362', label: '周尹村' },
              { value: '01111211363', label: '卞家村' },
              { value: '01111211364', label: '陈杨庄' },
              { value: '01111211365', label: '程家村' },
              { value: '01111211366', label: '程太监村' },
              { value: '01111211367', label: '大陈村' },
              { value: '01111211368', label: '东贾村' },
              { value: '01111211369', label: '东窑村' },
              { value: '01111211370', label: '东周村' },
              { value: '01111211371', label: '韩家村' },
              { value: '01111211372', label: '后于村' },
              { value: '01111211373', label: '贾代村' },
              { value: '01111211374', label: '寇家村' },
              { value: '01111211375', label: '利新村' },
              { value: '01111211376', label: '刘谟村' },
              { value: '01111211377', label: '南周村' },
              { value: '01111211378', label: '前于村' },
              { value: '01111211379', label: '润德村' },
              { value: '01111211380', label: '三里庄' },
              { value: '01111211381', label: '松树高村' },
              { value: '01111211382', label: '屠户崔村' },
              { value: '01111211383', label: '王文郭村' },
              { value: '01111211384', label: '西南马村' },
              { value: '01111211385', label: '西窑村' },
              { value: '01111211386', label: '小刘村' },
              { value: '01111211387', label: '张马郎村' }
            ]
          },
          {
            value: '011112114',
            label: '常家镇',
            children: [
              { value: '011112113', label: '大胡村' },
              { value: '01111211488', label: '李营魏村' },
              { value: '01111211489', label: '吕家村' },
              { value: '01111211490', label: '前乔村' },
              { value: '01111211491', label: '小李村' },
              { value: '01111211492', label: '小杨村' },
              { value: '01111211493', label: '中王村' },
              { value: '01111211494', label: '小刘村' },
              { value: '01111211495', label: '北板营村' },
              { value: '01111211496', label: '常家村' },
              { value: '01111211497', label: '大道王村' },
              { value: '01111211498', label: '大高村' },
              { value: '01111211499', label: '大唐村' },
              { value: '011112114100', label: '大杨村' },
              { value: '011112114101', label: '刁家村' },
              { value: '011112114102', label: '孟家村' },
              { value: '011112114103', label: '前王村' },
              { value: '011112114104', label: '西柳村' },
              { value: '011112114105', label: '北齐村' },
              { value: '011112114106', label: '波张村' },
              { value: '011112114107', label: '簸箕徐村' },
              { value: '011112114108', label: '大刘村' },
              { value: '011112114109', label: '东板营村' },
              { value: '011112114110', label: '东柳村' },
              { value: '011112114111', label: '东柳行村' },
              { value: '011112114112', label: '东田村' },
              { value: '011112114113', label: '东张村' },
              { value: '011112114114', label: '二十里村' },
              { value: '011112114115', label: '郭家村' },
              { value: '011112114116', label: '河涯赵村' },
              { value: '011112114117', label: '后柳村' },
              { value: '011112114118', label: '后田村' },
              { value: '011112114119', label: '后王村' },
              { value: '011112114120', label: '胡店村' },
              { value: '011112114121', label: '黄花马村' },
              { value: '011112114122', label: '霍家村' },
              { value: '011112114123', label: '纪铺杨村' },
              { value: '011112114124', label: '街西徐村' },
              { value: '011112114125', label: '梁家村' },
              { value: '011112114126', label: '牟家村' },
              { value: '011112114127', label: '南板营村' },
              { value: '011112114128', label: '南齐村' },
              { value: '011112114129', label: '前柳村' },
              { value: '011112114130', label: '前柳行村' },
              { value: '011112114131', label: '任家村' },
              { value: '011112114132', label: '史家坊村' },
              { value: '011112114133', label: '洼张村' },
              { value: '011112114134', label: '西柳行村' },
              { value: '011112114135', label: '西田村' },
              { value: '011112114136', label: '西张村' },
              { value: '011112114137', label: '肖家寺村' },
              { value: '011112114138', label: '小毕村' },
              { value: '011112114139', label: '小胡村' },
              { value: '011112114140', label: '小唐村' },
              { value: '011112114141', label: '张巧村' },
              { value: '011112114142', label: '郑家村' }
            ]
          },
          {
            value: '011112115',
            label: '尚堂镇',
            children: [
              { value: '011112114', label: '东翟村' },
              { value: '011112115143', label: '贾家村' },
              { value: '011112115144', label: '尚俭村' },
              { value: '011112115145', label: '尚堂村' },
              { value: '011112115146', label: '西堰村' },
              { value: '011112115147', label: '肖家村' },
              { value: '011112115148', label: '南侯村' },
              { value: '011112115149', label: '前王村' },
              { value: '011112115150', label: '西吴村' },
              { value: '011112115151', label: '北侯村' },
              { value: '011112115152', label: '菜张村' },
              { value: '011112115153', label: '大郝村' },
              { value: '011112115154', label: '冯家村' },
              { value: '011112115155', label: '和睦程村' },
              { value: '011112115156', label: '颊河徐村' },
              { value: '011112115157', label: '李梓村' },
              { value: '011112115158', label: '南王村' },
              { value: '011112115159', label: '西仓村' },
              { value: '011112115160', label: '西宗村' },
              { value: '011112115161', label: '小勾村' },
              { value: '011112115162', label: '朱家村' },
              { value: '011112115163', label: '北王村' },
              { value: '011112115164', label: '慈王毕村' },
              { value: '011112115165', label: '大勾村' },
              { value: '011112115166', label: '大胡楼村' },
              { value: '011112115167', label: '大靳村' },
              { value: '011112115168', label: '大王村' },
              { value: '011112115169', label: '东白村' },
              { value: '011112115170', label: '东仓村' },
              { value: '011112115171', label: '东郎坞村' },
              { value: '011112115172', label: '东刘村' },
              { value: '011112115173', label: '东撒村' },
              { value: '011112115174', label: '东吴村' },
              { value: '011112115175', label: '东堰村' },
              { value: '011112115176', label: '东宗村' },
              { value: '011112115177', label: '后李村' },
              { value: '011112115178', label: '后翟村' },
              { value: '011112115179', label: '纪王桥村' },
              { value: '011112115180', label: '颊河冯村' },
              { value: '011112115181', label: '李赤城村' },
              { value: '011112115182', label: '李含贲村' },
              { value: '011112115183', label: '李家店村' },
              { value: '011112115184', label: '梁家村' },
              { value: '011112115185', label: '马家村' },
              { value: '011112115186', label: '马徐村' },
              { value: '011112115187', label: '前李村' },
              { value: '011112115188', label: '前翟村' },
              { value: '011112115189', label: '尚智村' },
              { value: '011112115190', label: '王高村' },
              { value: '011112115191', label: '西白村' },
              { value: '011112115192', label: '西郎坞村' },
              { value: '011112115193', label: '西撒村' },
              { value: '011112115194', label: '兴隆店村' },
              { value: '011112115195', label: '姚千村' },
              { value: '011112115196', label: '枣王村' },
              { value: '011112115197', label: '灶户李村' },
              { value: '011112115198', label: '张牌村' },
              { value: '011112115199', label: '郑家村' },
              { value: '011112115200', label: '中仓村' }
            ]
          },
          {
            value: '011112116',
            label: '崔口镇',
            children: [
              { value: '011112115', label: '齐西北村' },
              { value: '011112116201', label: '齐西南村' },
              { value: '011112116202', label: '周辛村' },
              { value: '011112116203', label: '崔东南村' },
              { value: '011112116204', label: '崔西南村' },
              { value: '011112116205', label: '二三屯村' },
              { value: '011112116206', label: '后程赵村' },
              { value: '011112116207', label: '黄屯村' },
              { value: '011112116208', label: '前程赵村' },
              { value: '011112116209', label: '杨程赵村' },
              { value: '011112116210', label: '张庄村' },
              { value: '011112116211', label: '陈庄村' },
              { value: '011112116212', label: '崔东北村' },
              { value: '011112116213', label: '崔西北村' },
              { value: '011112116214', label: '东齐村' },
              { value: '011112116215', label: '刘庄村' },
              { value: '011112116216', label: '齐东北村' },
              { value: '011112116217', label: '齐东南村' },
              { value: '011112116218', label: '四屯村' },
              { value: '011112116219', label: '西齐村' },
              { value: '011112116220', label: '一屯村' }
            ]
          },
          {
            value: '011112117',
            label: '东辛店镇',
            children: [
              { value: '011112116', label: '东兴新村' },
              { value: '011112117221', label: '家和新村' },
              { value: '011112117222', label: '南杜村' },
              { value: '011112117223', label: '北孔村' },
              { value: '011112117224', label: '大范村' },
              { value: '011112117225', label: '大李村' },
              { value: '011112117226', label: '东阁村' },
              { value: '011112117227', label: '后邓村' },
              { value: '011112117228', label: '姜家村' },
              { value: '011112117229', label: '鲁家村' },
              { value: '011112117230', label: '南赵村' },
              { value: '011112117231', label: '万粮张村' },
              { value: '011112117232', label: '王官村' },
              { value: '011112117233', label: '王铁匠村' },
              { value: '011112117234', label: '小孙村' },
              { value: '011112117235', label: '张家村' },
              { value: '011112117236', label: '志门刘村' },
              { value: '011112117237', label: '大丁村' },
              { value: '011112117238', label: '坊子村' },
              { value: '011112117239', label: '汾水马村' },
              { value: '011112117240', label: '汾水杨村' },
              { value: '011112117241', label: '付兴赵新村' },
              { value: '011112117242', label: '顾家村' },
              { value: '011112117243', label: '李壮宇村' },
              { value: '011112117244', label: '南孔村' },
              { value: '011112117245', label: '前邓村' },
              { value: '011112117246', label: '三和新村' },
              { value: '011112117247', label: '石高村' },
              { value: '011112117248', label: '双莲新村' },
              { value: '011112117249', label: '松树马村' },
              { value: '011112117250', label: '万顷刘村' },
              { value: '011112117251', label: '西阁村' },
              { value: '011112117252', label: '西韩村' },
              { value: '011112117253', label: '小丁村' },
              { value: '011112117254', label: '小范村' },
              { value: '011112117255', label: '小马村' },
              { value: '011112117256', label: '小王村' },
              { value: '011112117257', label: '小张村' },
              { value: '011112117258', label: '杨家村' },
              { value: '011112117259', label: '姚家村' },
              { value: '011112117260', label: '张货郎村' },
              { value: '011112117261', label: '张立村' }
            ]
          },
          {
            value: '011112118',
            label: '中丁乡',
            children: [
              { value: '011112117', label: '堤南刘村' },
              { value: '011112118262', label: '东崔村' },
              { value: '011112118263', label: '马周村' },
              { value: '011112118264', label: '杨和寺村' },
              { value: '011112118265', label: '丁尹村' },
              { value: '011112118266', label: '东梁村' },
              { value: '011112118267', label: '东苗村' },
              { value: '011112118268', label: '何家村' },
              { value: '011112118269', label: '后大店村' },
              { value: '011112118270', label: '后丁村' },
              { value: '011112118271', label: '后段村' },
              { value: '011112118272', label: '刘秦辛村' },
              { value: '011112118273', label: '茂杨村' },
              { value: '011112118274', label: '前大店村' },
              { value: '011112118275', label: '前段村' },
              { value: '011112118276', label: '仁和刘村' },
              { value: '011112118277', label: '田家村' },
              { value: '011112118278', label: '王醉酒村' },
              { value: '011112118279', label: '文侯齐村' },
              { value: '011112118280', label: '西苗村' },
              { value: '011112118281', label: '小李村' },
              { value: '011112118282', label: '辛刘村' },
              { value: '011112118283', label: '徐家村' },
              { value: '011112118284', label: '张家村' },
              { value: '011112118285', label: '甄家村' },
              { value: '011112118286', label: '郑庙村' },
              { value: '011112118287', label: '中胡楼村' },
              { value: '011112118288', label: '中西崔村' }
            ]
          },
          {
            value: '011112119',
            label: '徐园子乡',
            children: [
              { value: '011112118', label: '后道口村' },
              { value: '011112119289', label: '张培元村' },
              { value: '011112119290', label: '巴古村' },
              { value: '011112119291', label: '杨道口村' },
              { value: '011112119292', label: '柴家村' },
              { value: '011112119293', label: '东安务村' },
              { value: '011112119294', label: '东赵村' },
              { value: '011112119295', label: '后赵村' },
              { value: '011112119296', label: '黄道口村' },
              { value: '011112119297', label: '刘贵村' },
              { value: '011112119298', label: '马古台村' },
              { value: '011112119299', label: '西安务村' },
              { value: '011112119300', label: '阎枣行村' },
              { value: '011112119301', label: '大袁村' },
              { value: '011112119302', label: '东袁村' },
              { value: '011112119303', label: '河刘新村' },
              { value: '011112119304', label: '后安务村' },
              { value: '011112119305', label: '利华新村' },
              { value: '011112119306', label: '龙王庙村' },
              { value: '011112119307', label: '苏家村' },
              { value: '011112119308', label: '孙蒋新村' },
              { value: '011112119309', label: '祥园新村' },
              { value: '011112119310', label: '邢家村' },
              { value: '011112119311', label: '周家村' }
            ]
          },
          {
            value: '0111121110',
            label: '严务乡',
            children: [
              { value: '011112119', label: '柴林庄村' },
              { value: '0111121110312', label: '大淀村' },
              { value: '0111121110313', label: '刁黄邱村' },
              { value: '0111121110314', label: '黄邱新村' },
              { value: '0111121110315', label: '冯桥村' },
              { value: '0111121110316', label: '邓黄邱村' },
              { value: '0111121110317', label: '东左耳村' },
              { value: '0111121110318', label: '关家村' },
              { value: '0111121110319', label: '后庄科村' },
              { value: '0111121110320', label: '王皇村' },
              { value: '0111121110321', label: '小武村' },
              { value: '0111121110322', label: '严务村' },
              { value: '0111121110323', label: '单屯村' },
              { value: '0111121110324', label: '姜屯村' },
              { value: '0111121110325', label: '蒋黄邱村' },
              { value: '0111121110326', label: '坡徐村' },
              { value: '0111121110327', label: '前庄科村' },
              { value: '0111121110328', label: '守义村' },
              { value: '0111121110329', label: '小淀村' },
              { value: '0111121110330', label: '张辛村' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '012',
    label: '经济技术开发区',
    children: [
      {
        value: '01211312',
        label: '德州经济技术开发区',
        children: [
          {
            value: '012113122',
            label: '宋官屯街道',
            children: [
              { value: '012113121', label: '十二里庄社区' },
              { value: '0121131221', label: '新城社区' },
              { value: '0121131222', label: '宋官屯社区' },
              { value: '0121131223', label: '曹村社区' },
              { value: '0121131224', label: '付庄社区' },
              { value: '0121131225', label: '张官屯社区' },
              { value: '0121131226', label: '刘集社区' },
              { value: '0121131227', label: '王庄社区' }
            ]
          },
          {
            value: '012113123',
            label: '长河街道',
            children: [
              { value: '012113122', label: '长河社区' },
              { value: '0121131238', label: '簸箕刘社区' },
              { value: '0121131239', label: '太阳城社区' },
              { value: '01211312310', label: '明德社区' }
            ]
          },
          {
            value: '012113124',
            label: '袁桥镇',
            children: [
              { value: '012113123', label: '袁桥社区' },
              { value: '01211312411', label: '牟庄社区' },
              { value: '01211312412', label: '香坊赵社区' }
            ]
          }
        ]
      }
    ]
  },
  {
    value: '013',
    label: '运河开发区',
    children: [
      {
        value: '01311413',
        label: '运河经济开发区',
        children: [
          {
            value: '013114132',
            label: '赵虎镇',
            children: [
              { value: '013114131', label: '赵虎村' },
              { value: '0131141321', label: '岔河寺村_冷家寺' },
              { value: '0131141322', label: '闫王张村' },
              { value: '0131141323', label: '东尹村' },
              { value: '0131141324', label: '姜庄村' },
              { value: '0131141325', label: '吕庄村' },
              { value: '0131141326', label: '李芳村' },
              { value: '0131141327', label: '李尧村' },
              { value: '0131141328', label: '冷庄村' },
              { value: '0131141329', label: '韩赵新村—韩马' },
              { value: '01311413210', label: '辛庄村' },
              { value: '01311413211', label: '曹韩村' },
              { value: '01311413212', label: '张七村' },
              { value: '01311413213', label: '贾庄村' },
              {
                value: '01311413214',
                label: '刘汉王庄村—大刘汗'
              },
              { value: '01311413215', label: '大柳树董村' }
            ]
          },
          {
            value: '013114133',
            label: '抬头寺镇',
            children: [
              { value: '013114132', label: '大韩村' },
              { value: '01311413316', label: '董庄村' },
              { value: '01311413317', label: '罗李村' },
              { value: '01311413318', label: '王舍村' },
              { value: '01311413319', label: '张庄村' },
              { value: '01311413320', label: '贺庄村' },
              { value: '01311413321', label: '共赢村' },
              { value: '01311413322', label: '抬头寺村' },
              { value: '01311413323', label: '曹庄村' },
              { value: '01311413324', label: '渠庄村' },
              { value: '01311413325', label: '水罗卜李村' },
              { value: '01311413326', label: '双庙陈村' },
              { value: '01311413327', label: '马虎李村' },
              { value: '01311413328', label: '满文白村' },
              { value: '01311413329', label: '幸福新村' },
              { value: '01311413330', label: '杨胡店村' }
            ]
          }
        ]
      }
    ]
  }
]
